/**
 * File generated by js-routes 2.2.7
 * Based on Rails 8.0.5 routes of Portal::Application
 */
// eslint-disable-next-line
const __jsr = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const ModuleReferences = {
        CJS: {
            define(routes) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                module.exports = routes;
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                define([], function () {
                    return routes;
                });
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using const __jsr = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const UriEncoderSegmentRegex = /[^a-zA-Z0-9\-._~!$&'()*+,;=:@]/g;
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (this.is_nullable(value)) {
                return "";
            }
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (this.is_nullable(prop) && prefix) {
                        prop = "";
                    }
                    if (this.is_not_nullable(prop)) {
                        if (prefix) {
                            key = prefix + "[" + key + "]";
                        }
                        result.push(this.default_serializer(prop, key));
                    }
                }
            }
            else {
                if (this.is_not_nullable(value)) {
                    result.push(encodeURIComponent(prefix) + "=" + encodeURIComponent("" + value));
                }
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (keyword_parameters.trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            result += keyword_parameters.anchor
                ? "#" + keyword_parameters.anchor
                : "";
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            return segment.replace(UriEncoderSegmentRegex, (str) => encodeURIComponent(str));
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return "(" + this.build_path_spec(route[1]) + ")";
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return false
                ? result
                : encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
        }
    }
    const Utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return Utils.route(parts_table, route_spec, absolute);
        },
    };
    const result = {
        ...__jsr,
        configure: (config) => {
            return Utils.configure(config);
        },
        config: () => {
            return Utils.config();
        },
        serialize: (object) => {
            return Utils.serialize(object);
        },
        ...{},
    };
    Utils.define_module("ESM", result);
    return result;
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * /account/quotes/:id/accept(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accept_account_quote_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"quotes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/subscriptions/accept(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accept_account_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /invitation/accept(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accept_user_invitation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"invitation"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /account/agents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_agent_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/agents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_agents_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"agents"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/ai_misuse/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_ai_misuse_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"ai_misuse"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/ai_misuse(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_ai_misuse_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"ai_misuse"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/antiviruses/antivirus_exclusion_widget(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_antivirus_exclusion_widget_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"antiviruses"],[2,[7,"/"],[2,[6,"antivirus_exclusion_widget"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/antivirus_exclusions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_antivirus_exclusions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"antivirus_exclusions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/antivirus_exclusions/settings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_antivirus_exclusions_setting_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"antivirus_exclusions"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/antivirus_exclusions/settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_antivirus_exclusions_settings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"antivirus_exclusions"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/antivirus_policy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_antivirus_policy_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"antivirus_policy"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/antiviruses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_antiviruses_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"antiviruses"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/api_credentials/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_api_credential_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"api_credentials"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/api_credentials(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_api_credentials_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"api_credentials"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/assessments/samples/:type(.:format)
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_assessments_sample_path = /*#__PURE__*/ __jsr.r({"type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"assessments"],[2,[7,"/"],[2,[6,"samples"],[2,[7,"/"],[2,[3,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/contacts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_contacts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/contracts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_contract_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/contracts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_contracts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"contracts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/unwanted_access/country_login_events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_country_login_event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"unwanted_access"],[2,[7,"/"],[2,[6,"country_login_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/data_archives(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_data_archives_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"data_archives"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/demo_sandbox(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_demo_sandbox_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"demo_sandbox"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/antiviruses/detections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_detections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"antiviruses"],[2,[7,"/"],[2,[6,"detections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/features/edr_tamper_protections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_edr_tamper_protection_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"features"],[2,[7,"/"],[2,[6,"edr_tamper_protections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/features/edr_tamper_protections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_edr_tamper_protections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"features"],[2,[7,"/"],[2,[6,"edr_tamper_protections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/email_security/dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_email_security_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"email_security"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/escalations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_escalation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"escalations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/escalations/:escalation_id/escalation_entities(.:format)
 * @param {any} escalation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_escalation_escalation_entities_path = /*#__PURE__*/ __jsr.r({"escalation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"escalations"],[2,[7,"/"],[2,[3,"escalation_id"],[2,[7,"/"],[2,[6,"escalation_entities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/escalations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_escalations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"escalations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/espm/app_control/approvals/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_espm_app_control_approval_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"app_control"],[2,[7,"/"],[2,[6,"approvals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/espm/app_control/approvals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_espm_app_control_approvals_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"app_control"],[2,[7,"/"],[2,[6,"approvals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/espm/app_control/binaries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_espm_app_control_binary_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"app_control"],[2,[7,"/"],[2,[6,"binaries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/espm/app_control_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_espm_app_control_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"app_control_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/espm/app_control/microsoft_apps/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_espm_app_control_microsoft_app_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"app_control"],[2,[7,"/"],[2,[6,"microsoft_apps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/espm/app_control/microsoft_apps(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_espm_app_control_microsoft_apps_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"app_control"],[2,[7,"/"],[2,[6,"microsoft_apps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/espm/app_control/rmm_tools/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_espm_app_control_rmm_tool_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"app_control"],[2,[7,"/"],[2,[6,"rmm_tools"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/espm/app_control/rmm_tools(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_espm_app_control_rmm_tools_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"app_control"],[2,[7,"/"],[2,[6,"rmm_tools"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/espm/app_control/settings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_espm_app_control_setting_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"app_control"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/espm/app_control/settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_espm_app_control_settings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"app_control"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/espm/app_control/signing_certs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_espm_app_control_signing_cert_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"app_control"],[2,[7,"/"],[2,[6,"signing_certs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/espm/app_control/signing_certs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_espm_app_control_signing_certs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"app_control"],[2,[7,"/"],[2,[6,"signing_certs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/espm/app_control/unsigned_executables(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_espm_app_control_unsigned_executables_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"app_control"],[2,[7,"/"],[2,[6,"unsigned_executables"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/espm/app_control/unsigned_files(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_espm_app_control_unsigned_files_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"app_control"],[2,[7,"/"],[2,[6,"unsigned_files"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/exclusions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_exclusion_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"exclusions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/exclusions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_exclusions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"exclusions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/external_recon(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_external_recon_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"external_recon"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/features/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_feature_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"features"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/features(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_features_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"features"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/footholds(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_footholds_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"footholds"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/host_isolation/allowlist_entries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_host_isolation_allowlist_entries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"host_isolation"],[2,[7,"/"],[2,[6,"allowlist_entries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/host_isolation/allowlist_entries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_host_isolation_allowlist_entry_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"host_isolation"],[2,[7,"/"],[2,[6,"allowlist_entries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/infection_reports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_infection_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/infection_reports/:infection_report_id/comments/:id(.:format)
 * @param {any} infection_report_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_infection_report_comment_path = /*#__PURE__*/ __jsr.r({"infection_report_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/infection_reports/:infection_report_id/comments(.:format)
 * @param {any} infection_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_infection_report_comments_path = /*#__PURE__*/ __jsr.r({"infection_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/infection_reports/:infection_report_id/sat_assignments/:id(.:format)
 * @param {any} infection_report_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_infection_report_sat_assignment_path = /*#__PURE__*/ __jsr.r({"infection_report_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"sat_assignments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/infection_reports/:infection_report_id/soc_callback_requests(.:format)
 * @param {any} infection_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_infection_report_soc_callback_requests_path = /*#__PURE__*/ __jsr.r({"infection_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"soc_callback_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/infection_reports/:infection_report_id/soc_email_conversations(.:format)
 * @param {any} infection_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_infection_report_soc_email_conversations_path = /*#__PURE__*/ __jsr.r({"infection_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"soc_email_conversations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/infection_reports/:infection_report_id/soc_support(.:format)
 * @param {any} infection_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_infection_report_soc_support_index_path = /*#__PURE__*/ __jsr.r({"infection_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"soc_support"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/infection_reports/:infection_report_id/timeline_event_drawer(.:format)
 * @param {any} infection_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_infection_report_timeline_event_drawer_index_path = /*#__PURE__*/ __jsr.r({"infection_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"timeline_event_drawer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/infection_reports/:infection_report_id/timeline_events(.:format)
 * @param {any} infection_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_infection_report_timeline_events_path = /*#__PURE__*/ __jsr.r({"infection_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"timeline_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/infection_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_infection_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"infection_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/infections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_infections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"infections"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/installer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_installer_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"installer"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/:integration_id/billing_sync_results(.:format)
 * @param {any} integration_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integration_billing_sync_results_path = /*#__PURE__*/ __jsr.r({"integration_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"integration_id"],[2,[7,"/"],[2,[6,"billing_sync_results"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/:integration_id/psa_tickets(.:format)
 * @param {any} integration_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integration_psa_tickets_path = /*#__PURE__*/ __jsr.r({"integration_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"integration_id"],[2,[7,"/"],[2,[6,"psa_tickets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/autotask/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_autotask_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"autotask"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/autotask(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_autotask_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"autotask"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/bms/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_bms_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"bms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/bms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_bms_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"bms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/connect_wise/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_connect_wise_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"connect_wise"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/connect_wise(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_connect_wise_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"connect_wise"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/microsoft(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_cpv_mapping_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"microsoft"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/duo/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_duo_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"duo"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/duo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_duo_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"duo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/email_security(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_email_security_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"email_security"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/email_security_tenants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_email_security_tenants_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"email_security_tenants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/gcc_high(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_gcc_high_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"gcc_high"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/google(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_google_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"google"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/google/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_google_tenant_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"google"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/google(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_google_tenants_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"google"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/google_tenants/oauth2callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_google_tenants_oauth2callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"google_tenants"],[2,[7,"/"],[2,[6,"oauth2callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/halo_psa/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_halo_psa_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"halo_psa"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/halo_psa(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_halo_psa_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"halo_psa"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/identity_providers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_identity_providers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"identity_providers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/identity_providers/organizations/:organization_id/billable_products(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_identity_providers_organization_billable_products_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"identity_providers"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"billable_products"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/m365/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_m365_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"m365"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/m365/:m365_id/confirm_deletion(.:format)
 * @param {any} m365_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_m365_confirm_deletion_path = /*#__PURE__*/ __jsr.r({"m365_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"m365"],[2,[7,"/"],[2,[3,"m365_id"],[2,[7,"/"],[2,[6,"confirm_deletion"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/microsoft_defenders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_microsoft_defender_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"microsoft_defenders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/microsoft_defender_tenants/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_microsoft_defender_tenant_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"microsoft_defender_tenants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/microsoft_defender_tenants/:microsoft_defender_tenant_id/microsoft_defender_tenant_aliases/:id(.:format)
 * @param {any} microsoft_defender_tenant_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_microsoft_defender_tenant_alias_path = /*#__PURE__*/ __jsr.r({"microsoft_defender_tenant_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"microsoft_defender_tenants"],[2,[7,"/"],[2,[3,"microsoft_defender_tenant_id"],[2,[7,"/"],[2,[6,"microsoft_defender_tenant_aliases"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/microsoft_defender_tenants/:microsoft_defender_tenant_id/microsoft_defender_tenant_alias_suggestions(.:format)
 * @param {any} microsoft_defender_tenant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_microsoft_defender_tenant_alias_suggestions_path = /*#__PURE__*/ __jsr.r({"microsoft_defender_tenant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"microsoft_defender_tenants"],[2,[7,"/"],[2,[3,"microsoft_defender_tenant_id"],[2,[7,"/"],[2,[6,"microsoft_defender_tenant_alias_suggestions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/microsoft_defender_tenants/:microsoft_defender_tenant_id/microsoft_defender_tenant_aliases(.:format)
 * @param {any} microsoft_defender_tenant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_microsoft_defender_tenant_aliases_path = /*#__PURE__*/ __jsr.r({"microsoft_defender_tenant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"microsoft_defender_tenants"],[2,[7,"/"],[2,[3,"microsoft_defender_tenant_id"],[2,[7,"/"],[2,[6,"microsoft_defender_tenant_aliases"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/microsoft_defender_tenants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_microsoft_defender_tenants_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"microsoft_defender_tenants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/microsoft_tenants/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_microsoft_tenant_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"microsoft_tenants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/microsoft_tenants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_microsoft_tenants_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"microsoft_tenants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/ninja_rmm/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_ninja_rmm_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"ninja_rmm"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/ninja_rmm(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_ninja_rmm_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"ninja_rmm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/service_now/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_service_now_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"service_now"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/service_now(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_service_now_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"service_now"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/syncro/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_syncro_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"syncro"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/syncro(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_syncro_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"syncro"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/webhooks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_webhook_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/endpoints/:endpoint_eid/webhooks/:webhook_id/delivery_attempts(.:format)
 * @param {any} endpoint_eid
 * @param {any} webhook_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_webhook_delivery_attempts_path = /*#__PURE__*/ __jsr.r({"endpoint_eid":{"r":true},"webhook_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"endpoints"],[2,[7,"/"],[2,[3,"endpoint_eid"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[3,"webhook_id"],[2,[7,"/"],[2,[6,"delivery_attempts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/endpoints/:endpoint_eid/webhooks/:webhook_id/messages/:id(.:format)
 * @param {any} endpoint_eid
 * @param {any} webhook_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_webhook_message_path = /*#__PURE__*/ __jsr.r({"endpoint_eid":{"r":true},"webhook_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"endpoints"],[2,[7,"/"],[2,[3,"endpoint_eid"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[3,"webhook_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/endpoints/:endpoint_eid/webhooks/:webhook_id/resend(.:format)
 * @param {any} endpoint_eid
 * @param {any} webhook_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_webhook_resend_path = /*#__PURE__*/ __jsr.r({"endpoint_eid":{"r":true},"webhook_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"endpoints"],[2,[7,"/"],[2,[3,"endpoint_eid"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[3,"webhook_id"],[2,[7,"/"],[2,[6,"resend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/webhooks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_webhooks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"webhooks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/invoices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_invoice_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/invoices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_invoices_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/ispm/organization_entitlements/bulk(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_ispm_bulk_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"organization_entitlements"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/ispm/security_control_enforcements/bulk(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_ispm_bulk_security_control_enforcement_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"security_control_enforcements"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/ispm/conditional_access_policies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_ispm_conditional_access_policies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"conditional_access_policies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/ispm/conditional_access_policies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_ispm_conditional_access_policy_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"conditional_access_policies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/ispm/organization_entitlements/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_ispm_organization_entitlement_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"organization_entitlements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/ispm/organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_ispm_organizations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/ispm/security_controls/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_ispm_security_control_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"security_controls"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/ispm/security_controls(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_ispm_security_controls_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"security_controls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/ispm/tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_ispm_tasks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/ispm/widgets/completed_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_ispm_widgets_completed_tasks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"completed_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/ispm/widgets/conditional_access_policies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_ispm_widgets_conditional_access_policies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"conditional_access_policies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/ispm/widgets/enabled_organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_ispm_widgets_enabled_organizations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"enabled_organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/ispm/widgets/organizations_at_risk(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_ispm_widgets_organizations_at_risk_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"organizations_at_risk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/ispm/widgets/security_posture(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_ispm_widgets_security_posture_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"security_posture"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/ai_search_feedbacks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_ai_search_feedback_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"ai_search_feedbacks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/ai_search_feedbacks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_ai_search_feedbacks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"ai_search_feedbacks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/audit_policy_escalation_manifest_configs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_audit_policy_escalation_manifest_config_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"audit_policy_escalation_manifest_configs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/billing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_billing_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/query_builders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_query_builders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"query_builders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/query_exports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_query_export_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"query_exports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/query_exports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_query_exports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"query_exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/rehydrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_rehydrations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"rehydrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/saved_queries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_saved_queries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"saved_queries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/saved_queries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_saved_query_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"saved_queries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_settings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/:source_id/activity(.:format)
 * @param {any} source_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_source_activity_path = /*#__PURE__*/ __jsr.r({"source_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[3,"source_id"],[2,[7,"/"],[2,[6,"activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/:source_id/activity_settings(.:format)
 * @param {any} source_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_source_activity_settings_path = /*#__PURE__*/ __jsr.r({"source_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[3,"source_id"],[2,[7,"/"],[2,[6,"activity_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/arista_syslogs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_arista_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"arista_syslogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/arista_syslogs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_arista_syslogs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"arista_syslogs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/azures/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_azure_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"azures"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/azure/entra_ids/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_azure_entra_id_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"azure"],[2,[7,"/"],[2,[6,"entra_ids"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/azure/generics/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_azure_generic_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"azure"],[2,[7,"/"],[2,[6,"generics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/azure/generic_jsons/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_azure_generic_json_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"azure"],[2,[7,"/"],[2,[6,"generic_jsons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/azure/monitors/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_azure_monitor_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"azure"],[2,[7,"/"],[2,[6,"monitors"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/azure/resources/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_azure_resource_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"azure"],[2,[7,"/"],[2,[6,"resources"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/azures(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_azures_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"azures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/barracuda_cloudgen_syslogs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_barracuda_cloudgen_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"barracuda_cloudgen_syslogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/barracuda_cloudgen_syslogs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_barracuda_cloudgen_syslogs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"barracuda_cloudgen_syslogs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/bitwardens/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_bitwarden_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"bitwardens"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/bitwarden_hecs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_bitwarden_hec_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"bitwarden_hecs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/bitwarden_hecs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_bitwarden_hecs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"bitwarden_hecs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/bitwarden/source_type_selectors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_bitwarden_source_type_selectors_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"bitwarden"],[2,[7,"/"],[2,[6,"source_type_selectors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/bitwardens(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_bitwardens_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"bitwardens"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/cisco_amps/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_cisco_amp_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cisco_amps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/cisco_amps(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_cisco_amps_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cisco_amps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/cisco_asa_syslogs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_cisco_asa_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cisco_asa_syslogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/cisco_asa_syslogs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_cisco_asa_syslogs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cisco_asa_syslogs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/cisco_ftd_syslogs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_cisco_ftd_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cisco_ftd_syslogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/cisco_ftd_syslogs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_cisco_ftd_syslogs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cisco_ftd_syslogs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/cisco_umbrella_organizations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_cisco_umbrella_organization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cisco_umbrella_organizations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/cisco_umbrella_organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_cisco_umbrella_organizations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cisco_umbrella_organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/cloud_trails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_cloud_trail_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cloud_trails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/cloud_trails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_cloud_trails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cloud_trails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/cloudflare_hecs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_cloudflare_hec_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cloudflare_hecs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/cloudflare_hecs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_cloudflare_hecs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cloudflare_hecs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/crowd_strike/agents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_crowd_strike_agent_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"crowd_strike"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/crowd_strike_falcons/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_crowd_strike_falcon_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"crowd_strike_falcons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/crowd_strike_falcons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_crowd_strike_falcons_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"crowd_strike_falcons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/datto_rmms/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_datto_rmm_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"datto_rmms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/datto_rmms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_datto_rmms_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"datto_rmms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/dnsfilter_hecs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_dnsfilter_hec_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"dnsfilter_hecs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/dnsfilter_hecs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_dnsfilter_hecs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"dnsfilter_hecs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/duos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_duo_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"duos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/duos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_duos_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"duos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/endpoint_logs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_endpoint_logs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"endpoint_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/fortigate_syslogs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_fortigate_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"fortigate_syslogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/fortigate_syslogs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_fortigate_syslogs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"fortigate_syslogs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/generic_hecs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_generic_hec_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"generic_hecs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/generic_hecs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_generic_hecs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"generic_hecs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/generic_s3s/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_generic_s3_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"generic_s3s"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/generic_s3s(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_generic_s3s_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"generic_s3s"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/huntress_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_huntress_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"huntress_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/huntress_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_huntress_accounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"huntress_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/huntress_organizations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_huntress_organization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"huntress_organizations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/huntress_organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_huntress_organizations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"huntress_organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/itdrs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_itdr_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"itdrs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/itdrs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_itdrs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"itdrs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/keeper_hecs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_keeper_hec_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"keeper_hecs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/keeper_hecs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_keeper_hecs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"keeper_hecs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/lastpass_hecs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_lastpass_hec_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"lastpass_hecs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/lastpass_hecs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_lastpass_hecs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"lastpass_hecs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/linux_events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_linux_event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"linux_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/linux_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_linux_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"linux_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/macos_events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_macos_event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"macos_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/macos_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_macos_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"macos_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/meraki_clouds/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_meraki_cloud_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"meraki_clouds"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/meraki_cloud_devices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_meraki_cloud_device_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"meraki_cloud_devices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/meraki_cloud_organizations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_meraki_cloud_organization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"meraki_cloud_organizations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/meraki_clouds(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_meraki_clouds_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"meraki_clouds"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/meraki_syslogs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_meraki_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"meraki_syslogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/meraki_syslogs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_meraki_syslogs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"meraki_syslogs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/microsoft_defender_alerts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_microsoft_defender_alert_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"microsoft_defender_alerts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/microsoft_defender_alerts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_microsoft_defender_alerts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"microsoft_defender_alerts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/ninja_one_hecs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_ninja_one_hec_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"ninja_one_hecs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/ninja_one_hecs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_ninja_one_hecs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"ninja_one_hecs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/oktas/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_okta_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"oktas"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/oktas(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_oktas_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"oktas"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/one_passwords/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_one_password_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"one_passwords"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/one_passwords(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_one_passwords_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"one_passwords"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/palo_alto_syslogs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_palo_alto_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"palo_alto_syslogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/palo_alto_syslogs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_palo_alto_syslogs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"palo_alto_syslogs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/pfsense_syslogs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_pfsense_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"pfsense_syslogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/pfsense_syslogs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_pfsense_syslogs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"pfsense_syslogs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/public_syslogs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_public_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"public_syslogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/public_syslogs/:public_syslog_id/ca_chain(.:format)
 * @param {any} public_syslog_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_public_syslog_ca_chain_path = /*#__PURE__*/ __jsr.r({"public_syslog_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"public_syslogs"],[2,[7,"/"],[2,[3,"public_syslog_id"],[2,[7,"/"],[2,[6,"ca_chain"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/public_syslogs/:public_syslog_id/certificate(.:format)
 * @param {any} public_syslog_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_public_syslog_certificate_path = /*#__PURE__*/ __jsr.r({"public_syslog_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"public_syslogs"],[2,[7,"/"],[2,[3,"public_syslog_id"],[2,[7,"/"],[2,[6,"certificate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/public_syslogs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_public_syslogs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"public_syslogs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/sentinel_one_agent_syslogs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_sentinel_one_agent_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"sentinel_one_agent_syslogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/sentinel_one_site_syslogs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_sentinel_one_site_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"sentinel_one_site_syslogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/sentinel_one_syslogs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_sentinel_one_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"sentinel_one_syslogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/sentinel_one_syslogs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_sentinel_one_syslogs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"sentinel_one_syslogs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/sonicwall_syslogs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_sonicwall_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"sonicwall_syslogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/sonicwall_syslogs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_sonicwall_syslogs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"sonicwall_syslogs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/sophos_syslogs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_sophos_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"sophos_syslogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/sophos_syslogs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_sophos_syslogs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"sophos_syslogs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/syslogs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"syslogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/syslog_agents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_syslog_agents_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"syslog_agents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/syslogs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_syslogs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"syslogs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/ubiquiti_syslogs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_ubiquiti_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"ubiquiti_syslogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/ubiquiti_syslogs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_ubiquiti_syslogs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"ubiquiti_syslogs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/watchguard_syslogs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_watchguard_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"watchguard_syslogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/watchguard_syslogs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_watchguard_syslogs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"watchguard_syslogs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/windows_events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_windows_event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"windows_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/windows_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_windows_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"windows_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/wiz_hecs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_wiz_hec_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"wiz_hecs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/wiz_hecs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_wiz_hecs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"wiz_hecs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/wizards/starter(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_wizards_starter_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"wizards"],[2,[7,"/"],[2,[6,"starter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/wizards/syslog(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_sources_wizards_syslog_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"wizards"],[2,[7,"/"],[2,[6,"syslog"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/windows_audit_configs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_windows_audit_configs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"windows_audit_configs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/windows_audit_configs/mute(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_windows_audit_configs_mute_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"windows_audit_configs"],[2,[7,"/"],[2,[6,"mute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/windows_audit_configs/resync(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_logs_windows_audit_configs_resync_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"windows_audit_configs"],[2,[7,"/"],[2,[6,"resync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/managed_identity/attribute_rules/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_managed_identity_attribute_rule_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"attribute_rules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/managed_identity/attribute_rules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_managed_identity_attribute_rules_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"attribute_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/managed_identity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_managed_identity_detections_table_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"managed_identity"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/managed_identity/identities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_managed_identity_identities_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"identities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/managed_identity/identities/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_managed_identity_identity_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"identities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/managed_identity/identities/:identity_id/attribute_rules(.:format)
 * @param {any} identity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_managed_identity_identity_attribute_rules_path = /*#__PURE__*/ __jsr.r({"identity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"identities"],[2,[7,"/"],[2,[3,"identity_id"],[2,[7,"/"],[2,[6,"attribute_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/managed_identity/identities/:identity_id/logged_in_events(.:format)
 * @param {any} identity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_managed_identity_identity_logged_in_events_path = /*#__PURE__*/ __jsr.r({"identity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"identities"],[2,[7,"/"],[2,[3,"identity_id"],[2,[7,"/"],[2,[6,"logged_in_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/managed_identity/risky_identities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_managed_identity_risky_identities_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"risky_identities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/managed_identity/signals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_managed_identity_signals_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"signals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/managed_identity/tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_managed_identity_tasks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/managed_identity/user_entities/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_managed_identity_user_entity_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"user_entities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/managed_identity/user_entities/:user_entity_id/licenses(.:format)
 * @param {any} user_entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_managed_identity_user_entity_licenses_path = /*#__PURE__*/ __jsr.r({"user_entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"user_entities"],[2,[7,"/"],[2,[3,"user_entity_id"],[2,[7,"/"],[2,[6,"licenses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/marketing_assets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_marketing_asset_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"marketing_assets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/marketing_assets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_marketing_assets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"marketing_assets"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/member_invitations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_member_invitation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"member_invitations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/member_invitations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_member_invitations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"member_invitations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/memberships/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_membership_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/memberships(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_memberships_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"memberships"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/microsoft_defender_events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_microsoft_defender_event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"microsoft_defender_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/microsoft_defender_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_microsoft_defender_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"microsoft_defender_events"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/microsoft_defender_endpoints(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_microsoft_defender_machine_entities_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"microsoft_defender_endpoints"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/microsoft_defender_vulnerabilities/machine_entities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_microsoft_defender_vulnerability_assessment_machine_entities_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"microsoft_defender_vulnerabilities"],[2,[7,"/"],[2,[6,"machine_entities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/microsoft_defender_vulnerabilities/organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_microsoft_defender_vulnerability_assessment_organizations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"microsoft_defender_vulnerabilities"],[2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/microsoft_defender_vulnerabilities/product_vendor_organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_microsoft_defender_vulnerability_assessment_product_vendor_organizations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"microsoft_defender_vulnerabilities"],[2,[7,"/"],[2,[6,"product_vendor_organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/microsoft_defender_vulnerabilities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_microsoft_defender_vulnerability_assessments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"microsoft_defender_vulnerabilities"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/antivirus_exclusions/settings/account_modal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_modal_account_antivirus_exclusions_settings_path = /*#__PURE__*/ __jsr.r({"format":{"d":"turbo_stream"}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"antivirus_exclusions"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"account_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/notification_contacts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_notification_contact_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"notification_contacts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/notification_contacts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_notification_contacts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"notification_contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_organizations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/partner_showcase(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_partner_showcase_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"partner_showcase"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/pricing_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_pricing_requests_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"pricing_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/processes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_processes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"processes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/ransomed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_ransomed_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"ransomed"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/ransomware_canaries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_ransomware_canaries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"ransomware_canaries"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/reports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/rogue_apps/cloud_applications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_rogue_apps_cloud_application_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"rogue_apps"],[2,[7,"/"],[2,[6,"cloud_applications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/rogue_apps/cloud_applications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_rogue_apps_cloud_applications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"rogue_apps"],[2,[7,"/"],[2,[6,"cloud_applications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/rogue_apps(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_rogue_apps_root_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"rogue_apps"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/rogue_apps/service_principals/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_rogue_apps_service_principal_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"rogue_apps"],[2,[7,"/"],[2,[6,"service_principals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/rogue_apps/signals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_rogue_apps_signals_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"rogue_apps"],[2,[7,"/"],[2,[6,"signals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/unwanted_access/rules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_rules_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"unwanted_access"],[2,[7,"/"],[2,[6,"rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/sales_contact_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_sales_contact_requests_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"sales_contact_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/saml_provider(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_saml_provider_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"saml_provider"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/screen_connect_agent_hosts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_screen_connect_agent_hosts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"screen_connect_agent_hosts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/security_awareness_training/magic_link(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_security_awareness_training_magic_link_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"security_awareness_training"],[2,[7,"/"],[2,[6,"magic_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/security_awareness_training/organization_mappings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_security_awareness_training_organization_mappings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"security_awareness_training"],[2,[7,"/"],[2,[6,"organization_mappings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/signals/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_signal_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/signals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_signals_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"signals"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/simulated_incidents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_simulated_incidents_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"simulated_incidents"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/soc_callback_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_soc_callback_requests_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"soc_callback_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/subscription(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_subscription_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/subscriptions/:subscription_id/subscription_cancellation_requests(.:format)
 * @param {any} subscription_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_subscription_subscription_cancellation_requests_path = /*#__PURE__*/ __jsr.r({"subscription_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"subscription_id"],[2,[7,"/"],[2,[6,"subscription_cancellation_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/threatops/logs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_threatops_logs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/trials(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_trials_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"trials"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/unwanted_access(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_unwanted_access_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"unwanted_access"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/user_api_credentials/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_user_api_credential_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"user_api_credentials"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/user_api_credentials(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_user_api_credentials_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"user_api_credentials"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/antivirus_exclusions/action_individual(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const action_individual_account_antivirus_exclusions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"antivirus_exclusions"],[2,[7,"/"],[2,[6,"action_individual"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/antivirus_exclusions/action_individual(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const action_individual_organization_antivirus_exclusions_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"antivirus_exclusions"],[2,[7,"/"],[2,[6,"action_individual"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/signals/:id/actions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const actions_admin_signal_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"actions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:id/actions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const actions_admin_soc_investigation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"actions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/investigation_notes/:id/actions(.:format)
 * @param {any} investigation_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const actions_admin_soc_investigation_investigation_note_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"investigation_notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"actions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/threatops/logs/detections/:detection_id/activate(.:format)
 * @param {any} detection_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activate_detection_account_threatops_logs_path = /*#__PURE__*/ __jsr.r({"detection_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"detections"],[2,[7,"/"],[2,[3,"detection_id"],[2,[7,"/"],[2,[6,"activate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:agent_id/microsoft_defender/active_weaknesses(.:format)
 * @param {any} organization_id
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const active_weaknesses_organization_agent_microsoft_defender_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"microsoft_defender"],[2,[7,"/"],[2,[6,"active_weaknesses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/antivirus_exclusions/settings/add(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_account_antivirus_exclusions_settings_path = /*#__PURE__*/ __jsr.r({"format":{"d":"turbo_stream"}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"antivirus_exclusions"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"add"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/webhooks/:id/add_endpoint(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_endpoint_account_integrations_webhook_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_endpoint"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/antivirus_exclusions/settings/add(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_organization_antivirus_exclusions_settings_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{"d":"turbo_stream"}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"antivirus_exclusions"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"add"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/threatops/logs/investigations/:investigation_id/items(.:format)
 * @param {any} investigation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_to_investigation_account_threatops_logs_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/accounts/:account_id/subscriptions/:id/add_units_form(.:format)
 * @param {any} reseller_id
 * @param {any} account_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_units_form_reseller_account_subscription_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"account_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_units_form"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/accounts/:account_id/subscriptions/:id/add_units(.:format)
 * @param {any} reseller_id
 * @param {any} account_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_units_reseller_account_subscription_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"account_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_units"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/addresses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addresses_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"addresses"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscriptions/:id/adjust_discount(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adjust_discount_admin_subscription_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"adjust_discount"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscriptions/:id/adjust_maximum(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adjust_maximum_admin_subscription_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"adjust_maximum"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/accounts/:account_id/itdr_assessments/drawer(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_account_itdr_assessments_drawer_path = /*#__PURE__*/ __jsr.r({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"itdr_assessments"],[2,[7,"/"],[2,[6,"drawer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/accounts/:account_id/organizations(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_account_organizations_path = /*#__PURE__*/ __jsr.r({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/accounts/:account_id/subscriptions(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_account_subscriptions_path = /*#__PURE__*/ __jsr.r({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_accounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/agents/:agent_id/configuration(.:format)
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_agent_configuration_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agents/:agent_id/eetee(.:format)
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_agent_eetee_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"eetee"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agents/:agent_id/infection_reports(.:format)
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_agent_infection_reports_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"infection_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agents/:agent_id/isolation(.:format)
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_agent_isolation_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"isolation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agent_issue_fix_attempts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_agent_issue_fix_attempts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agent_issue_fix_attempts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/agent_issue_snapshots(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_agent_issue_snapshots_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agent_issue_snapshots"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/agent_issues(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_agent_issues_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agent_issues"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/agents/:agent_id/mayday_errors(.:format)
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_agent_mayday_errors_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"mayday_errors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agent_misbehaviors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_agent_misbehaviors_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agent_misbehaviors"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/agent_misbehaviors/install_churns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_agent_misbehaviors_install_churns_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agent_misbehaviors"],[2,[7,"/"],[2,[6,"install_churns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agent_releases(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_agent_releases_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agent_releases"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/agent_rollouts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_agent_rollout_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agent_rollouts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agent_rollouts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_agent_rollouts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agent_rollouts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/agents/:agent_id/tasks(.:format)
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_agent_tasks_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agents/:agent_id/update_manifest(.:format)
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_agent_update_manifest_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"update_manifest"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agent_usage/accounts/:account_id/organizations/:organization_id/agent_tombstones(.:format)
 * @param {any} account_id
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_agent_usage_account_organization_agent_tombstones_path = /*#__PURE__*/ __jsr.r({"account_id":{"r":true},"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agent_usage"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agent_tombstones"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agent_usage/accounts/:account_id/organizations(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_agent_usage_account_organizations_path = /*#__PURE__*/ __jsr.r({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agent_usage"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agent_usage/accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_agent_usage_accounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agent_usage"],[2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_agents_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agents"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/antivirus_threats/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_antivirus_threat_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"antivirus_threats"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/antivirus_threats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_antivirus_threats_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"antivirus_threats"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/artemis/releases/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_artemis_release_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"artemis"],[2,[7,"/"],[2,[6,"releases"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/artemis/releases(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_artemis_releases_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"artemis"],[2,[7,"/"],[2,[6,"releases"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/assessments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_assessments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"assessments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/async_exports/:export_filename(.:format)
 * @param {any} export_filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_async_export_path = /*#__PURE__*/ __jsr.r({"export_filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"async_exports"],[2,[7,"/"],[2,[3,"export_filename"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/audit/events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_audit_event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/audit/events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_audit_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/autoruns/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_autorun_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"autoruns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/autorun_entries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_autorun_entry_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"autorun_entries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/billing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_billing_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/billing/csv_runner(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_billing_csv_runner_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"csv_runner"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/billing/flex_subscriptions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_billing_flex_subscription_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"flex_subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/billing/flex_subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_billing_flex_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"flex_subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/billing/goalie_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_billing_goalie_tasks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"goalie_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/billing/health(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_billing_health_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"health"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/billing/salesforce_errors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_billing_salesforce_errors_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"salesforce_errors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/binaries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_binary_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"binaries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/binaries/:binary_id/agents(.:format)
 * @param {any} binary_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_binary_agents_path = /*#__PURE__*/ __jsr.r({"binary_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"binaries"],[2,[7,"/"],[2,[3,"binary_id"],[2,[7,"/"],[2,[6,"agents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/blockable_ip_addresses/:ip(.:format)
 * @param {any} ip
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_blockable_ip_address_path = /*#__PURE__*/ __jsr.r({"ip":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blockable_ip_addresses"],[2,[7,"/"],[2,[3,"ip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/bulk_investigations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_bulk_investigation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bulk_investigations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/bulk_investigations/:bulk_investigation_id/comments(.:format)
 * @param {any} bulk_investigation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_bulk_investigation_comments_path = /*#__PURE__*/ __jsr.r({"bulk_investigation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bulk_investigations"],[2,[7,"/"],[2,[3,"bulk_investigation_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/bulk_investigations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_bulk_investigations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bulk_investigations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_categories_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/contracts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_contract_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/contracts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_contracts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"contracts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/data_grid_saved_views/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_data_grid_saved_view_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"data_grid_saved_views"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/data_grid_saved_views(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_data_grid_saved_views_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"data_grid_saved_views"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/data_replays/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_data_replay_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"data_replays"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/data_replays(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_data_replays_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"data_replays"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/db/explain(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_db_explain_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"db"],[2,[7,"/"],[2,[6,"explain"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dead_jobs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_dead_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dead_jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dead_jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_dead_jobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dead_jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/detection_rules/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_detection_rule_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"detection_rules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/detection_rules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_detection_rules_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"detection_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_security/account_tenants/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_email_security_account_tenant_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_security"],[2,[7,"/"],[2,[6,"account_tenants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_security/account_tenants/:account_tenant_id/tenants(.:format)
 * @param {any} account_tenant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_email_security_account_tenant_tenants_path = /*#__PURE__*/ __jsr.r({"account_tenant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_security"],[2,[7,"/"],[2,[6,"account_tenants"],[2,[7,"/"],[2,[3,"account_tenant_id"],[2,[7,"/"],[2,[6,"tenants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_security/account_tenants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_email_security_account_tenants_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_security"],[2,[7,"/"],[2,[6,"account_tenants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/escalations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_escalation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"escalations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/escalations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_escalations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"escalations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/espm/app_control/binaries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_espm_app_control_binary_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"app_control"],[2,[7,"/"],[2,[6,"binaries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/espm/app_control/signing_certs/details/:tbs_hash(.:format)
 * @param {any} tbs_hash
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_espm_app_control_signing_cert_details_path = /*#__PURE__*/ __jsr.r({"tbs_hash":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"app_control"],[2,[7,"/"],[2,[6,"signing_certs"],[2,[7,"/"],[2,[6,"details"],[2,[7,"/"],[2,[3,"tbs_hash"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/espm/app_control/signing_certs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_espm_app_control_signing_certs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"app_control"],[2,[7,"/"],[2,[6,"signing_certs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/espm/rmm_tools/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_espm_rmm_tool_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"rmm_tools"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/espm/rmm_tool_candidates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_espm_rmm_tool_candidate_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"rmm_tool_candidates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/espm/rmm_tool_candidates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_espm_rmm_tool_candidates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"rmm_tool_candidates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/espm/rmm_tools/:rmm_tool_id/signing_certs/:tbs_hash(.:format)
 * @param {any} rmm_tool_id
 * @param {any} tbs_hash
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_espm_rmm_tool_signing_cert_path = /*#__PURE__*/ __jsr.r({"rmm_tool_id":{"r":true},"tbs_hash":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"rmm_tools"],[2,[7,"/"],[2,[3,"rmm_tool_id"],[2,[7,"/"],[2,[6,"signing_certs"],[2,[7,"/"],[2,[3,"tbs_hash"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/espm/rmm_tools(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_espm_rmm_tools_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"rmm_tools"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/external_vulnerabilities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_external_vulnerabilities_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"external_vulnerabilities"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/feature(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_feature_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"feature"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/feature_rollouts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_feature_rollout_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"feature_rollouts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/feature_rollouts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_feature_rollouts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"feature_rollouts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/features(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_features_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"features"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/grafana-redirect/:dashboard/:resource_type/:resource_id(.:format)
 * @param {any} dashboard
 * @param {any} resource_type
 * @param {any} resource_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_grafana_links_path = /*#__PURE__*/ __jsr.r({"dashboard":{"r":true},"resource_type":{"r":true},"resource_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"grafana-redirect"],[2,[7,"/"],[2,[3,"dashboard"],[2,[7,"/"],[2,[3,"resource_type"],[2,[7,"/"],[2,[3,"resource_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/incident_responses/manual_remediations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_incident_responses_manual_remediation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"incident_responses"],[2,[7,"/"],[2,[6,"manual_remediations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/incident_responses/manual_remediations/:manual_remediation_id/detection_rules/:id(.:format)
 * @param {any} manual_remediation_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_incident_responses_manual_remediation_detection_rule_path = /*#__PURE__*/ __jsr.r({"manual_remediation_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"incident_responses"],[2,[7,"/"],[2,[6,"manual_remediations"],[2,[7,"/"],[2,[3,"manual_remediation_id"],[2,[7,"/"],[2,[6,"detection_rules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/incident_responses/manual_remediations/:manual_remediation_id/detection_rules(.:format)
 * @param {any} manual_remediation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_incident_responses_manual_remediation_detection_rules_path = /*#__PURE__*/ __jsr.r({"manual_remediation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"incident_responses"],[2,[7,"/"],[2,[6,"manual_remediations"],[2,[7,"/"],[2,[3,"manual_remediation_id"],[2,[7,"/"],[2,[6,"detection_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/incident_responses/manual_remediations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_incident_responses_manual_remediations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"incident_responses"],[2,[7,"/"],[2,[6,"manual_remediations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/infection_reports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_infection_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/infection_reports/:infection_report_id/comments/:id(.:format)
 * @param {any} infection_report_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_infection_report_comment_path = /*#__PURE__*/ __jsr.r({"infection_report_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/infection_reports/:infection_report_id/comments(.:format)
 * @param {any} infection_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_infection_report_comments_path = /*#__PURE__*/ __jsr.r({"infection_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/infection_reports/:infection_report_id/infection_report_feedbacks(.:format)
 * @param {any} infection_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_infection_report_infection_report_feedbacks_path = /*#__PURE__*/ __jsr.r({"infection_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"infection_report_feedbacks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/infection_reports/:infection_report_id/inquiry(.:format)
 * @param {any} infection_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_infection_report_inquiry_path = /*#__PURE__*/ __jsr.r({"infection_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"inquiry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/infection_reports/:infection_report_id/tasks(.:format)
 * @param {any} infection_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_infection_report_tasks_path = /*#__PURE__*/ __jsr.r({"infection_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/infection_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_infection_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"infection_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/internal_api_credentials/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_internal_api_credential_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"internal_api_credentials"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/internal_api_credentials(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_internal_api_credentials_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"internal_api_credentials"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/internal_api_docs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_internal_api_docs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"internal_api_docs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/ispm/overview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_ispm_overview_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ispm/security_control_checks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_ispm_security_control_checks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"security_control_checks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ispm/security_control_definitions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_ispm_security_control_definition_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"security_control_definitions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ispm/security_control_definitions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_ispm_security_control_definitions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"security_control_definitions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ispm/security_controls(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_ispm_security_controls_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"security_controls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ispm/tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_ispm_tasks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/jobs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_jobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/latest_user_notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_latest_user_notifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"latest_user_notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/logs/accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_logs_accounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/logs/filter_rules/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_logs_filter_rule_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"filter_rules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/logs/filter_rules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_logs_filter_rules_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"filter_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/logs/organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_logs_organizations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/logs/overages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_logs_overages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"overages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/logs/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_logs_sources_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/malware_families(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_malware_families_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"malware_families"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/malware_families/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_malware_family_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"malware_families"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_identity/accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_managed_identity_accounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_identity/identities/:identity_id/infection_reports(.:format)
 * @param {any} identity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_managed_identity_identity_infection_reports_path = /*#__PURE__*/ __jsr.r({"identity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"identities"],[2,[7,"/"],[2,[3,"identity_id"],[2,[7,"/"],[2,[6,"infection_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_identity/identities/:identity_id/isolation(.:format)
 * @param {any} identity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_managed_identity_identity_isolation_path = /*#__PURE__*/ __jsr.r({"identity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"identities"],[2,[7,"/"],[2,[3,"identity_id"],[2,[7,"/"],[2,[6,"isolation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_identity/identities/:identity_id/tasks(.:format)
 * @param {any} identity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_managed_identity_identity_tasks_path = /*#__PURE__*/ __jsr.r({"identity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"identities"],[2,[7,"/"],[2,[3,"identity_id"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_identity/organizations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_managed_identity_organization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_identity/organizations/:organization_id/client_api_request(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_managed_identity_organization_client_api_request_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"client_api_request"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_identity/organizations/:organization_id/excluded_licenses/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_managed_identity_organization_excluded_license_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"excluded_licenses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_identity/organizations/:organization_id/excluded_licenses(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_managed_identity_organization_excluded_licenses_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"excluded_licenses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_identity/organizations/:organization_id/excluded_organizational_units/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_managed_identity_organization_excluded_organizational_unit_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"excluded_organizational_units"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_identity/organizations/:organization_id/excluded_organizational_units(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_managed_identity_organization_excluded_organizational_units_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"excluded_organizational_units"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_identity/organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_managed_identity_organizations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_identity/service_principals/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_managed_identity_service_principal_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"service_principals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_identity/tasks/:task_id/view_params(.:format)
 * @param {any} task_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_managed_identity_task_view_params_path = /*#__PURE__*/ __jsr.r({"task_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_id"],[2,[7,"/"],[2,[6,"view_params"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_identity/tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_managed_identity_tasks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_identity/user_entities/:user_entity_id/infection_reports(.:format)
 * @param {any} user_entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_managed_identity_user_entity_infection_reports_path = /*#__PURE__*/ __jsr.r({"user_entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"user_entities"],[2,[7,"/"],[2,[3,"user_entity_id"],[2,[7,"/"],[2,[6,"infection_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_identity/user_entities/:user_entity_id/isolation(.:format)
 * @param {any} user_entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_managed_identity_user_entity_isolation_path = /*#__PURE__*/ __jsr.r({"user_entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"user_entities"],[2,[7,"/"],[2,[3,"user_entity_id"],[2,[7,"/"],[2,[6,"isolation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_identity/user_entities/:user_entity_id/tasks(.:format)
 * @param {any} user_entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_managed_identity_user_entity_tasks_path = /*#__PURE__*/ __jsr.r({"user_entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"user_entities"],[2,[7,"/"],[2,[3,"user_entity_id"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/marketing_assets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_marketing_asset_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"marketing_assets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/marketing_assets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_marketing_assets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"marketing_assets"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/microsoft_defender/events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_microsoft_defender_event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"microsoft_defender"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/microsoft_defender/events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_microsoft_defender_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"microsoft_defender"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/microsoft_defender/tenants/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_microsoft_defender_tenant_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"microsoft_defender"],[2,[7,"/"],[2,[6,"tenants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/microsoft_defender/tenants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_microsoft_defender_tenants_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"microsoft_defender"],[2,[7,"/"],[2,[6,"tenants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/mitre/:mitre_tag(.:format)
 * @param {any} mitre_tag
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_mitre_path = /*#__PURE__*/ __jsr.r({"mitre_tag":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"mitre"],[2,[7,"/"],[2,[3,"mitre_tag"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/monitored_files(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_monitored_files_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"monitored_files"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/noticed_events/:noticed_event_id/recipients(.:format)
 * @param {any} noticed_event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_noticed_event_recipients_path = /*#__PURE__*/ __jsr.r({"noticed_event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"noticed_events"],[2,[7,"/"],[2,[3,"noticed_event_id"],[2,[7,"/"],[2,[6,"recipients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/noticed_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_noticed_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"noticed_events"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/notification_contact/supported_countries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_notification_contact_supported_countries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"notification_contact"],[2,[7,"/"],[2,[6,"supported_countries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/notification_contact/supported_countries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_notification_contact_supported_country_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"notification_contact"],[2,[7,"/"],[2,[6,"supported_countries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/notify/autotask(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_notify_autotask_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"notify"],[2,[7,"/"],[2,[6,"autotask"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/notify/connectwise(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_notify_connectwise_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"notify"],[2,[7,"/"],[2,[6,"connectwise"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/notify/halo_psa(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_notify_halo_psa_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"notify"],[2,[7,"/"],[2,[6,"halo_psa"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/notify/kaseya(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_notify_kaseya_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"notify"],[2,[7,"/"],[2,[6,"kaseya"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/notify/syncro(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_notify_syncro_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"notify"],[2,[7,"/"],[2,[6,"syncro"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/one_time_notifications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_one_time_notification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"one_time_notifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/one_time_notifications/:one_time_notification_id/send(.:format)
 * @param {any} one_time_notification_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_one_time_notification_send_path = /*#__PURE__*/ __jsr.r({"one_time_notification_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"one_time_notifications"],[2,[7,"/"],[2,[3,"one_time_notification_id"],[2,[7,"/"],[2,[6,"send"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/one_time_notifications/:one_time_notification_id/send_attempts/:send_attempt_id/recipients(.:format)
 * @param {any} one_time_notification_id
 * @param {any} send_attempt_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_one_time_notification_send_attempt_recipients_path = /*#__PURE__*/ __jsr.r({"one_time_notification_id":{"r":true},"send_attempt_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"one_time_notifications"],[2,[7,"/"],[2,[3,"one_time_notification_id"],[2,[7,"/"],[2,[6,"send_attempts"],[2,[7,"/"],[2,[3,"send_attempt_id"],[2,[7,"/"],[2,[6,"recipients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/one_time_notifications/:one_time_notification_id/test(.:format)
 * @param {any} one_time_notification_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_one_time_notification_test_path = /*#__PURE__*/ __jsr.r({"one_time_notification_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"one_time_notifications"],[2,[7,"/"],[2,[3,"one_time_notification_id"],[2,[7,"/"],[2,[6,"test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/one_time_notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_one_time_notifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"one_time_notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_organization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organization_moves/account_select2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_organization_moves_account_select2_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organization_moves"],[2,[7,"/"],[2,[6,"account_select2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_organizations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/persistence/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_persistence_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"persistence"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/persistence/:persistence_id/agents(.:format)
 * @param {any} persistence_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_persistence_agents_path = /*#__PURE__*/ __jsr.r({"persistence_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"persistence"],[2,[7,"/"],[2,[3,"persistence_id"],[2,[7,"/"],[2,[6,"agents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/processes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_processes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"processes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/product_reports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_product_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"product_reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/product_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_product_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"product_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/recently_uninstalled_agents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_recently_uninstalled_agents_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"recently_uninstalled_agents"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/redfigs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_redfig_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"redfigs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/redfigs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_redfigs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"redfigs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/remediations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_remediations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"remediations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/resellers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_reseller_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resellers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_resellers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"resellers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/rio_config(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_rio_configs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"rio_config"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/risk_calculations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_risk_calculations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"risk_calculations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_root_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/rules/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_rule_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"rules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/rules/:rule_id/comments(.:format)
 * @param {any} rule_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_rule_comments_path = /*#__PURE__*/ __jsr.r({"rule_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"rules"],[2,[7,"/"],[2,[3,"rule_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/rules/:rule_id/rule_actions(.:format)
 * @param {any} rule_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_rule_rule_actions_path = /*#__PURE__*/ __jsr.r({"rule_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"rules"],[2,[7,"/"],[2,[3,"rule_id"],[2,[7,"/"],[2,[6,"rule_actions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/rules/:rule_id/rule_matches(.:format)
 * @param {any} rule_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_rule_rule_matches_path = /*#__PURE__*/ __jsr.r({"rule_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"rules"],[2,[7,"/"],[2,[3,"rule_id"],[2,[7,"/"],[2,[6,"rule_matches"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/rules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_rules_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"rules"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/sales(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sales_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sales"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/sales_commissions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sales_commissions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sales_commissions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/sales_goals/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sales_goal_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sales_goals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/sales_goals/:sales_goal_id/sales_commissions(.:format)
 * @param {any} sales_goal_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sales_goal_sales_commissions_path = /*#__PURE__*/ __jsr.r({"sales_goal_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sales_goals"],[2,[7,"/"],[2,[3,"sales_goal_id"],[2,[7,"/"],[2,[6,"sales_commissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/sales_goals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sales_goals_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sales_goals"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/sales_reports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sales_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sales_reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/sales_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sales_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sales_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/scans/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_scan_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scans"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scan_results/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_scan_result_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scan_results"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scheduled_jobs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_scheduled_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scheduled_jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scheduled_jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_scheduled_jobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scheduled_jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_setting_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_settings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/showcases/demos/activity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_showcases_activities_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"showcases"],[2,[7,"/"],[2,[6,"demos"],[2,[7,"/"],[2,[6,"activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/showcases/demos/:showcase_id(.:format)
 * @param {any} showcase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_showcases_demo_path = /*#__PURE__*/ __jsr.r({"showcase_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"showcases"],[2,[7,"/"],[2,[6,"demos"],[2,[7,"/"],[2,[3,"showcase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/showcases/demos/:demo_showcase_id/detonate(.:format)
 * @param {any} demo_showcase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_showcases_demo_detonate_path = /*#__PURE__*/ __jsr.r({"demo_showcase_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"showcases"],[2,[7,"/"],[2,[6,"demos"],[2,[7,"/"],[2,[3,"demo_showcase_id"],[2,[7,"/"],[2,[6,"detonate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/showcases/demos/:demo_showcase_id/membership(.:format)
 * @param {any} demo_showcase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_showcases_demo_membership_path = /*#__PURE__*/ __jsr.r({"demo_showcase_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"showcases"],[2,[7,"/"],[2,[6,"demos"],[2,[7,"/"],[2,[3,"demo_showcase_id"],[2,[7,"/"],[2,[6,"membership"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/showcases/demos/:demo_showcase_id/plot(.:format)
 * @param {any} demo_showcase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_showcases_demo_plot_path = /*#__PURE__*/ __jsr.r({"demo_showcase_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"showcases"],[2,[7,"/"],[2,[6,"demos"],[2,[7,"/"],[2,[3,"demo_showcase_id"],[2,[7,"/"],[2,[6,"plot"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/showcases/demos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_showcases_demos_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"showcases"],[2,[7,"/"],[2,[6,"demos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/showcases/tours(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_showcases_tours_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"showcases"],[2,[7,"/"],[2,[6,"tours"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/showcases/validations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_showcases_validations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"showcases"],[2,[7,"/"],[2,[6,"validations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/signals/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_signal_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/signals/:signal_id/comments/:id(.:format)
 * @param {any} signal_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_signal_comment_path = /*#__PURE__*/ __jsr.r({"signal_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[3,"signal_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/signals/:signal_id/comments(.:format)
 * @param {any} signal_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_signal_comments_path = /*#__PURE__*/ __jsr.r({"signal_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[3,"signal_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/signal_events/:signal_event_id/detection_rule(.:format)
 * @param {any} signal_event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_signal_event_detection_rule_path = /*#__PURE__*/ __jsr.r({"signal_event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signal_events"],[2,[7,"/"],[2,[3,"signal_event_id"],[2,[7,"/"],[2,[6,"detection_rule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/signal_event_matches(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_signal_event_matches_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signal_event_matches"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/signal_prevalences/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_signal_prevalence_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signal_prevalences"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/signals/:signal_id/priority(.:format)
 * @param {any} signal_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_signal_priority_path = /*#__PURE__*/ __jsr.r({"signal_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[3,"signal_id"],[2,[7,"/"],[2,[6,"priority"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/signal_workflow_executions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_signal_workflow_execution_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signal_workflow_executions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/signals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_signals_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signals"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/signals/report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_signals_report_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[6,"report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/sites/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_site_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/sites(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sites_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sites"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_agent_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agents/:agent_id/antivirus(.:format)
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_agent_antivirus_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"antivirus"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agents/:agent_id/autorun_entries(.:format)
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_agent_autorun_entries_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"autorun_entries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agents/:agent_id/autorun_entries/:id(.:format)
 * @param {any} agent_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_agent_autorun_entry_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"autorun_entries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agents/:agent_id/logs(.:format)
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_agent_logs_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agents/:agent_id/microsoft_defender_events/:id(.:format)
 * @param {any} agent_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_agent_microsoft_defender_event_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"microsoft_defender_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agents/:agent_id/microsoft_defender_events(.:format)
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_agent_microsoft_defender_events_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"microsoft_defender_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agents/:agent_id/process_detections/:id(.:format)
 * @param {any} agent_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_agent_process_detection_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"process_detections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agents/:agent_id/process_events/:id(.:format)
 * @param {any} agent_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_agent_process_event_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"process_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agents/:agent_id/process_events(.:format)
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_agent_process_events_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"process_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agents/:agent_id/rio_surveys/*target_events(.:format)
 * @param {any} agent_id
 * @param {any} target_events
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_agent_rio_survey_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"target_events":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"rio_surveys"],[2,[7,"/"],[2,[5,[3,"target_events"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agents/:agent_id/rio_surveys(.:format)
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_agent_rio_surveys_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"rio_surveys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agents/:agent_id/surveys/:date/:time(.:format)
 * @param {any} agent_id
 * @param {any} date
 * @param {any} time
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_agent_survey_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"date":{"r":true},"time":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"surveys"],[2,[7,"/"],[2,[3,"date"],[2,[7,"/"],[2,[3,"time"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agents/:agent_id/surveys(.:format)
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_agent_surveys_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"surveys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agents/:agent_id/tasks/:id(.:format)
 * @param {any} agent_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_agent_task_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agents/:agent_id/tasks(.:format)
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_agent_tasks_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agents/:agent_id/turbo_mode(.:format)
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_agent_turbo_mode_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"turbo_mode"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agents/:agent_id/user_accounts(.:format)
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_agent_user_accounts_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"user_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agents/:agent_id/user_logon_events(.:format)
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_agent_user_logon_events_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"user_logon_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agentic/configuration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_agentic_configuration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agentic"],[2,[7,"/"],[2,[6,"configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agentic/conversations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_agentic_conversation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agentic"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agentic/conversations/:conversation_id/chats/:id(.:format)
 * @param {any} conversation_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_agentic_conversation_chat_path = /*#__PURE__*/ __jsr.r({"conversation_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agentic"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[2,[6,"chats"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agentic/conversations/:conversation_id/chats(.:format)
 * @param {any} conversation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_agentic_conversation_chats_path = /*#__PURE__*/ __jsr.r({"conversation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agentic"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[2,[6,"chats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agentic/conversations/:conversation_id/messages/:id(.:format)
 * @param {any} conversation_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_agentic_conversation_message_path = /*#__PURE__*/ __jsr.r({"conversation_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agentic"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agentic/conversations/:conversation_id/messages(.:format)
 * @param {any} conversation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_agentic_conversation_messages_path = /*#__PURE__*/ __jsr.r({"conversation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agentic"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agentic/conversations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_agentic_conversations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agentic"],[2,[7,"/"],[2,[6,"conversations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agentic/investigations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_agentic_investigation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agentic"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agentic/investigations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_agentic_investigations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agentic"],[2,[7,"/"],[2,[6,"investigations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agentic/prompts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_agentic_prompt_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agentic"],[2,[7,"/"],[2,[6,"prompts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agentic/prompts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_agentic_prompts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agentic"],[2,[7,"/"],[2,[6,"prompts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/email_security/mailboxes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_email_security_mailbox_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"email_security"],[2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/email_security/mailboxes/:mailbox_id/message_groups/:id(.:format)
 * @param {any} mailbox_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_email_security_mailbox_message_group_path = /*#__PURE__*/ __jsr.r({"mailbox_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"email_security"],[2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[3,"mailbox_id"],[2,[7,"/"],[2,[6,"message_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/email_security/mailboxes/:mailbox_id/message_groups/:message_group_id/close_as_benign(.:format)
 * @param {any} mailbox_id
 * @param {any} message_group_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_email_security_mailbox_message_group_close_as_benign_path = /*#__PURE__*/ __jsr.r({"mailbox_id":{"r":true},"message_group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"email_security"],[2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[3,"mailbox_id"],[2,[7,"/"],[2,[6,"message_groups"],[2,[7,"/"],[2,[3,"message_group_id"],[2,[7,"/"],[2,[6,"close_as_benign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/email_security/mailboxes/:mailbox_id/message_groups/:message_group_id/close_as_spam(.:format)
 * @param {any} mailbox_id
 * @param {any} message_group_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_email_security_mailbox_message_group_close_as_spam_path = /*#__PURE__*/ __jsr.r({"mailbox_id":{"r":true},"message_group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"email_security"],[2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[3,"mailbox_id"],[2,[7,"/"],[2,[6,"message_groups"],[2,[7,"/"],[2,[3,"message_group_id"],[2,[7,"/"],[2,[6,"close_as_spam"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/email_security/mailboxes/:mailbox_id/messages/:message_id/preview(.:format)
 * @param {any} mailbox_id
 * @param {any} message_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_email_security_mailbox_message_preview_path = /*#__PURE__*/ __jsr.r({"mailbox_id":{"r":true},"message_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"email_security"],[2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[3,"mailbox_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"message_id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/feedbacks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_feedback_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"feedbacks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/feedbacks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_feedbacks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"feedbacks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/infection_report_signals/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_infection_report_signal_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"infection_report_signals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_investigation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigation/epochs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_investigation_all_epochs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigation"],[2,[7,"/"],[2,[6,"epochs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/epochs/:id(.:format)
 * @param {any} investigation_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_investigation_epoch_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"epochs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/epochs/:epoch_id/communications/:id(.:format)
 * @param {any} investigation_id
 * @param {any} epoch_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_investigation_epoch_communication_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"epoch_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"epochs"],[2,[7,"/"],[2,[3,"epoch_id"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/epochs/:epoch_id/communications/:communication_id/delivery(.:format)
 * @param {any} investigation_id
 * @param {any} epoch_id
 * @param {any} communication_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_investigation_epoch_communication_delivery_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"epoch_id":{"r":true},"communication_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"epochs"],[2,[7,"/"],[2,[3,"epoch_id"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[3,"communication_id"],[2,[7,"/"],[2,[6,"delivery"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/epochs/:epoch_id/communications(.:format)
 * @param {any} investigation_id
 * @param {any} epoch_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_investigation_epoch_communications_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"epoch_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"epochs"],[2,[7,"/"],[2,[3,"epoch_id"],[2,[7,"/"],[2,[6,"communications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/epochs/:epoch_id/delivery(.:format)
 * @param {any} investigation_id
 * @param {any} epoch_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_investigation_epoch_delivery_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"epoch_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"epochs"],[2,[7,"/"],[2,[3,"epoch_id"],[2,[7,"/"],[2,[6,"delivery"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/epochs/:epoch_id/entities/:entity_id/isolation(.:format)
 * @param {any} investigation_id
 * @param {any} epoch_id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_investigation_epoch_entity_isolation_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"epoch_id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"epochs"],[2,[7,"/"],[2,[3,"epoch_id"],[2,[7,"/"],[2,[6,"entities"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[6,"isolation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/epochs/:epoch_id/response_plans/:id(.:format)
 * @param {any} investigation_id
 * @param {any} epoch_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_investigation_epoch_response_plan_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"epoch_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"epochs"],[2,[7,"/"],[2,[3,"epoch_id"],[2,[7,"/"],[2,[6,"response_plans"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/epochs/:epoch_id/response_plans/:response_plan_id/remediations/:id(.:format)
 * @param {any} investigation_id
 * @param {any} epoch_id
 * @param {any} response_plan_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_investigation_epoch_response_plan_remediation_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"epoch_id":{"r":true},"response_plan_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"epochs"],[2,[7,"/"],[2,[3,"epoch_id"],[2,[7,"/"],[2,[6,"response_plans"],[2,[7,"/"],[2,[3,"response_plan_id"],[2,[7,"/"],[2,[6,"remediations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/epochs/:epoch_id/response_plans/:response_plan_id/remediations(.:format)
 * @param {any} investigation_id
 * @param {any} epoch_id
 * @param {any} response_plan_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_investigation_epoch_response_plan_remediations_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"epoch_id":{"r":true},"response_plan_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"epochs"],[2,[7,"/"],[2,[3,"epoch_id"],[2,[7,"/"],[2,[6,"response_plans"],[2,[7,"/"],[2,[3,"response_plan_id"],[2,[7,"/"],[2,[6,"remediations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/epochs/:epoch_id/response_plans(.:format)
 * @param {any} investigation_id
 * @param {any} epoch_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_investigation_epoch_response_plans_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"epoch_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"epochs"],[2,[7,"/"],[2,[3,"epoch_id"],[2,[7,"/"],[2,[6,"response_plans"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/epochs(.:format)
 * @param {any} investigation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_investigation_epochs_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"epochs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/investigation_notes/:id(.:format)
 * @param {any} investigation_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_investigation_investigation_note_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"investigation_notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/investigation_notes(.:format)
 * @param {any} investigation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_investigation_investigation_notes_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"investigation_notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/signals(.:format)
 * @param {any} investigation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_investigation_signals_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"signals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/threat_indicators/:id(.:format)
 * @param {any} investigation_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_investigation_threat_indicator_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"threat_indicators"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/threat_indicators(.:format)
 * @param {any} investigation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_investigation_threat_indicators_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"threat_indicators"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/workflows(.:format)
 * @param {any} investigation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_investigation_workflows_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"workflows"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_investigations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/qc/reviews/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_qc_review_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"qc"],[2,[7,"/"],[2,[6,"reviews"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/qc/reviews/:review_id/comments(.:format)
 * @param {any} review_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_qc_review_comments_path = /*#__PURE__*/ __jsr.r({"review_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"qc"],[2,[7,"/"],[2,[6,"reviews"],[2,[7,"/"],[2,[3,"review_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/qc/reviews(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_qc_reviews_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"qc"],[2,[7,"/"],[2,[6,"reviews"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/signals/assignment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_signals_assignment_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[6,"assignment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/staff_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_staff_group_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"staff_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/staff_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_soc_staff_groups_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"staff_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscriptions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_subscription_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/tasks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_tasks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/terms_of_service/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_terms_of_service_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"terms_of_service"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/terms_of_service(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_terms_of_service_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"terms_of_service"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/threats/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_threat_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threats"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/threats/:threat_id/detection_rules(.:format)
 * @param {any} threat_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_threat_detection_rules_path = /*#__PURE__*/ __jsr.r({"threat_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threats"],[2,[7,"/"],[2,[3,"threat_id"],[2,[7,"/"],[2,[6,"detection_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/threatops(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_threatops_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threatops"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/threatops/analyst_notes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_threatops_analyst_note_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"analyst_notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/threatops/analyst_notes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_threatops_analyst_notes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"analyst_notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/threatops/detections/microsoft_defender(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_threatops_detections_microsoft_defender_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"detections"],[2,[7,"/"],[2,[6,"microsoft_defender"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/threatops/detections/microsoft_defender_detection_sets/:microsoft_defender_detection_set_priority/event_mappings/:uuid(.:format)
 * @param {any} microsoft_defender_detection_set_priority
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_threatops_detections_microsoft_defender_detection_set_event_mapping_path = /*#__PURE__*/ __jsr.r({"microsoft_defender_detection_set_priority":{"r":true},"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"detections"],[2,[7,"/"],[2,[6,"microsoft_defender_detection_sets"],[2,[7,"/"],[2,[3,"microsoft_defender_detection_set_priority"],[2,[7,"/"],[2,[6,"event_mappings"],[2,[7,"/"],[2,[3,"uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/threatops/detections/microsoft_defender_detection_sets/:microsoft_defender_detection_set_priority/event_mappings(.:format)
 * @param {any} microsoft_defender_detection_set_priority
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_threatops_detections_microsoft_defender_detection_set_event_mappings_path = /*#__PURE__*/ __jsr.r({"microsoft_defender_detection_set_priority":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"detections"],[2,[7,"/"],[2,[6,"microsoft_defender_detection_sets"],[2,[7,"/"],[2,[3,"microsoft_defender_detection_set_priority"],[2,[7,"/"],[2,[6,"event_mappings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/threatops/detectors/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_threatops_detector_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"detectors"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/threatops/detectors/:detector_id/detections/:id(.:format)
 * @param {any} detector_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_threatops_detector_detection_path = /*#__PURE__*/ __jsr.r({"detector_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"detectors"],[2,[7,"/"],[2,[3,"detector_id"],[2,[7,"/"],[2,[6,"detections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/threatops/detectors/:detector_id/detections(.:format)
 * @param {any} detector_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_threatops_detector_detections_path = /*#__PURE__*/ __jsr.r({"detector_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"detectors"],[2,[7,"/"],[2,[3,"detector_id"],[2,[7,"/"],[2,[6,"detections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/threatops/detectors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_threatops_detectors_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"detectors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/threatops/emotet_names(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_threatops_emotet_names_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"emotet_names"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/threatops/event_schemas(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_threatops_event_schemas_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"event_schemas"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/threatops/logs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_threatops_logs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/threatops/logs/authentication_failures(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_threatops_logs_authentication_failures_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"authentication_failures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/threatops/logs/authentication_failures/sources/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_threatops_logs_authentication_failures_source_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"authentication_failures"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/threatops/trickbot_names(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_threatops_trickbot_names_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"trickbot_names"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/threats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_threats_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threats"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/tracked_services/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_tracked_service_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tracked_services"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/trq/autorun_reviews/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_trq_autorun_review_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"trq"],[2,[7,"/"],[2,[6,"autorun_reviews"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/trq/autorun_reviews/:autorun_review_id/agents/:id(.:format)
 * @param {any} autorun_review_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_trq_autorun_review_agent_path = /*#__PURE__*/ __jsr.r({"autorun_review_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"trq"],[2,[7,"/"],[2,[6,"autorun_reviews"],[2,[7,"/"],[2,[3,"autorun_review_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/trq/autorun_review_bulk_actions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_trq_autorun_review_bulk_actions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"trq"],[2,[7,"/"],[2,[6,"autorun_review_bulk_actions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/trq/autorun_reviews(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_trq_autorun_reviews_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"trq"],[2,[7,"/"],[2,[6,"autorun_reviews"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/user_notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_user_notifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"user_notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/windows_event_log_configs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_windows_event_log_config_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"windows_event_log_configs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/windows_event_log_configs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_windows_event_log_configs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"windows_event_log_configs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/threatops/agent_lookup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agent_lookup_admin_threatops_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"agent_lookup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/endpoint_logs/org/:organization_id/:platform_type/agent_table(.:format)
 * @param {any} organization_id
 * @param {any} platform_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agent_table_account_logs_sources_endpoint_logs_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"platform_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"endpoint_logs"],[2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[3,"platform_type"],[2,[7,"/"],[2,[6,"agent_table"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/data_archives/agents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agents_account_data_archives_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"data_archives"],[2,[7,"/"],[2,[6,"agents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/screen_connect_agent_hosts/agents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agents_account_screen_connect_agent_hosts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"screen_connect_agent_hosts"],[2,[7,"/"],[2,[6,"agents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/windows_events/agents_drawer/:organization_id(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agents_drawer_account_logs_sources_windows_events_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"windows_events"],[2,[7,"/"],[2,[6,"agents_drawer"],[2,[7,"/"],[2,[3,"organization_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/windows_events/agents_drawer_table/:organization_id(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agents_drawer_table_account_logs_sources_windows_events_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"windows_events"],[2,[7,"/"],[2,[6,"agents_drawer_table"],[2,[7,"/"],[2,[3,"organization_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/screen_connect_agent_hosts/agents(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agents_organization_screen_connect_agent_hosts_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"screen_connect_agent_hosts"],[2,[7,"/"],[2,[6,"agents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/windows_events/agents_table(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agents_table_organization_logs_sources_windows_events_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"windows_events"],[2,[7,"/"],[2,[6,"agents_table"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/unwanted_access/rules/ajax_modal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ajax_modal_account_rules_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"unwanted_access"],[2,[7,"/"],[2,[6,"rules"],[2,[7,"/"],[2,[6,"ajax_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/unwanted_access/rules/ajax_modal(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ajax_modal_organization_rules_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"unwanted_access"],[2,[7,"/"],[2,[6,"rules"],[2,[7,"/"],[2,[6,"ajax_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/threatops/logs/alerts/:alert_id/firings(.:format)
 * @param {any} alert_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alert_firings_account_threatops_logs_path = /*#__PURE__*/ __jsr.r({"alert_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"alerts"],[2,[7,"/"],[2,[3,"alert_id"],[2,[7,"/"],[2,[6,"firings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/threatops/logs/alerts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alerts_account_threatops_logs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"alerts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/threatops/logs/analyze(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analyze_account_threatops_logs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"analyze"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/antivirus_dashboard_active_incidents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const antivirus_dashboard_active_incidents_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"antivirus_dashboard_active_incidents"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/antivirus_dashboard_defender_health(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const antivirus_dashboard_defender_health_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"antivirus_dashboard_defender_health"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/antivirus_dashboard_resolved_incidents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const antivirus_dashboard_resolved_incidents_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"antivirus_dashboard_resolved_incidents"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/antivirus_dashboard_signals_investigated(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const antivirus_dashboard_signals_investigated_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"antivirus_dashboard_signals_investigated"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/*unmatched_route(.:format)
 * @param {any} unmatched_route
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_path = /*#__PURE__*/ __jsr.r({"unmatched_route":{"r":true},"format":{"d":"json"},"subdomain":{"d":"agent"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[5,[3,"unmatched_route"]],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/agents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_agent_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"agent"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/agents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_agents_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"agent"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"agents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/integrations/syncro(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_integrations_syncro_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"agent"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"syncro"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/logs/uploads/:log_time(.:format)
 * @param {any} log_time
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_logs_upload_path = /*#__PURE__*/ __jsr.r({"log_time":{"r":true},"format":{"d":"json"},"subdomain":{"d":"agent"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[3,"log_time"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/logs/uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_logs_uploads_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"agent"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/logs/windows_audit_config(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_logs_windows_audit_config_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"agent"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"windows_audit_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/mayday(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_mayday_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"agent"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"mayday"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/monitored_directories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_monitored_directories_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"agent"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"monitored_directories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/monitored_files(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_monitored_files_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"agent"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"monitored_files"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/monitored_registry_keys(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_monitored_registry_keys_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"agent"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"monitored_registry_keys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ping(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_ping_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"agent"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ping"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/rio/events/:rio_time(.:format)
 * @param {any} rio_time
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_rio_event_path = /*#__PURE__*/ __jsr.r({"rio_time":{"r":true},"format":{"d":"json"},"subdomain":{"d":"agent"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"rio"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"rio_time"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/rio/events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_rio_events_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"agent"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"rio"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/rio/sync(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_rio_sync_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"agent"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"rio"],[2,[7,"/"],[2,[6,"sync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/surveys/:survey_time(.:format)
 * @param {any} survey_time
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_survey_path = /*#__PURE__*/ __jsr.r({"survey_time":{"r":true},"format":{"d":"json"},"subdomain":{"d":"agent"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"surveys"],[2,[7,"/"],[2,[3,"survey_time"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/surveys(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_surveys_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"agent"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"surveys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/tasks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"agent"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_tasks_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"agent"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/tracked_services(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_tracked_services_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"agent"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tracked_services"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/updates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_updates_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"agent"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"updates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /apok/signals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apok_signals_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apok"],[2,[7,"/"],[2,[6,"signals"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /apok/v2/signals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apok_v2_signals_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apok"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"signals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/espm/app_control/microsoft_apps/:id/approve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_account_espm_app_control_microsoft_app_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"app_control"],[2,[7,"/"],[2,[6,"microsoft_apps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/espm/app_control/rmm_tools/:id/approve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_account_espm_app_control_rmm_tool_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"app_control"],[2,[7,"/"],[2,[6,"rmm_tools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/espm/app_control/signing_certs/:id/approve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_account_espm_app_control_signing_cert_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"app_control"],[2,[7,"/"],[2,[6,"signing_certs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/espm/app_control/unsigned_executables/approve(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_account_espm_app_control_unsigned_executables_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"app_control"],[2,[7,"/"],[2,[6,"unsigned_executables"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/espm/app_control/unsigned_files/:id/approve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_account_espm_app_control_unsigned_file_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"app_control"],[2,[7,"/"],[2,[6,"unsigned_files"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/infection_reports/:infection_report_id/remediations/approve(.:format)
 * @param {any} infection_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_account_infection_report_remediations_path = /*#__PURE__*/ __jsr.r({"infection_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"remediations"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/espm/app_control/signing_certs/:id/approve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_admin_espm_app_control_signing_cert_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"app_control"],[2,[7,"/"],[2,[6,"signing_certs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/espm/rmm_tool_candidates/:id/approve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_admin_espm_rmm_tool_candidate_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"rmm_tool_candidates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/epochs/:epoch_id/response_plans/:id/approve(.:format)
 * @param {any} investigation_id
 * @param {any} epoch_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_admin_soc_investigation_epoch_response_plan_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"epoch_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"epochs"],[2,[7,"/"],[2,[3,"epoch_id"],[2,[7,"/"],[2,[6,"response_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscriptions/:id/approve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_admin_subscription_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/infection_reports/:infection_report_id/remediations/approve(.:format)
 * @param {any} organization_id
 * @param {any} infection_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_organization_infection_report_remediations_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"infection_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"remediations"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /partners/investigations/:investigation_id/response_plans/:id/approve(.:format)
 * @param {any} investigation_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_partners_investigation_response_plan_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"response_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /artemis(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artemis_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"artemis"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /artemis_toggle(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artemis_toggle_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"artemis_toggle"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/infection_reports/:id/assign(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assign_admin_infection_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/signals/:id/assign(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assign_admin_signal_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/infection_reports/:id/assign_modal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assign_modal_admin_infection_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assign_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/signals/:id/assign_modal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assign_modal_admin_signal_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assign_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/showcases/validations/attempt(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attempt_admin_showcases_validations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"showcases"],[2,[7,"/"],[2,[6,"validations"],[2,[7,"/"],[2,[6,"attempt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:id/authorize_network_filter_modal(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authorize_network_filter_modal_organization_agent_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"authorize_network_filter_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:id/authorize_network_filter(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authorize_network_filter_organization_agent_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"authorize_network_filter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:id/auto_close(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_close_admin_soc_investigation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"auto_close"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/:id/auto_map(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_map_account_integration_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"auto_map"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:id/auto_report(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_report_admin_soc_investigation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"auto_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /aws/cloudformation_templates/:template_name(.:format)
 * @param {any} template_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aws_cloudformation_template_path = /*#__PURE__*/ __jsr.r({"template_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"aws"],[2,[7,"/"],[2,[6,"cloudformation_templates"],[2,[7,"/"],[2,[3,"template_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /aws/sns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aws_sns_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"aws"],[2,[7,"/"],[2,[6,"sns"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /azure/arm_templates/:template_name(.:format)
 * @param {any} template_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const azure_arm_template_path = /*#__PURE__*/ __jsr.r({"template_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"azure"],[2,[7,"/"],[2,[6,"arm_templates"],[2,[7,"/"],[2,[3,"template_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /azure/blob_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const azure_blob_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"azure"],[2,[7,"/"],[2,[6,"blob_events"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /azure/diagnostic_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const azure_diagnostic_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"azure"],[2,[7,"/"],[2,[6,"diagnostic_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /azure/diagnostic_scripts/:name(.:format)
 * @param {any} name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const azure_diagnostic_script_path = /*#__PURE__*/ __jsr.r({"name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"azure"],[2,[7,"/"],[2,[6,"diagnostic_scripts"],[2,[7,"/"],[2,[3,"name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /azure/marketplace_webhooks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const azure_marketplace_webhooks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"azure"],[2,[7,"/"],[2,[6,"marketplace_webhooks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /multi_factor/setup/backup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backup_user_multi_factor_setup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"multi_factor"],[2,[7,"/"],[2,[6,"setup"],[2,[7,"/"],[2,[6,"backup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/organizations/:id/billable_identities_drawer(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billable_identities_drawer_account_organization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"billable_identities_drawer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/billing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billing_resellers_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:id/binaries(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const binaries_organization_agent_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"binaries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/antivirus_exclusions/bulk_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_action_account_antivirus_exclusions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"antivirus_exclusions"],[2,[7,"/"],[2,[6,"bulk_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/antivirus_exclusions/settings/bulk_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_action_account_antivirus_exclusions_settings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"antivirus_exclusions"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"bulk_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/antivirus_exclusions/bulk_action(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_action_organization_antivirus_exclusions_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"antivirus_exclusions"],[2,[7,"/"],[2,[6,"bulk_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/antivirus_exclusions/settings/bulk_action(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_action_organization_antivirus_exclusions_settings_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"antivirus_exclusions"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"bulk_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /salesforce/subscriptions/bulk_complete(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_complete_salesforce_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"salesforce"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"bulk_complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agents/:agent_id/turbo_mode/bulk_create(.:format)
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_create_admin_soc_agent_turbo_mode_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"turbo_mode"],[2,[7,"/"],[2,[6,"bulk_create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/tasks/bulk_create(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_create_admin_tasks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"bulk_create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /salesforce/subscriptions/bulk_create(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_create_salesforce_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"salesforce"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"bulk_create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /salesforce/trials/bulk_create(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_create_salesforce_trials_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"salesforce"],[2,[7,"/"],[2,[6,"trials"],[2,[7,"/"],[2,[6,"bulk_create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agent_rollouts/bulk_delete(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_delete_admin_agent_rollouts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agent_rollouts"],[2,[7,"/"],[2,[6,"bulk_delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /salesforce/subscriptions/bulk_delete(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_delete_salesforce_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"salesforce"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"bulk_delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/organizations/bulk_isolate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_isolate_account_organizations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"bulk_isolate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/organizations/bulk_isolate_modal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_isolate_modal_account_organizations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"bulk_isolate_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/binaries/bulk_lookup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_lookup_admin_binaries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"binaries"],[2,[7,"/"],[2,[6,"bulk_lookup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agent_rollouts/bulk_pause(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_pause_admin_agent_rollouts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agent_rollouts"],[2,[7,"/"],[2,[6,"bulk_pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/organizations/bulk_release(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_release_account_organizations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"bulk_release"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/signals/bulk_release(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_release_admin_signals_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[6,"bulk_release"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/organizations/bulk_release_modal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_release_modal_account_organizations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"bulk_release_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/infection_reports/bulk_resolve(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_resolve_account_infection_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[6,"bulk_resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/infection_reports/bulk_resolve_modal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_resolve_modal_account_infection_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[6,"bulk_resolve_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/infection_reports/bulk_resolve_modal(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_resolve_modal_organization_infection_reports_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[6,"bulk_resolve_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/infection_reports/bulk_resolve(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_resolve_organization_infection_reports_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[6,"bulk_resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agent_rollouts/bulk_start(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_start_admin_agent_rollouts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agent_rollouts"],[2,[7,"/"],[2,[6,"bulk_start"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/rules/bulk_toggle_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_toggle_status_admin_rules_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"rules"],[2,[7,"/"],[2,[6,"bulk_toggle_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/autorun_entries/bulk_unapprove(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_unapprove_admin_autorun_entries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"autorun_entries"],[2,[7,"/"],[2,[6,"bulk_unapprove"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/organizations/:id/bulk_unblock(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_unblock_account_organization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"bulk_unblock"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/organizations/:id/bulk_unblock_modal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_unblock_modal_account_organization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"bulk_unblock_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/agents/bulk_uninstall(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_uninstall_account_agents_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"bulk_uninstall"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/agents/bulk_uninstall_modal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_uninstall_modal_account_agents_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"bulk_uninstall_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/bulk_uninstall_modal(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_uninstall_modal_organization_agents_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"bulk_uninstall_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/bulk_uninstall(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_uninstall_organization_agents_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"bulk_uninstall"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/agents/bulk_update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_update_account_agents_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"bulk_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/antiviruses/bulk_update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_update_account_antiviruses_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"antiviruses"],[2,[7,"/"],[2,[6,"bulk_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/autorun_entries/bulk_update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_update_admin_autorun_entries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"autorun_entries"],[2,[7,"/"],[2,[6,"bulk_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/threat_indicators/bulk_update(.:format)
 * @param {any} investigation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_update_admin_soc_investigation_threat_indicators_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"threat_indicators"],[2,[7,"/"],[2,[6,"bulk_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/windows_events/bulk_update_agents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_update_agents_account_logs_sources_windows_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"windows_events"],[2,[7,"/"],[2,[6,"bulk_update_agents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/windows_events/bulk_update_agents(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_update_agents_organization_logs_sources_windows_events_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"windows_events"],[2,[7,"/"],[2,[6,"bulk_update_agents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/bulk_update(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_update_organization_agents_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"bulk_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/antiviruses/bulk_update(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_update_organization_antiviruses_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"antiviruses"],[2,[7,"/"],[2,[6,"bulk_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/windows_events/bulk_update_organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_update_organizations_account_logs_sources_windows_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"windows_events"],[2,[7,"/"],[2,[6,"bulk_update_organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/billing/health/by_error(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const by_error_admin_billing_health_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"health"],[2,[7,"/"],[2,[6,"by_error"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/invoices/cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_account_invoices_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/rehydrations/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_account_logs_rehydration_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"rehydrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_identity/organizations/:organization_id/excluded_organizational_units/cancel(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_admin_managed_identity_organization_excluded_organizational_units_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"excluded_organizational_units"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agents/:id/cancel_isolation(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_isolation_admin_soc_agent_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel_isolation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:id/cancel_isolation(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_isolation_organization_agent_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel_isolation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/epochs/:epoch_id/response_plans/:id/cancel_remaining(.:format)
 * @param {any} investigation_id
 * @param {any} epoch_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_remaining_admin_soc_investigation_epoch_response_plan_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"epoch_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"epochs"],[2,[7,"/"],[2,[3,"epoch_id"],[2,[7,"/"],[2,[6,"response_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel_remaining"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /register/cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"register"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/agents/:agent_id/tasks/canned(.:format)
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const canned_admin_agent_tasks_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"canned"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agents/:agent_id/tasks/canned(.:format)
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const canned_admin_soc_agent_tasks_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"canned"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/espm/app_control/rmm_tools/catalog(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const catalog_account_espm_app_control_rmm_tools_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"app_control"],[2,[7,"/"],[2,[6,"rmm_tools"],[2,[7,"/"],[2,[6,"catalog"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/unwanted_access/rules/catchall_excepted_organizations_grid(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const catchall_excepted_organizations_grid_account_rules_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"unwanted_access"],[2,[7,"/"],[2,[6,"rules"],[2,[7,"/"],[2,[6,"catchall_excepted_organizations_grid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/billing/health/:id/check_health(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_health_admin_billing_health_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"health"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"check_health"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/tasks/:id/child_tasks(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const child_tasks_admin_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"child_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/signals/claim(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claim_admin_signals_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[6,"claim"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:id/claim(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claim_admin_soc_investigation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"claim"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/halo_psa/:id/clients(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clients_account_integrations_halo_psa_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"halo_psa"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/infection_reports/:id/close(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const close_admin_infection_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"close"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/signals/close(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const close_admin_signals_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[6,"close"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:id/close(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const close_admin_soc_investigation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"close"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:id/collected_files(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const collected_files_organization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"collected_files"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:id/collected_files(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const collected_files_organization_agent_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"collected_files"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/marketing_assets/collection/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const collection_account_marketing_assets_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"marketing_assets"],[2,[7,"/"],[2,[6,"collection"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/marketing_assets/collection/:slug(.:format)
 * @param {any} reseller_id
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const collection_reseller_marketing_assets_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"slug":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"marketing_assets"],[2,[7,"/"],[2,[6,"collection"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/command_center(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const command_center_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"command_center"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/command_center_active_incidents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const command_center_active_incidents_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"command_center_active_incidents"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/command_center_agents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const command_center_agents_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"command_center_agents"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/command_center_antivirus(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const command_center_antivirus_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"command_center_antivirus"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/command_center_escalations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const command_center_escalations_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"command_center_escalations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/command_center_escalations_widget(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const command_center_escalations_widget_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"command_center_escalations_widget"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/command_center_explore_trial_panel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const command_center_explore_trial_panel_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"command_center_explore_trial_panel"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/command_center_firewall(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const command_center_firewall_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"command_center_firewall"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/command_center_incidents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const command_center_incidents_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"command_center_incidents"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/command_center_macos_agent_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const command_center_macos_agent_status_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"command_center_macos_agent_status"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/command_center_macos_agent_status_banner(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const command_center_macos_agent_status_banner_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"command_center_macos_agent_status_banner"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/command_center_mde_agent_coverage_widget(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const command_center_mde_agent_coverage_widget_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"command_center_mde_agent_coverage_widget"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/command_center_mde_agent_health_widget(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const command_center_mde_agent_health_widget_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"command_center_mde_agent_health_widget"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/command_center_mde_tenant_health_widget(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const command_center_mde_tenant_health_widget_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"command_center_mde_tenant_health_widget"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/command_center_mde_widget(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const command_center_mde_widget_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"command_center_mde_widget"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/command_center_mfa(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const command_center_mfa_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"command_center_mfa"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/command_center_sat_active_learners(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const command_center_sat_active_learners_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"command_center_sat_active_learners"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/command_center_screen_connect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const command_center_screen_connect_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"command_center_screen_connect"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/command_center_security_operations_center_actions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const command_center_security_operations_center_actions_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"command_center_security_operations_center_actions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/command_center_stat_counts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const command_center_stat_counts_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"command_center_stat_counts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/command_center_triage_feed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const command_center_triage_feed_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"command_center_triage_feed"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/command_center_user_entities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const command_center_user_entities_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"command_center_user_entities"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/escalations/:id/comment(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comment_account_escalation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"escalations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"comment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/escalations/:id/comment(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comment_admin_escalation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"escalations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"comment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/escalations/:id/comment(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comment_organization_escalation_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"escalations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"comment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/autotask/:id/companies(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companies_account_integrations_autotask_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"autotask"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"companies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/bms/:id/companies(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companies_account_integrations_bms_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"bms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"companies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/connect_wise/:id/companies(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companies_account_integrations_connect_wise_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"connect_wise"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"companies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/syncro/:id/companies(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companies_account_integrations_syncro_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"syncro"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"companies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/accounts/:account_id/aggregator_subscriptions/:id/complete(.:format)
 * @param {any} reseller_id
 * @param {any} account_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const complete_reseller_account_aggregator_subscription_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"account_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"aggregator_subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agents/completed_installations_grid(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const completed_installations_grid_admin_agents_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"completed_installations_grid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/autotask/:id/configure(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const configure_account_integrations_autotask_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"autotask"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"configure"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/bms/:id/configure(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const configure_account_integrations_bms_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"bms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"configure"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/connect_wise/:id/configure(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const configure_account_integrations_connect_wise_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"connect_wise"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"configure"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/halo_psa/:id/configure(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const configure_account_integrations_halo_psa_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"halo_psa"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"configure"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/microsoft_defender_tenants/configure(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const configure_account_integrations_microsoft_defender_tenants_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"microsoft_defender_tenants"],[2,[7,"/"],[2,[6,"configure"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/service_now/:id/configure(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const configure_account_integrations_service_now_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"service_now"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"configure"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/syncro/:id/configure(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const configure_account_integrations_syncro_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"syncro"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"configure"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/webhooks/:id/configure(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const configure_account_integrations_webhook_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"configure"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/datto_rmms/:id/configure(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const configure_account_logs_sources_datto_rmm_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"datto_rmms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"configure"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/meraki_clouds/:id/configure(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const configure_account_logs_sources_meraki_cloud_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"meraki_clouds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"configure"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/sentinel_one_syslogs/:id/configure(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const configure_account_logs_sources_sentinel_one_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"sentinel_one_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"configure"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/infection_reports/:infection_report_id/sat_assignments/:id/configure_in_sat_status(.:format)
 * @param {any} infection_report_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const configure_in_sat_status_account_infection_report_sat_assignment_path = /*#__PURE__*/ __jsr.r({"infection_report_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"sat_assignments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"configure_in_sat_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/microsoft_defender_tenants/:id/confirm(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_account_integrations_microsoft_defender_tenant_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"microsoft_defender_tenants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/redfigs/:id/confirm(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_admin_redfig_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"redfigs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/threatops/detections/microsoft_defender_detection_sets/:microsoft_defender_detection_set_priority/event_mappings/:uuid/confirm(.:format)
 * @param {any} microsoft_defender_detection_set_priority
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_admin_threatops_detections_microsoft_defender_detection_set_event_mapping_path = /*#__PURE__*/ __jsr.r({"microsoft_defender_detection_set_priority":{"r":true},"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"detections"],[2,[7,"/"],[2,[6,"microsoft_defender_detection_sets"],[2,[7,"/"],[2,[3,"microsoft_defender_detection_set_priority"],[2,[7,"/"],[2,[6,"event_mappings"],[2,[7,"/"],[2,[3,"uuid"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /multi_factor/setup/confirm_backup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_backup_user_multi_factor_setup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"multi_factor"],[2,[7,"/"],[2,[6,"setup"],[2,[7,"/"],[2,[6,"confirm_backup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:id/confirm_claim(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_claim_admin_soc_investigation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_claim"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/user_api_credentials/:id/confirm_delete(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_delete_account_user_api_credential_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"user_api_credentials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/api_credentials/:id/confirm_delete(.:format)
 * @param {any} reseller_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_delete_reseller_api_credential_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"api_credentials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/google/confirm_deletion(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_deletion_account_integrations_google_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"google"],[2,[7,"/"],[2,[6,"confirm_deletion"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/saml_provider/confirm_destroy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_destroy_account_saml_provider_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"saml_provider"],[2,[7,"/"],[2,[6,"confirm_destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/antivirus_exclusions/confirm_enforce_mode(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_enforce_mode_account_antivirus_exclusions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"antivirus_exclusions"],[2,[7,"/"],[2,[6,"confirm_enforce_mode"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/antivirus_exclusions/confirm_enforce_mode(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_enforce_mode_organization_antivirus_exclusions_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"antivirus_exclusions"],[2,[7,"/"],[2,[6,"confirm_enforce_mode"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/epochs/:id/confirm_resolve(.:format)
 * @param {any} investigation_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_resolve_admin_soc_investigation_epoch_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"epochs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /multi_factor/setup/confirm_totp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_totp_user_multi_factor_setup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"multi_factor"],[2,[7,"/"],[2,[6,"setup"],[2,[7,"/"],[2,[6,"confirm_totp"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /consolidated_terms_acceptance/:policy_type(.:format)
 * @param {any} policy_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const consolidated_terms_acceptance_path = /*#__PURE__*/ __jsr.r({"policy_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"consolidated_terms_acceptance"],[2,[7,"/"],[2,[3,"policy_type"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/autotask/:id/contracts(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contracts_account_integrations_autotask_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"autotask"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"contracts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agentic/investigations/:id/conversation(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const conversation_admin_soc_agentic_investigation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agentic"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"conversation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/persistence/:persistence_id/agents/count(.:format)
 * @param {any} persistence_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const count_admin_persistence_agents_path = /*#__PURE__*/ __jsr.r({"persistence_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"persistence"],[2,[7,"/"],[2,[3,"persistence_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/persistence/:persistence_id/agents/count(.:format)
 * @param {any} organization_id
 * @param {any} persistence_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const count_organization_persistence_agents_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"persistence_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"persistence"],[2,[7,"/"],[2,[3,"persistence_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/invoices/:id/counts(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const counts_account_invoice_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"counts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/invoices/:id/counts(.:format)
 * @param {any} reseller_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const counts_reseller_invoice_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"counts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/microsoft/create_direct_tenant_organization(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_direct_tenant_organization_account_integrations_cpv_mapping_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"microsoft"],[2,[7,"/"],[2,[6,"create_direct_tenant_organization"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/host_isolation_policies/create_exception(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_exception_account_host_isolation_policies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"host_isolation_policies"],[2,[7,"/"],[2,[6,"create_exception"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/host_isolation_policies/create_host_isolation_exception_modal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_host_isolation_exception_modal_account_host_isolation_policies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"host_isolation_policies"],[2,[7,"/"],[2,[6,"create_host_isolation_exception_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agents/:agent_id/tasks/create_multiple(.:format)
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_multiple_admin_agent_tasks_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"create_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/microsoft/create_onboarding_organization(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_onboarding_organization_account_integrations_cpv_mapping_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"microsoft"],[2,[7,"/"],[2,[6,"create_onboarding_organization"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/identity_providers/create_onboarding_organization(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_onboarding_organization_account_integrations_identity_providers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"identity_providers"],[2,[7,"/"],[2,[6,"create_onboarding_organization"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/microsoft/create_organization(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_organization_account_integrations_cpv_mapping_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"microsoft"],[2,[7,"/"],[2,[6,"create_organization"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/rules/create_rule_modal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_rule_modal_admin_rules_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"rules"],[2,[7,"/"],[2,[6,"create_rule_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/autotask/:id/create_test_ticket(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_test_ticket_account_integrations_autotask_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"autotask"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_test_ticket"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/bms/:id/create_test_ticket(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_test_ticket_account_integrations_bms_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"bms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_test_ticket"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/connect_wise/:id/create_test_ticket(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_test_ticket_account_integrations_connect_wise_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"connect_wise"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_test_ticket"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/halo_psa/:id/create_test_ticket(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_test_ticket_account_integrations_halo_psa_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"halo_psa"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_test_ticket"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/service_now/:id/create_test_ticket(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_test_ticket_account_integrations_service_now_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"service_now"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_test_ticket"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/syncro/:id/create_test_ticket(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_test_ticket_account_integrations_syncro_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"syncro"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_test_ticket"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /csp-violation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const csp_violation_path = /*#__PURE__*/ __jsr.r({"format":{"d":"csp_report"}}, [2,[7,"/"],[2,[6,"csp-violation"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /curricula
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const curricula_api_api_controller_path = /*#__PURE__*/ __jsr.r({"subdomain":{"d":"api"}}, [2,[7,"/"],[6,"curricula"]]);

/**
 * Generates rails route to
 * /account/infection_reports/:infection_report_id/sat_assignments/:id/curricula_assignment(.:format)
 * @param {any} infection_report_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const curricula_assignment_account_infection_report_sat_assignment_path = /*#__PURE__*/ __jsr.r({"infection_report_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"sat_assignments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"curricula_assignment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/infection_reports/:infection_report_id/sat_assignments/curricula_episode_preview(.:format)
 * @param {any} infection_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const curricula_episode_preview_account_infection_report_sat_assignments_path = /*#__PURE__*/ __jsr.r({"infection_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"sat_assignments"],[2,[7,"/"],[2,[6,"curricula_episode_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /download/darwin/:key(/:crap)(.:format)
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const darwin_installer_download_path = /*#__PURE__*/ __jsr.r({"key":{"r":true},"crap":{},"format":{}}, [2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[6,"darwin"],[2,[7,"/"],[2,[3,"key"],[2,[1,[2,[7,"/"],[3,"crap"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /script/darwin/:key(/:crap)(.:format)
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const darwin_script_download_path = /*#__PURE__*/ __jsr.r({"key":{"r":true},"crap":{},"format":{}}, [2,[7,"/"],[2,[6,"script"],[2,[7,"/"],[2,[6,"darwin"],[2,[7,"/"],[2,[3,"key"],[2,[1,[2,[7,"/"],[3,"crap"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/espm/app_control/rmm_tools/dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_account_espm_app_control_rmm_tools_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"app_control"],[2,[7,"/"],[2,[6,"rmm_tools"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/espm/app_control/rmm_tools/:id/dashboard_detail(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_detail_account_espm_app_control_rmm_tool_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"app_control"],[2,[7,"/"],[2,[6,"rmm_tools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dashboard_detail"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard_selector/accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_selector_accounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard_selector"],[2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboard_selector/organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_selector_organizations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard_selector"],[2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboard_selector/resellers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_selector_resellers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard_selector"],[2,[7,"/"],[2,[6,"resellers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/espm/app_control_events/data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_account_espm_app_control_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"app_control_events"],[2,[7,"/"],[2,[6,"data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/escalations/:id/datatable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datatable_account_escalation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"escalations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"datatable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/escalations/:id/datatable(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datatable_organization_escalation_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"escalations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"datatable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/threatops/logs/detections/:detection_id/activate(.:format)
 * @param {any} detection_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deactivate_detection_account_threatops_logs_path = /*#__PURE__*/ __jsr.r({"detection_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"detections"],[2,[7,"/"],[2,[3,"detection_id"],[2,[7,"/"],[2,[6,"activate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /partners/investigations/:investigation_id/response_plans/:id/decline(.:format)
 * @param {any} investigation_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const decline_partners_investigation_response_plan_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"response_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"decline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agent_releases/default_versions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const default_versions_admin_agent_releases_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agent_releases"],[2,[7,"/"],[2,[6,"default_versions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/malware_families/:id/delete(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_admin_malware_family_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"malware_families"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/threats/:id/delete(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_admin_threat_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threats"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/webhooks/:id/delete_endpoint(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_endpoint_account_integrations_webhook_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_endpoint"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/host_isolation_policies/delete_exception(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_exception_account_host_isolation_policies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"host_isolation_policies"],[2,[7,"/"],[2,[6,"delete_exception"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/infection_reports/:infection_report_id/comments/:id/delete_modal(.:format)
 * @param {any} infection_report_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_modal_account_infection_report_comment_path = /*#__PURE__*/ __jsr.r({"infection_report_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/member_invitations/:id/delete_modal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_modal_account_member_invitation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"member_invitations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/memberships/:id/delete_modal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_modal_account_membership_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/organizations/:id/delete_modal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_modal_account_organization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/infection_reports/:infection_report_id/comments/:id/delete_modal(.:format)
 * @param {any} infection_report_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_modal_admin_infection_report_comment_path = /*#__PURE__*/ __jsr.r({"infection_report_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/notification_contact/supported_countries/:id/delete_modal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_modal_admin_notification_contact_supported_country_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"notification_contact"],[2,[7,"/"],[2,[6,"supported_countries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/one_time_notifications/:id/delete_modal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_modal_admin_one_time_notification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"one_time_notifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/signals/:signal_id/comments/:id/delete_modal(.:format)
 * @param {any} signal_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_modal_admin_signal_comment_path = /*#__PURE__*/ __jsr.r({"signal_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[3,"signal_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/investigation_notes/:id/delete_modal(.:format)
 * @param {any} investigation_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_modal_admin_soc_investigation_investigation_note_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"investigation_notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/infection_reports/:infection_report_id/comments/:id/delete_modal(.:format)
 * @param {any} organization_id
 * @param {any} infection_report_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_modal_organization_infection_report_comment_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"infection_report_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/member_invitations/:id/delete_modal(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_modal_organization_member_invitation_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"member_invitations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/memberships/:id/delete_modal(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_modal_organization_membership_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/investigation_notes/:id/delete_screenshot(.:format)
 * @param {any} investigation_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_screenshot_admin_soc_investigation_investigation_note_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"investigation_notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_screenshot"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/investigation_notes/:id/delete_screenshot_modal(.:format)
 * @param {any} investigation_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_screenshot_modal_admin_soc_investigation_investigation_note_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"investigation_notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_screenshot_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /multi_factor/recovery/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_user_multi_factor_recovery_path = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"multi_factor"],[2,[7,"/"],[2,[6,"recovery"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/sales_contact_requests/demo_create(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const demo_create_account_sales_contact_requests_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"sales_contact_requests"],[2,[7,"/"],[2,[6,"demo_create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/sales_contact_requests/new/demo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const demo_new_account_sales_contact_request_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"sales_contact_requests"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[6,"demo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_identity/organizations/:id/deploy_railway_rapid_response_cap(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deploy_railway_rapid_response_cap_admin_managed_identity_organization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"deploy_railway_rapid_response_cap"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/threatops/logs/alerts/:alert_id(.:format)
 * @param {any} alert_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_alert_account_threatops_logs_path = /*#__PURE__*/ __jsr.r({"alert_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"alerts"],[2,[7,"/"],[2,[3,"alert_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/threatops/logs/investigations/:investigation_id(.:format)
 * @param {any} investigation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_investigation_account_threatops_logs_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/threatops/logs/iocs/:ioc_id(.:format)
 * @param {any} ioc_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_ioc_account_threatops_logs_path = /*#__PURE__*/ __jsr.r({"ioc_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"iocs"],[2,[7,"/"],[2,[3,"ioc_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/rogue_apps/service_principals/:id/destroy_modal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_modal_account_rogue_apps_service_principal_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"rogue_apps"],[2,[7,"/"],[2,[6,"service_principals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/rogue_apps/service_principals/:id/destroy_modal(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_modal_organization_rogue_apps_service_principal_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"rogue_apps"],[2,[7,"/"],[2,[6,"service_principals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sso/logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_sso_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sso"],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/autoruns/:id/details(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const details_admin_autorun_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"autoruns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/autorun_entries/:id/details(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const details_admin_autorun_entry_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"autorun_entries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/process_detections/:id/details(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const details_admin_process_detection_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"process_detections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:agent_id/autoruns/:id/details(.:format)
 * @param {any} organization_id
 * @param {any} agent_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const details_organization_agent_autorun_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"agent_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"autoruns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/threatops/logs/detection_library(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const detection_library_account_threatops_logs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"detection_library"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/showcases/validations/detector(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const detector_admin_showcases_validations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"showcases"],[2,[7,"/"],[2,[6,"validations"],[2,[7,"/"],[2,[6,"detector"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /direct_contract_terms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const direct_contract_terms_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"direct_contract_terms"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /account/ransomware_canaries/disable(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_account_ransomware_canaries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"ransomware_canaries"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/accounts/:id/disable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_admin_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/disable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_admin_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/syslog_agents/disable_agent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_agent_account_logs_sources_syslog_agents_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"syslog_agents"],[2,[7,"/"],[2,[6,"disable_agent"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/syslog_agents/disable_agent(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_agent_organization_logs_sources_syslog_agents_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"syslog_agents"],[2,[7,"/"],[2,[6,"disable_agent"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/accounts/:id/disable_feature(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_feature_admin_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable_feature"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:id/disable_feature(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_feature_admin_organization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable_feature"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/managed_identity/identities/:identity_id/tasks/disable_identity(.:format)
 * @param {any} identity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_identity_account_managed_identity_identity_tasks_path = /*#__PURE__*/ __jsr.r({"identity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"identities"],[2,[7,"/"],[2,[3,"identity_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"disable_identity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_identity/identities/:identity_id/tasks/disable_identity(.:format)
 * @param {any} identity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_identity_admin_managed_identity_identity_tasks_path = /*#__PURE__*/ __jsr.r({"identity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"identities"],[2,[7,"/"],[2,[3,"identity_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"disable_identity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/accounts/:id/disable_neighborhood_watch(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_neighborhood_watch_admin_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable_neighborhood_watch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/ransomware_canaries/disable(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_organization_ransomware_canaries_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ransomware_canaries"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/accounts/:id/disable(.:format)
 * @param {any} reseller_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_reseller_account_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /multi_factor/disable(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_user_multi_factor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"multi_factor"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/epochs/:id/dismiss(.:format)
 * @param {any} investigation_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismiss_admin_soc_investigation_epoch_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"epochs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dismiss"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:id/dismiss_task_failure(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismiss_task_failure_organization_agent_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dismiss_task_failure"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /docs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const docs_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"docs"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/epochs/:epoch_id/response_plans/:id/done(.:format)
 * @param {any} investigation_id
 * @param {any} epoch_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const done_admin_soc_investigation_epoch_response_plan_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"epoch_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"epochs"],[2,[7,"/"],[2,[3,"epoch_id"],[2,[7,"/"],[2,[6,"response_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"done"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /download/:key(/:crap)(.:format)
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_path = /*#__PURE__*/ __jsr.r({"key":{"r":true},"crap":{},"format":{}}, [2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"key"],[2,[1,[2,[7,"/"],[3,"crap"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /account/escalations/download(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_account_escalations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"escalations"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/external_recon/download(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_account_external_recon_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"external_recon"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/marketing_assets/:id/download(/:attachment_id)(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_account_marketing_asset_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"attachment_id":{},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"marketing_assets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[2,[1,[2,[7,"/"],[3,"attachment_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agents/download(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_admin_agents_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/binaries/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_admin_binary_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"binaries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/escalations/download(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_admin_escalations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"escalations"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/marketing_assets/:id/download(/:attachment_id)(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_admin_marketing_asset_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"attachment_id":{},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"marketing_assets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[2,[1,[2,[7,"/"],[3,"attachment_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/process_detections/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_admin_process_detection_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"process_detections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/product_reports/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_admin_product_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"product_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/sales_reports/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_admin_sales_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sales_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/signal_events/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_admin_signal_event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signal_events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/tasks/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_admin_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/marketing_assets/:id/download_all(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_all_account_marketing_asset_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"marketing_assets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/marketing_assets/:id/download_all(.:format)
 * @param {any} reseller_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_all_reseller_marketing_asset_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"marketing_assets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/query_exports/:id/download_csv(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_csv_account_logs_query_export_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"query_exports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/query_exports/:id/download_csv(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_csv_organization_logs_query_export_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"query_exports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /espm/app_control/policies/download/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_espm_app_control_policies_path = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"app_control"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /download_eula(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_eula_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"download_eula"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /account/data_archives/:id/download_modal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_modal_account_data_archive_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"data_archives"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:agent_id/antivirus_detections/:id/download(.:format)
 * @param {any} organization_id
 * @param {any} agent_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_organization_agent_antivirus_detection_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"agent_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"antivirus_detections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:agent_id/autoruns/:id/download(.:format)
 * @param {any} organization_id
 * @param {any} agent_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_organization_agent_autorun_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"agent_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"autoruns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/escalations/download(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_organization_escalations_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"escalations"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/external_recon/download(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_organization_external_recon_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"external_recon"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/infection_reports/:id/download_pdf(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_pdf_account_infection_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/infection_reports/:id/download_pdf(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_pdf_organization_infection_report_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/marketing_assets/:id/download(/:attachment_id)(.:format)
 * @param {any} reseller_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_reseller_marketing_asset_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"id":{"r":true},"attachment_id":{},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"marketing_assets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[2,[1,[2,[7,"/"],[3,"attachment_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /download_tos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_tos_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"download_tos"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /account/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/api_credentials/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_api_credential_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"api_credentials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/contacts/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_contacts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/espm/app_control/settings/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_espm_app_control_setting_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"app_control"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/host_isolation/allowlist_entries/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_host_isolation_allowlist_entry_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"host_isolation"],[2,[7,"/"],[2,[6,"allowlist_entries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/infection_reports/:infection_report_id/comments/:id/edit(.:format)
 * @param {any} infection_report_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_infection_report_comment_path = /*#__PURE__*/ __jsr.r({"infection_report_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/autotask/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_integrations_autotask_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"autotask"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/bms/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_integrations_bms_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"bms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/connect_wise/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_integrations_connect_wise_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"connect_wise"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/microsoft/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_integrations_cpv_mapping_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"microsoft"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/duo/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_integrations_duo_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"duo"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/emails/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_integrations_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/halo_psa/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_integrations_halo_psa_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"halo_psa"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/microsoft_defenders/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_integrations_microsoft_defender_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"microsoft_defenders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/microsoft_defender_tenants/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_integrations_microsoft_defender_tenant_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"microsoft_defender_tenants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/ninja_rmm/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_integrations_ninja_rmm_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"ninja_rmm"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/service_now/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_integrations_service_now_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"service_now"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/syncro/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_integrations_syncro_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"syncro"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/audit_policy_escalation_manifest_configs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_audit_policy_escalation_manifest_config_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"audit_policy_escalation_manifest_configs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/saved_queries/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_saved_query_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"saved_queries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/arista_syslogs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_arista_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"arista_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/azures/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_azure_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"azures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/barracuda_cloudgen_syslogs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_barracuda_cloudgen_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"barracuda_cloudgen_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/bitwardens/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_bitwarden_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"bitwardens"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/bitwarden_hecs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_bitwarden_hec_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"bitwarden_hecs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/cisco_amps/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_cisco_amp_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cisco_amps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/cisco_asa_syslogs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_cisco_asa_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cisco_asa_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/cisco_ftd_syslogs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_cisco_ftd_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cisco_ftd_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/cisco_umbrella_organizations/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_cisco_umbrella_organization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cisco_umbrella_organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/cloud_trails/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_cloud_trail_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cloud_trails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/cloudflare_hecs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_cloudflare_hec_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cloudflare_hecs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/crowd_strike_falcons/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_crowd_strike_falcon_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"crowd_strike_falcons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/datto_rmms/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_datto_rmm_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"datto_rmms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/dnsfilter_hecs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_dnsfilter_hec_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"dnsfilter_hecs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/duos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_duo_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"duos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/fortigate_syslogs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_fortigate_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"fortigate_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/generic_hecs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_generic_hec_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"generic_hecs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/generic_s3s/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_generic_s3_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"generic_s3s"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/keeper_hecs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_keeper_hec_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"keeper_hecs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/lastpass_hecs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_lastpass_hec_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"lastpass_hecs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/meraki_clouds/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_meraki_cloud_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"meraki_clouds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/meraki_syslogs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_meraki_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"meraki_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/ninja_one_hecs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_ninja_one_hec_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"ninja_one_hecs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/oktas/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_okta_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"oktas"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/one_passwords/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_one_password_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"one_passwords"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/palo_alto_syslogs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_palo_alto_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"palo_alto_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/pfsense_syslogs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_pfsense_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"pfsense_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/public_syslogs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_public_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"public_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/sentinel_one_agent_syslogs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_sentinel_one_agent_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"sentinel_one_agent_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/sentinel_one_site_syslogs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_sentinel_one_site_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"sentinel_one_site_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/sentinel_one_syslogs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_sentinel_one_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"sentinel_one_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/sonicwall_syslogs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_sonicwall_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"sonicwall_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/sophos_syslogs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_sophos_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"sophos_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/syslogs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/ubiquiti_syslogs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_ubiquiti_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"ubiquiti_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/watchguard_syslogs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_watchguard_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"watchguard_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/wiz_hecs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_sources_wiz_hec_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"wiz_hecs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/windows_audit_configs/mute/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_logs_windows_audit_configs_mute_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"windows_audit_configs"],[2,[7,"/"],[2,[6,"mute"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/member_invitations/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_member_invitation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"member_invitations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/memberships/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_membership_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/saml_provider/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_saml_provider_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"saml_provider"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/user_api_credentials/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_user_api_credential_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"user_api_credentials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/accounts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agent_rollouts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_agent_rollout_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agent_rollouts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/antivirus_threats/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_antivirus_threat_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"antivirus_threats"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/artemis/releases/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_artemis_release_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"artemis"],[2,[7,"/"],[2,[6,"releases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/audit/events/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_audit_event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/categories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/detection_rules/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_detection_rule_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"detection_rules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/espm/rmm_tools/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_espm_rmm_tool_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"rmm_tools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/incident_responses/manual_remediations/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_incident_responses_manual_remediation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"incident_responses"],[2,[7,"/"],[2,[6,"manual_remediations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/incident_responses/manual_remediations/:manual_remediation_id/detection_rules/:id/edit(.:format)
 * @param {any} manual_remediation_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_incident_responses_manual_remediation_detection_rule_path = /*#__PURE__*/ __jsr.r({"manual_remediation_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"incident_responses"],[2,[7,"/"],[2,[6,"manual_remediations"],[2,[7,"/"],[2,[3,"manual_remediation_id"],[2,[7,"/"],[2,[6,"detection_rules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/infection_reports/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_infection_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/infection_reports/:infection_report_id/comments/:id/edit(.:format)
 * @param {any} infection_report_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_infection_report_comment_path = /*#__PURE__*/ __jsr.r({"infection_report_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ispm/security_control_definitions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_ispm_security_control_definition_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"security_control_definitions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/logs/filter_rules/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_logs_filter_rule_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"filter_rules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/malware_families/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_malware_family_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"malware_families"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/marketing_assets/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_marketing_asset_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"marketing_assets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/microsoft_defender/tenants/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_microsoft_defender_tenant_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"microsoft_defender"],[2,[7,"/"],[2,[6,"tenants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/notification_contact/supported_countries/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_notification_contact_supported_country_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"notification_contact"],[2,[7,"/"],[2,[6,"supported_countries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/one_time_notifications/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_one_time_notification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"one_time_notifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/redfigs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_redfig_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"redfigs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resellers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_reseller_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/rio_config/edit(/:version)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_rio_configs_path = /*#__PURE__*/ __jsr.r({"version":{},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"rio_config"],[2,[7,"/"],[2,[6,"edit"],[2,[1,[2,[7,"/"],[3,"version"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/signals/:signal_id/comments/:id/edit(.:format)
 * @param {any} signal_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_signal_comment_path = /*#__PURE__*/ __jsr.r({"signal_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[3,"signal_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/signals/:signal_id/priority/edit(.:format)
 * @param {any} signal_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_signal_priority_path = /*#__PURE__*/ __jsr.r({"signal_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[3,"signal_id"],[2,[7,"/"],[2,[6,"priority"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agents/:agent_id/tasks/:id/edit(.:format)
 * @param {any} agent_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_soc_agent_task_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/epochs/:epoch_id/communications/:id/edit(.:format)
 * @param {any} investigation_id
 * @param {any} epoch_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_soc_investigation_epoch_communication_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"epoch_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"epochs"],[2,[7,"/"],[2,[3,"epoch_id"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/investigation_notes/:id/edit(.:format)
 * @param {any} investigation_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_soc_investigation_investigation_note_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"investigation_notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/staff_groups/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_soc_staff_group_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"staff_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscriptions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_subscription_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/terms_of_service/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_terms_of_service_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"terms_of_service"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/threats/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_threat_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threats"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/threatops/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_threatops_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/threatops/analyst_notes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_threatops_analyst_note_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"analyst_notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/windows_event_log_configs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_windows_event_log_config_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"windows_event_log_configs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/infection_reports/:infection_report_id/sat_assignments/:id/edit_curricula_assignment(.:format)
 * @param {any} infection_report_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_curricula_assignment_account_infection_report_sat_assignment_path = /*#__PURE__*/ __jsr.r({"infection_report_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"sat_assignments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_curricula_assignment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/connect_wise/:id/edit_defaults(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_defaults_account_integrations_connect_wise_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"connect_wise"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_defaults"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/host_isolation_policies/edit_exception(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_exception_account_host_isolation_policies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"host_isolation_policies"],[2,[7,"/"],[2,[6,"edit_exception"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/host_isolation_policies/edit_host_isolation_exception_modal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_host_isolation_exception_modal_account_host_isolation_policies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"host_isolation_policies"],[2,[7,"/"],[2,[6,"edit_host_isolation_exception_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/edit_managed_response(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_managed_response_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"edit_managed_response"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /org/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_agent_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/infection_reports/:infection_report_id/comments/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} infection_report_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_infection_report_comment_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"infection_report_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/saved_queries/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_saved_query_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"saved_queries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/arista_syslogs/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_sources_arista_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"arista_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/azures/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_sources_azure_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"azures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/barracuda_cloudgen_syslogs/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_sources_barracuda_cloudgen_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"barracuda_cloudgen_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/bitwardens/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_sources_bitwarden_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"bitwardens"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/bitwarden_hecs/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_sources_bitwarden_hec_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"bitwarden_hecs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/cisco_amps/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_sources_cisco_amp_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cisco_amps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/cisco_asa_syslogs/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_sources_cisco_asa_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cisco_asa_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/cisco_ftd_syslogs/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_sources_cisco_ftd_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cisco_ftd_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/cisco_umbrella_organizations/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_sources_cisco_umbrella_organization_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cisco_umbrella_organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/cloud_trails/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_sources_cloud_trail_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cloud_trails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/cloudflare_hecs/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_sources_cloudflare_hec_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cloudflare_hecs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/crowd_strike_falcons/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_sources_crowd_strike_falcon_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"crowd_strike_falcons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/dnsfilter_hecs/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_sources_dnsfilter_hec_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"dnsfilter_hecs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/duos/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_sources_duo_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"duos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/fortigate_syslogs/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_sources_fortigate_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"fortigate_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/generic_hecs/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_sources_generic_hec_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"generic_hecs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/generic_s3s/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_sources_generic_s3_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"generic_s3s"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/keeper_hecs/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_sources_keeper_hec_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"keeper_hecs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/lastpass_hecs/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_sources_lastpass_hec_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"lastpass_hecs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/meraki_syslogs/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_sources_meraki_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"meraki_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/ninja_one_hecs/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_sources_ninja_one_hec_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"ninja_one_hecs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/oktas/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_sources_okta_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"oktas"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/one_passwords/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_sources_one_password_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"one_passwords"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/palo_alto_syslogs/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_sources_palo_alto_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"palo_alto_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/pfsense_syslogs/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_sources_pfsense_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"pfsense_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/public_syslogs/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_sources_public_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"public_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/sentinel_one_agent_syslogs/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_sources_sentinel_one_agent_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"sentinel_one_agent_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/sentinel_one_site_syslogs/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_sources_sentinel_one_site_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"sentinel_one_site_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/sonicwall_syslogs/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_sources_sonicwall_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"sonicwall_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/sophos_syslogs/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_sources_sophos_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"sophos_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/syslogs/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_sources_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/ubiquiti_syslogs/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_sources_ubiquiti_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"ubiquiti_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/watchguard_syslogs/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_sources_watchguard_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"watchguard_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/wiz_hecs/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_logs_sources_wiz_hec_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"wiz_hecs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/member_invitations/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_member_invitation_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"member_invitations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/memberships/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_membership_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscriptions/:id/edit_quote_line(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_quote_line_admin_subscription_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_quote_line"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_reseller_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/accounts/:account_id/subscriptions/:id/edit(.:format)
 * @param {any} reseller_id
 * @param {any} account_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_reseller_account_subscription_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"account_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/api_credentials/:id/edit(.:format)
 * @param {any} reseller_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_reseller_api_credential_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"api_credentials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/memberships/:id/edit(.:format)
 * @param {any} reseller_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_reseller_membership_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/edit_rio_tamper_protection(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_rio_tamper_protection_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"edit_rio_tamper_protection"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/rules/:id/edit_rule_modal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_rule_modal_admin_rule_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"rules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_rule_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /secure_account/backup/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_secure_account_backup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"secure_account"],[2,[7,"/"],[2,[6,"backup"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /secure_account/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_secure_account_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"secure_account"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /secure_account/totp/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_secure_account_totp_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"secure_account"],[2,[7,"/"],[2,[6,"totp"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /register/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"register"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/edr_assessments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edr_assessment_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"edr_assessments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/edr_assessment_generate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edr_assessment_generate_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"edr_assessment_generate"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/edr_dashboard_active_incidents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edr_dashboard_active_incidents_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"edr_dashboard_active_incidents"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/edr_dashboard_agent_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edr_dashboard_agent_status_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"edr_dashboard_agent_status"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/edr_dashboard_isolated_host_notice(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edr_dashboard_isolated_host_notice_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"edr_dashboard_isolated_host_notice"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/edr_dashboard_legacy_os_notice(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edr_dashboard_legacy_os_notice_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"edr_dashboard_legacy_os_notice"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/edr_dashboard_resolved_incidents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edr_dashboard_resolved_incidents_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"edr_dashboard_resolved_incidents"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/edr_dashboard_signals_investigated(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edr_dashboard_signals_investigated_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"edr_dashboard_signals_investigated"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/edr_dashboard_surveys_chart(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edr_dashboard_surveys_chart_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"edr_dashboard_surveys_chart"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/edr_dashboard_systems_protected(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edr_dashboard_systems_protected_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"edr_dashboard_systems_protected"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /elastic/m365_detections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const elastic_m365_detections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"elastic"],[2,[7,"/"],[2,[6,"m365_detections"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/memberships/:id/email_recovery_link(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_recovery_link_account_membership_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"email_recovery_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/memberships/:id/email_recovery_link(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_recovery_link_organization_membership_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"email_recovery_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/memberships/:id/email_recovery_link(.:format)
 * @param {any} reseller_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_recovery_link_reseller_membership_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"email_recovery_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email_security/webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_security_webhook_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_security"],[2,[7,"/"],[2,[6,"webhook"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/windows_events/enable(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_account_logs_sources_windows_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"windows_events"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/managed_identity/user_entities/:user_entity_id/tasks/enable(.:format)
 * @param {any} user_entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_account_managed_identity_user_entity_tasks_path = /*#__PURE__*/ __jsr.r({"user_entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"user_entities"],[2,[7,"/"],[2,[3,"user_entity_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/ransomware_canaries/enable(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_account_ransomware_canaries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"ransomware_canaries"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/accounts/:id/enable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_admin_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/syslog_agents/enable_agent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_agent_account_logs_sources_syslog_agents_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"syslog_agents"],[2,[7,"/"],[2,[6,"enable_agent"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/syslog_agents/enable_agent(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_agent_organization_logs_sources_syslog_agents_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"syslog_agents"],[2,[7,"/"],[2,[6,"enable_agent"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/espm/app_control/enable_early_access(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_early_access_account_espm_app_control_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"app_control"],[2,[7,"/"],[2,[6,"enable_early_access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/ispm/security_controls/enable_early_access(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_early_access_account_ispm_security_controls_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"security_controls"],[2,[7,"/"],[2,[6,"enable_early_access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/accounts/:id/enable_feature(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_feature_admin_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enable_feature"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:id/enable_feature(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_feature_admin_organization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enable_feature"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/managed_identity/identities/:identity_id/tasks/enable_identity(.:format)
 * @param {any} identity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_identity_account_managed_identity_identity_tasks_path = /*#__PURE__*/ __jsr.r({"identity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"identities"],[2,[7,"/"],[2,[3,"identity_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"enable_identity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_identity/identities/:identity_id/tasks/enable_identity(.:format)
 * @param {any} identity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_identity_admin_managed_identity_identity_tasks_path = /*#__PURE__*/ __jsr.r({"identity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"identities"],[2,[7,"/"],[2,[3,"identity_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"enable_identity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/windows_events/enable(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_organization_logs_sources_windows_events_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"windows_events"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/ransomware_canaries/enable(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_organization_ransomware_canaries_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ransomware_canaries"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /multi_factor/backup/enable(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_user_multi_factor_backup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"multi_factor"],[2,[7,"/"],[2,[6,"backup"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /multi_factor/duo/enable(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_user_multi_factor_duo_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"multi_factor"],[2,[7,"/"],[2,[6,"duo"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /multi_factor/totp/enable(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_user_multi_factor_totp_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"multi_factor"],[2,[7,"/"],[2,[6,"totp"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/syslog_agents/enableable_select2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enableable_select2_account_logs_sources_syslog_agents_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"syslog_agents"],[2,[7,"/"],[2,[6,"enableable_select2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/syslog_agents/enableable_select2(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enableable_select2_organization_logs_sources_syslog_agents_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"syslog_agents"],[2,[7,"/"],[2,[6,"enableable_select2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/billing/enabled_organizations_select2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enabled_organizations_select2_account_logs_billing_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"enabled_organizations_select2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/enabled_organizations_select2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enabled_organizations_select2_account_logs_sources_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"enabled_organizations_select2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/accounts/:id/end_trial(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const end_trial_admin_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"end_trial"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/antivirus_exclusions/settings/endpoint_modal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const endpoint_modal_account_antivirus_exclusions_settings_path = /*#__PURE__*/ __jsr.r({"format":{"d":"turbo_stream"}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"antivirus_exclusions"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"endpoint_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/antivirus_exclusions/settings/endpoint_modal(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const endpoint_modal_organization_antivirus_exclusions_settings_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{"d":"turbo_stream"}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"antivirus_exclusions"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"endpoint_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/antivirus_exclusions/enforce_mode(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enforce_mode_account_antivirus_exclusions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"antivirus_exclusions"],[2,[7,"/"],[2,[6,"enforce_mode"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/antivirus_exclusions/enforce_mode_consent_modal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enforce_mode_consent_modal_account_antivirus_exclusions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"antivirus_exclusions"],[2,[7,"/"],[2,[6,"enforce_mode_consent_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/antivirus_exclusions/enforce_mode_consent_modal(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enforce_mode_consent_modal_organization_antivirus_exclusions_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"antivirus_exclusions"],[2,[7,"/"],[2,[6,"enforce_mode_consent_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/antivirus_exclusions/enforce_mode(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enforce_mode_organization_antivirus_exclusions_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"antivirus_exclusions"],[2,[7,"/"],[2,[6,"enforce_mode"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/signals/entities_select2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const entities_select2_admin_signals_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[6,"entities_select2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/signals/entities_select2(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const entities_select2_organization_signals_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[6,"entities_select2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /policies/eula(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eula_policies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"eula"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_identity/organizations/:id/event_ingest_status(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const event_ingest_status_admin_managed_identity_organization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"event_ingest_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /services/collector/event(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const event_splunk_hec_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"collector"],[2,[7,"/"],[2,[6,"event"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_identity/organizations/:organization_id/excluded_licenses/exclude_all_student_licenses(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exclude_all_student_licenses_admin_managed_identity_organization_excluded_licenses_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"excluded_licenses"],[2,[7,"/"],[2,[6,"exclude_all_student_licenses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/epochs/:epoch_id/response_plans/:id/execute(.:format)
 * @param {any} investigation_id
 * @param {any} epoch_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const execute_admin_soc_investigation_epoch_response_plan_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"epoch_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"epochs"],[2,[7,"/"],[2,[3,"epoch_id"],[2,[7,"/"],[2,[6,"response_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"execute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/espm/rmm_tools/:id/execute_merge(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const execute_merge_admin_espm_rmm_tool_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"rmm_tools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"execute_merge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_account_logs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/threatops/logs/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_account_threatops_logs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/async_exports/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_admin_async_exports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"async_exports"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agents/:agent_id/logs/export(.:format)
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_admin_soc_agent_logs_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/export(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_organization_logs_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/signals/report/feedback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const feedback_admin_signals_report_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"feedback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/threatops/logs/field_browser(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_browser_account_threatops_logs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"field_browser"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/threatops/logs/field_values(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_values_account_threatops_logs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"field_values"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:agent_id/processes/file_events_grid(.:format)
 * @param {any} organization_id
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_events_grid_organization_agent_processes_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[6,"file_events_grid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/binaries/:id/fileinfo(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fileinfo_admin_binary_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"binaries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"fileinfo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/autotask/:id/find_test_ticket(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const find_test_ticket_account_integrations_autotask_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"autotask"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"find_test_ticket"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/bms/:id/find_test_ticket(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const find_test_ticket_account_integrations_bms_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"bms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"find_test_ticket"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/connect_wise/:id/find_test_ticket(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const find_test_ticket_account_integrations_connect_wise_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"connect_wise"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"find_test_ticket"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/halo_psa/:id/find_test_ticket(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const find_test_ticket_account_integrations_halo_psa_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"halo_psa"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"find_test_ticket"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/service_now/:id/find_test_ticket(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const find_test_ticket_account_integrations_service_now_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"service_now"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"find_test_ticket"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/syncro/:id/find_test_ticket(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const find_test_ticket_account_integrations_syncro_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"syncro"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"find_test_ticket"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/infection_reports/:id/finish(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finish_admin_infection_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"finish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agents/fleet_health_widget(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fleet_health_widget_admin_agents_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"fleet_health_widget"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agents/fleet_recently_installed_agents_grid(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fleet_recently_installed_agents_grid_admin_agents_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"fleet_recently_installed_agents_grid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agents/fleet_unhealthy_agents_grid(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fleet_unhealthy_agents_grid_admin_agents_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"fleet_unhealthy_agents_grid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agents/fleet_uninstalled_agents_grid(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fleet_uninstalled_agents_grid_admin_agents_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"fleet_uninstalled_agents_grid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/signals/followup_modal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const followup_modal_admin_signals_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[6,"followup_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscriptions/:id/force_expiry(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const force_expiry_admin_subscription_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"force_expiry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/agents/forced_register(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const forced_register_api_v1_agents_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"agent"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"forced_register"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/signals/generate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_admin_signals_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[6,"generate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/reports/generate_custom(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_custom_account_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"generate_custom"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/reports/generate_custom(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_custom_organization_reports_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"generate_custom"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:agent_id/processes/generate(.:format)
 * @param {any} organization_id
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_organization_agent_processes_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[6,"generate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/threatops/logs/authentication_failures/sources/:id/generate_signal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_signal_admin_threatops_logs_authentication_failures_source_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"authentication_failures"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"generate_signal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_identity/organizations/google_migration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const google_migration_admin_managed_identity_organizations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"google_migration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /google/subscription_channel_notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const google_subscription_channel_notifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"google"],[2,[7,"/"],[2,[6,"subscription_channel_notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /health(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const health_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"health"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /services/collector/health(/:version)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const health_splunk_hec_path = /*#__PURE__*/ __jsr.r({"version":{},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"collector"],[2,[7,"/"],[2,[6,"health"],[2,[1,[2,[7,"/"],[3,"version"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /hotwire_native/tokens(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hotwire_native_tokens_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hotwire_native"],[2,[7,"/"],[2,[6,"tokens"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /hubspot/cards/account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hubspot_cards_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hubspot"],[2,[7,"/"],[2,[6,"cards"],[2,[7,"/"],[2,[6,"account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /hubspot/cards/account/contracts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hubspot_cards_account_contracts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hubspot"],[2,[7,"/"],[2,[6,"cards"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"contracts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /hubspot/cards/account/incidents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hubspot_cards_account_incidents_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hubspot"],[2,[7,"/"],[2,[6,"cards"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"incidents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /hubspot
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hubspot_event_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"hubspot"]]);

/**
 * Generates rails route to
 * /hubspot/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hubspot_event_root_path = /*#__PURE__*/ __jsr.r({}, [2,[2,[7,"/"],[6,"hubspot"]],[7,"/"]]);

/**
 * Generates rails route to
 * /hubspot/events
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hubspot_events_new_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"hubspot"],[2,[7,"/"],[6,"events"]]]]);

/**
 * Generates rails route to
 * /hubspot/events/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hubspot_events_new_root_path = /*#__PURE__*/ __jsr.r({}, [2,[2,[7,"/"],[2,[6,"hubspot"],[2,[7,"/"],[6,"events"]]]],[7,"/"]]);

/**
 * Generates rails route to
 * /admin/threatops/identity_lookup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const identity_lookup_admin_threatops_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"identity_lookup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /sso/idp_sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const idp_sign_out_sso_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sso"],[2,[7,"/"],[2,[6,"idp_sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/rogue_apps/cloud_applications/:id/impacted_identities(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const impacted_identities_organization_rogue_apps_cloud_application_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"rogue_apps"],[2,[7,"/"],[2,[6,"cloud_applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"impacted_identities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /impersonation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const impersonation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"impersonation"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:id/inline_signals_timeline(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inline_signals_timeline_admin_soc_investigation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"inline_signals_timeline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:id/install_system_extension_modal(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const install_system_extension_modal_organization_agent_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"install_system_extension_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:id/install_system_extension(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const install_system_extension_organization_agent_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"install_system_extension"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_api_api_controller_path = /*#__PURE__*/ __jsr.r({"subdomain":{"d":"internal-api"}}, [7,"/"]);

/**
 * Generates rails route to
 * /account/threatops/logs/investigations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const investigations_account_threatops_logs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"investigations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:id/invite(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invite_organization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"invite"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoice_subdomain_root_path = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /account/threatops/logs/iocs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const iocs_account_threatops_logs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"iocs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:id/isolate(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const isolate_organization_agent_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"isolate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/ispm_early_access_banner_dismissed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ispm_early_access_banner_dismissed_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"ispm_early_access_banner_dismissed"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/ispm_nav_tooltip_dismissed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ispm_nav_tooltip_dismissed_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"ispm_nav_tooltip_dismissed"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/connect_wise/:id/items(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const items_account_integrations_connect_wise_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"connect_wise"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/halo_psa/:id/items(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const items_account_integrations_halo_psa_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"halo_psa"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /zendesk_authentication/knowledge_base_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const knowledge_base_token_zendesk_authentication_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"zendesk_authentication"],[2,[7,"/"],[2,[6,"knowledge_base_token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/launchpad(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const launchpad_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"launchpad"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /legacy_download/:key(/:crap)(.:format)
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacy_download_path = /*#__PURE__*/ __jsr.r({"key":{"r":true},"crap":{},"format":{}}, [2,[7,"/"],[2,[6,"legacy_download"],[2,[7,"/"],[2,[3,"key"],[2,[1,[2,[7,"/"],[3,"crap"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /download/linux/:key(/:crap)(.:format)
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linux_installer_download_path = /*#__PURE__*/ __jsr.r({"key":{"r":true},"crap":{},"format":{}}, [2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[6,"linux"],[2,[7,"/"],[2,[3,"key"],[2,[1,[2,[7,"/"],[3,"crap"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/infection_reports/:infection_report_id/soc_support/live_chat_option(.:format)
 * @param {any} infection_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const live_chat_option_account_infection_report_soc_support_index_path = /*#__PURE__*/ __jsr.r({"infection_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"soc_support"],[2,[7,"/"],[2,[6,"live_chat_option"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/infection_reports/:infection_report_id/soc_support/live_chat_option(.:format)
 * @param {any} organization_id
 * @param {any} infection_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const live_chat_option_organization_infection_report_soc_support_index_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"infection_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"soc_support"],[2,[7,"/"],[2,[6,"live_chat_option"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /zendesk_authentication/live_chat_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const live_chat_token_zendesk_authentication_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"zendesk_authentication"],[2,[7,"/"],[2,[6,"live_chat_token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/live_queue(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const live_queue_admin_soc_investigations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[6,"live_queue"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/saved_queries/load_drawer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const load_drawer_account_logs_saved_queries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"saved_queries"],[2,[7,"/"],[2,[6,"load_drawer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/saved_queries/load_drawer(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const load_drawer_organization_logs_saved_queries_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"saved_queries"],[2,[7,"/"],[2,[6,"load_drawer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/saved_queries/load_drawer_table(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const load_drawer_table_account_logs_saved_queries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"saved_queries"],[2,[7,"/"],[2,[6,"load_drawer_table"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/saved_queries/load_drawer_table(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const load_drawer_table_organization_logs_saved_queries_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"saved_queries"],[2,[7,"/"],[2,[6,"load_drawer_table"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/saved_queries/load_starter_queries_table(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const load_starter_queries_table_account_logs_saved_queries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"saved_queries"],[2,[7,"/"],[2,[6,"load_starter_queries_table"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/saved_queries/load_starter_queries_table(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const load_starter_queries_table_organization_logs_saved_queries_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"saved_queries"],[2,[7,"/"],[2,[6,"load_starter_queries_table"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /login_link(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const login_link_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"login_link"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /multi_factor/recovery/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const login_user_multi_factor_recovery_path = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"multi_factor"],[2,[7,"/"],[2,[6,"recovery"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:agent_id/processes/logon_events_grid(.:format)
 * @param {any} organization_id
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logon_events_grid_organization_agent_processes_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[6,"logon_events_grid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/managed_identity/user_entities/:user_entity_id/tasks/logout(.:format)
 * @param {any} user_entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logout_account_managed_identity_user_entity_tasks_path = /*#__PURE__*/ __jsr.r({"user_entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"user_entities"],[2,[7,"/"],[2,[3,"user_entity_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/managed_identity/user_entities/:user_entity_id/tasks/logout_and_disable(.:format)
 * @param {any} user_entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logout_and_disable_account_managed_identity_user_entity_tasks_path = /*#__PURE__*/ __jsr.r({"user_entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"user_entities"],[2,[7,"/"],[2,[3,"user_entity_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"logout_and_disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_identity/user_entities/:user_entity_id/tasks/logout_and_disable(.:format)
 * @param {any} user_entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logout_and_disable_admin_managed_identity_user_entity_tasks_path = /*#__PURE__*/ __jsr.r({"user_entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"user_entities"],[2,[7,"/"],[2,[3,"user_entity_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"logout_and_disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /logs/cloudtrail/sns/:webhook_key(.:format)
 * @param {any} webhook_key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logs_cloud_trail_sns_path = /*#__PURE__*/ __jsr.r({"webhook_key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"cloudtrail"],[2,[7,"/"],[2,[6,"sns"],[2,[7,"/"],[2,[3,"webhook_key"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /logs/generic_s3/sns/:webhook_key(.:format)
 * @param {any} webhook_key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logs_generic_s3_sns_path = /*#__PURE__*/ __jsr.r({"webhook_key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"generic_s3"],[2,[7,"/"],[2,[6,"sns"],[2,[7,"/"],[2,[3,"webhook_key"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ui
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"ui"]]);

/**
 * Generates rails route to
 * /ui/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_lookbook_home_path = /*#__PURE__*/ __jsr.r({}, [2,[2,[7,"/"],[6,"ui"]],[7,"/"]]);

/**
 * Generates rails route to
 * /ui/docs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_lookbook_page_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"ui"]],[7,"/"]],[2,[6,"docs"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ui/docs/*path(.:format)
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_lookbook_page_path = /*#__PURE__*/ __jsr.r({"path":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"ui"]],[7,"/"]],[2,[6,"docs"],[2,[7,"/"],[2,[5,[3,"path"]],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ui/previews(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_lookbook_previews_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"ui"]],[7,"/"]],[2,[6,"previews"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ui/preview/*path(.:format)
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_lookbook_preview_path = /*#__PURE__*/ __jsr.r({"path":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"ui"]],[7,"/"]],[2,[6,"preview"],[2,[7,"/"],[2,[5,[3,"path"]],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ui/inspect/*path(.:format)
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_lookbook_inspect_path = /*#__PURE__*/ __jsr.r({"path":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"ui"]],[7,"/"]],[2,[6,"inspect"],[2,[7,"/"],[2,[5,[3,"path"]],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ui/embed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_lookbook_embed_lookup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"ui"]],[7,"/"]],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ui/embed/*path(.:format)
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_lookbook_embed_path = /*#__PURE__*/ __jsr.r({"path":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"ui"]],[7,"/"]],[2,[6,"embed"],[2,[7,"/"],[2,[5,[3,"path"]],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /m365/events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const m365_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"m365"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/processes/macos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const macos_admin_processes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[6,"macos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/rio_config/macos_apply_to_orgs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const macos_apply_to_orgs_admin_rio_configs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"rio_config"],[2,[7,"/"],[2,[6,"macos_apply_to_orgs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/rio_config/macos_create(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const macos_create_admin_rio_configs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"rio_config"],[2,[7,"/"],[2,[6,"macos_create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/rio_config/macos_edit(/:name)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const macos_edit_admin_rio_configs_path = /*#__PURE__*/ __jsr.r({"name":{},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"rio_config"],[2,[7,"/"],[2,[6,"macos_edit"],[2,[1,[2,[7,"/"],[3,"name"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/macos_setup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const macos_setup_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"macos_setup"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/macos_setup_bulk_install(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const macos_setup_bulk_install_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"macos_setup_bulk_install"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/macos_setup_bulk_install_modal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const macos_setup_bulk_install_modal_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"macos_setup_bulk_install_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /org/:id/macos_setup_bulk_install_modal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const macos_setup_bulk_install_modal_organization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"macos_setup_bulk_install_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:id/macos_setup_bulk_install(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const macos_setup_bulk_install_organization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"macos_setup_bulk_install"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:id/macos_setup(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const macos_setup_organization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"macos_setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/rio_config/macos_update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const macos_update_admin_rio_configs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"rio_config"],[2,[7,"/"],[2,[6,"macos_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/rio_config/macos_update_default(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const macos_update_default_admin_rio_configs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"rio_config"],[2,[7,"/"],[2,[6,"macos_update_default"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/identity_providers/organizations/:organization_id/billable_products/manage(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manage_account_integrations_identity_providers_organization_billable_products_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"identity_providers"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"billable_products"],[2,[7,"/"],[2,[6,"manage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/organizations/manage_products_drawer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manage_products_drawer_account_organizations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"manage_products_drawer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /managed_identity/*unmatched_route(.:format)
 * @param {any} unmatched_route
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const managed_identity_path = /*#__PURE__*/ __jsr.r({"unmatched_route":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[5,[3,"unmatched_route"]],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /managed_identity/api/m365/admin_consent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const managed_identity_api_m365_admin_consent_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"m365"],[2,[7,"/"],[2,[6,"admin_consent"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /managed_identity/api/m365/authorize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const managed_identity_api_m365_authorize_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"m365"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /managed_identity/api/m365/direct_tenant_admin_consent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const managed_identity_api_m365_direct_tenant_admin_consent_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"m365"],[2,[7,"/"],[2,[6,"direct_tenant_admin_consent"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /managed_identity/api/m365/phishing_detection/:tenant_id.gif(.:format)
 * @param {any} tenant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const managed_identity_api_m365_tracking_pixel_path = /*#__PURE__*/ __jsr.r({"tenant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"m365"],[2,[7,"/"],[2,[6,"phishing_detection"],[2,[7,"/"],[2,[3,"tenant_id"],[2,[8,"."],[2,[6,"gif"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/installer/manual(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manual_account_installer_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"installer"],[2,[7,"/"],[2,[6,"manual"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/identity_providers/mapped_organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mapped_organizations_account_integrations_identity_providers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"identity_providers"],[2,[7,"/"],[2,[6,"mapped_organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user_notifications/mark_notifications_read(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_notifications_read_user_notifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_notifications"],[2,[7,"/"],[2,[6,"mark_notifications_read"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/threatops/mde_lookup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mde_lookup_admin_threatops_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"mde_lookup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /member_invitations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const member_invitations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"member_invitations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /member_invitations/resends(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const member_invitations_resends_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"member_invitations"],[2,[7,"/"],[2,[6,"resends"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/memberships(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const memberships_admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"memberships"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/espm/rmm_tools/:id/merge(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const merge_admin_espm_rmm_tool_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"rmm_tools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"merge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sso/metadata(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const metadata_sso_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sso"],[2,[7,"/"],[2,[6,"metadata"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/accounts/:id/migrate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const migrate_admin_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"migrate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agents/misbehaviors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const misbehaviors_admin_agents_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"misbehaviors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agents/misconfigured_agents_grid(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const misconfigured_agents_grid_admin_agents_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"misconfigured_agents_grid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/threatops/logs/mitre_coverage(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mitre_coverage_account_threatops_logs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"mitre_coverage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/mobile_start(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mobile_start_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"mobile_start"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/:uuid/modal(.:format)
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const modal_account_log_path = /*#__PURE__*/ __jsr.r({"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[3,"uuid"],[2,[7,"/"],[2,[6,"modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/threatops/logs/:uuid/modal(.:format)
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const modal_account_threatops_log_path = /*#__PURE__*/ __jsr.r({"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[3,"uuid"],[2,[7,"/"],[2,[6,"modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agents/:agent_id/logs/:uuid/modal(.:format)
 * @param {any} agent_id
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const modal_admin_soc_agent_log_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[3,"uuid"],[2,[7,"/"],[2,[6,"modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/threatops/logs/:uuid/modal(.:format)
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const modal_admin_threatops_log_path = /*#__PURE__*/ __jsr.r({"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[3,"uuid"],[2,[7,"/"],[2,[6,"modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:agent_id/logs/:uuid/modal(.:format)
 * @param {any} organization_id
 * @param {any} agent_id
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const modal_organization_agent_log_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"agent_id":{"r":true},"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[3,"uuid"],[2,[7,"/"],[2,[6,"modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/:uuid/modal(.:format)
 * @param {any} organization_id
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const modal_organization_log_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[3,"uuid"],[2,[7,"/"],[2,[6,"modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/agents/move(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const move_account_agents_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"move"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/move(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const move_admin_organizations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"move"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/move(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const move_organization_agents_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"move"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/move_request(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const move_request_admin_organizations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"move_request"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/accounts/:account_id/organizations/move_select2(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const move_select2_admin_account_organizations_path = /*#__PURE__*/ __jsr.r({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"move_select2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /msp_contract_terms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const msp_contract_terms_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"msp_contract_terms"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:id/needs_reporting_counts(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const needs_reporting_counts_organization_agent_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"needs_reporting_counts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/api_credentials/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_api_credential_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"api_credentials"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/data_archives/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_data_archive_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"data_archives"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/exclusions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_exclusion_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"exclusions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/host_isolation/allowlist_entries/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_host_isolation_allowlist_entry_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"host_isolation"],[2,[7,"/"],[2,[6,"allowlist_entries"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/infection_reports/:infection_report_id/soc_callback_requests/new(.:format)
 * @param {any} infection_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_infection_report_soc_callback_request_path = /*#__PURE__*/ __jsr.r({"infection_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"soc_callback_requests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/infection_reports/:infection_report_id/soc_email_conversations/new(.:format)
 * @param {any} infection_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_infection_report_soc_email_conversation_path = /*#__PURE__*/ __jsr.r({"infection_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"soc_email_conversations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/autotask/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_integrations_autotask_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"autotask"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/bms/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_integrations_bms_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"bms"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/connect_wise/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_integrations_connect_wise_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"connect_wise"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/microsoft/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_integrations_cpv_mapping_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"microsoft"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/duo/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_integrations_duo_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"duo"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_integrations_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/email_security_tenants/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_integrations_email_security_tenant_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"email_security_tenants"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/google/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_integrations_google_tenant_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"google"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/halo_psa/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_integrations_halo_psa_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"halo_psa"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/microsoft_defender_tenants/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_integrations_microsoft_defender_tenant_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"microsoft_defender_tenants"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/microsoft_defender_tenants/:microsoft_defender_tenant_id/microsoft_defender_tenant_aliases/new(.:format)
 * @param {any} microsoft_defender_tenant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_integrations_microsoft_defender_tenant_alias_path = /*#__PURE__*/ __jsr.r({"microsoft_defender_tenant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"microsoft_defender_tenants"],[2,[7,"/"],[2,[3,"microsoft_defender_tenant_id"],[2,[7,"/"],[2,[6,"microsoft_defender_tenant_aliases"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/ninja_rmm/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_integrations_ninja_rmm_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"ninja_rmm"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/service_now/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_integrations_service_now_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"service_now"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/syncro/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_integrations_syncro_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"syncro"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/ispm/organization_entitlements/bulk/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_ispm_bulk_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"organization_entitlements"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/ispm/security_control_enforcements/bulk/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_ispm_bulk_security_control_enforcement_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"security_control_enforcements"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/rehydrations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_logs_rehydration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"rehydrations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/saved_queries/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_logs_saved_query_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"saved_queries"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/azures/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_logs_sources_azure_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"azures"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/bitwardens/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_logs_sources_bitwarden_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"bitwardens"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/bitwarden_hecs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_logs_sources_bitwarden_hec_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"bitwarden_hecs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/cisco_amps/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_logs_sources_cisco_amp_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cisco_amps"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/cisco_umbrella_organizations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_logs_sources_cisco_umbrella_organization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cisco_umbrella_organizations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/cloud_trails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_logs_sources_cloud_trail_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cloud_trails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/cloudflare_hecs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_logs_sources_cloudflare_hec_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cloudflare_hecs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/crowd_strike_falcons/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_logs_sources_crowd_strike_falcon_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"crowd_strike_falcons"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/datto_rmms/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_logs_sources_datto_rmm_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"datto_rmms"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/dnsfilter_hecs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_logs_sources_dnsfilter_hec_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"dnsfilter_hecs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/duos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_logs_sources_duo_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"duos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/generic_hecs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_logs_sources_generic_hec_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"generic_hecs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/generic_s3s/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_logs_sources_generic_s3_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"generic_s3s"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/keeper_hecs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_logs_sources_keeper_hec_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"keeper_hecs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/lastpass_hecs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_logs_sources_lastpass_hec_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"lastpass_hecs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/meraki_clouds/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_logs_sources_meraki_cloud_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"meraki_clouds"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/ninja_one_hecs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_logs_sources_ninja_one_hec_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"ninja_one_hecs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/oktas/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_logs_sources_okta_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"oktas"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/one_passwords/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_logs_sources_one_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"one_passwords"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/public_syslogs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_logs_sources_public_syslog_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"public_syslogs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/sentinel_one_syslogs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_logs_sources_sentinel_one_syslog_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"sentinel_one_syslogs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/wiz_hecs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_logs_sources_wiz_hec_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"wiz_hecs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/wizards/starter/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_logs_sources_wizards_starter_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"wizards"],[2,[7,"/"],[2,[6,"starter"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/wizards/syslog/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_logs_sources_wizards_syslog_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"wizards"],[2,[7,"/"],[2,[6,"syslog"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/windows_audit_configs/mute/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_logs_windows_audit_configs_mute_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"windows_audit_configs"],[2,[7,"/"],[2,[6,"mute"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/windows_audit_configs/resync/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_logs_windows_audit_configs_resync_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"windows_audit_configs"],[2,[7,"/"],[2,[6,"resync"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/managed_identity/attribute_rules/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_managed_identity_attribute_rule_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"attribute_rules"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/managed_identity/identities/:identity_id/attribute_rules/new(.:format)
 * @param {any} identity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_managed_identity_identity_attribute_rule_path = /*#__PURE__*/ __jsr.r({"identity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"identities"],[2,[7,"/"],[2,[3,"identity_id"],[2,[7,"/"],[2,[6,"attribute_rules"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/member_invitations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_member_invitation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"member_invitations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/notification_contacts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_notification_contact_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"notification_contacts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/pricing_requests/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_pricing_request_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"pricing_requests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/sales_contact_requests/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_sales_contact_request_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"sales_contact_requests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/saml_provider/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_saml_provider_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"saml_provider"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/user_api_credentials/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_user_api_credential_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"user_api_credentials"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/accounts/:account_id/subscriptions/new(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_account_subscription_path = /*#__PURE__*/ __jsr.r({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agents/:agent_id/infection_reports/new(.:format)
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_agent_infection_report_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agent_releases/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_agent_release_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agent_releases"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agent_rollouts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_agent_rollout_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agent_rollouts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agents/:agent_id/tasks/new(.:format)
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_agent_task_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/artemis/releases/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_artemis_release_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"artemis"],[2,[7,"/"],[2,[6,"releases"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/audit/events/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_audit_event_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/data_grid_saved_views/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_data_grid_saved_view_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"data_grid_saved_views"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/espm/rmm_tools/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_espm_rmm_tool_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"rmm_tools"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/incident_responses/manual_remediations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_incident_responses_manual_remediation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"incident_responses"],[2,[7,"/"],[2,[6,"manual_remediations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/incident_responses/manual_remediations/:manual_remediation_id/detection_rules/new(.:format)
 * @param {any} manual_remediation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_incident_responses_manual_remediation_detection_rule_path = /*#__PURE__*/ __jsr.r({"manual_remediation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"incident_responses"],[2,[7,"/"],[2,[6,"manual_remediations"],[2,[7,"/"],[2,[3,"manual_remediation_id"],[2,[7,"/"],[2,[6,"detection_rules"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/infection_reports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_infection_report_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/infection_reports/:infection_report_id/body_overrides/new(.:format)
 * @param {any} infection_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_infection_report_body_override_path = /*#__PURE__*/ __jsr.r({"infection_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"body_overrides"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/infection_reports/:infection_report_id/infection_report_feedbacks/new(.:format)
 * @param {any} infection_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_infection_report_infection_report_feedback_path = /*#__PURE__*/ __jsr.r({"infection_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"infection_report_feedbacks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/infection_reports/:infection_report_id/inquiry/new(.:format)
 * @param {any} infection_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_infection_report_inquiry_path = /*#__PURE__*/ __jsr.r({"infection_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"inquiry"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/infection_reports/:infection_report_id/remediations/new(.:format)
 * @param {any} infection_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_infection_report_remediation_path = /*#__PURE__*/ __jsr.r({"infection_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"remediations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/logs/filter_rules/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_logs_filter_rule_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"filter_rules"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/malware_families/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_malware_family_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"malware_families"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_identity/organizations/:organization_id/client_api_request/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_managed_identity_organization_client_api_request_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"client_api_request"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_identity/organizations/:organization_id/excluded_licenses/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_managed_identity_organization_excluded_license_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"excluded_licenses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_identity/organizations/:organization_id/excluded_organizational_units/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_managed_identity_organization_excluded_organizational_unit_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"excluded_organizational_units"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/marketing_assets/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_marketing_asset_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"marketing_assets"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/notification_contact/supported_countries/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_notification_contact_supported_country_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"notification_contact"],[2,[7,"/"],[2,[6,"supported_countries"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/notify/autotask/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_notify_autotask_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"notify"],[2,[7,"/"],[2,[6,"autotask"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/notify/connectwise/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_notify_connectwise_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"notify"],[2,[7,"/"],[2,[6,"connectwise"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/notify/halo_psa/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_notify_halo_psa_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"notify"],[2,[7,"/"],[2,[6,"halo_psa"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/notify/kaseya/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_notify_kaseya_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"notify"],[2,[7,"/"],[2,[6,"kaseya"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/notify/syncro/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_notify_syncro_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"notify"],[2,[7,"/"],[2,[6,"syncro"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/one_time_notifications/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_one_time_notification_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"one_time_notifications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resellers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_reseller_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/showcases/demos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_showcases_demo_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"showcases"],[2,[7,"/"],[2,[6,"demos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/showcases/demos/:demo_showcase_id/attack/new(.:format)
 * @param {any} demo_showcase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_showcases_demo_attack_path = /*#__PURE__*/ __jsr.r({"demo_showcase_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"showcases"],[2,[7,"/"],[2,[6,"demos"],[2,[7,"/"],[2,[3,"demo_showcase_id"],[2,[7,"/"],[2,[6,"attack"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/showcases/demos/:demo_showcase_id/detonate/new(.:format)
 * @param {any} demo_showcase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_showcases_demo_detonate_path = /*#__PURE__*/ __jsr.r({"demo_showcase_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"showcases"],[2,[7,"/"],[2,[6,"demos"],[2,[7,"/"],[2,[3,"demo_showcase_id"],[2,[7,"/"],[2,[6,"detonate"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/showcases/demos/:demo_showcase_id/plot/new(.:format)
 * @param {any} demo_showcase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_showcases_demo_plot_path = /*#__PURE__*/ __jsr.r({"demo_showcase_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"showcases"],[2,[7,"/"],[2,[6,"demos"],[2,[7,"/"],[2,[3,"demo_showcase_id"],[2,[7,"/"],[2,[6,"plot"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/signals/antivirus_detections/generate/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_signals_antivirus_detections_generate_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[6,"antivirus_detections"],[2,[7,"/"],[2,[6,"generate"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/signals/autorun_entries/generate/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_signals_autorun_entries_generate_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[6,"autorun_entries"],[2,[7,"/"],[2,[6,"generate"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/signals/microsoft_defender_events/generate/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_signals_microsoft_defender_events_generate_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[6,"microsoft_defender_events"],[2,[7,"/"],[2,[6,"generate"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/signals/processes/generate/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_signals_processes_generate_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[6,"generate"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/signals/report/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_signals_report_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agents/:agent_id/tasks/new(.:format)
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_soc_agent_task_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agents/:agent_id/toolbar/tasks/new(.:format)
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_soc_agent_toolbar_task_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"toolbar"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agentic/conversations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_soc_agentic_conversation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agentic"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/epochs/:epoch_id/communications/new(.:format)
 * @param {any} investigation_id
 * @param {any} epoch_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_soc_investigation_epoch_communication_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"epoch_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"epochs"],[2,[7,"/"],[2,[3,"epoch_id"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/epochs/:epoch_id/delivery/new(.:format)
 * @param {any} investigation_id
 * @param {any} epoch_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_soc_investigation_epoch_delivery_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"epoch_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"epochs"],[2,[7,"/"],[2,[3,"epoch_id"],[2,[7,"/"],[2,[6,"delivery"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/epochs/:epoch_id/response_plans/new(.:format)
 * @param {any} investigation_id
 * @param {any} epoch_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_soc_investigation_epoch_response_plan_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"epoch_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"epochs"],[2,[7,"/"],[2,[3,"epoch_id"],[2,[7,"/"],[2,[6,"response_plans"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/qc/reviews/:review_id/comments/new(.:format)
 * @param {any} review_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_soc_qc_review_comment_path = /*#__PURE__*/ __jsr.r({"review_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"qc"],[2,[7,"/"],[2,[6,"reviews"],[2,[7,"/"],[2,[3,"review_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/staff_groups/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_soc_staff_group_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"staff_groups"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/tasks/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_task_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/terms_of_service/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_terms_of_service_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"terms_of_service"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/threats/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_threat_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threats"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/threatops/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_threatops_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/threatops/analyst_notes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_threatops_analyst_note_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"analyst_notes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/threatops/detections/microsoft_defender_detection_sets/:microsoft_defender_detection_set_priority/event_mappings/new(.:format)
 * @param {any} microsoft_defender_detection_set_priority
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_threatops_detections_microsoft_defender_detection_set_event_mapping_path = /*#__PURE__*/ __jsr.r({"microsoft_defender_detection_set_priority":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"detections"],[2,[7,"/"],[2,[6,"microsoft_defender_detection_sets"],[2,[7,"/"],[2,[3,"microsoft_defender_detection_set_priority"],[2,[7,"/"],[2,[6,"event_mappings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/windows_event_log_configs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_windows_event_log_config_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"windows_event_log_configs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/binaries/new_bulk_lookup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_bulk_lookup_admin_binaries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"binaries"],[2,[7,"/"],[2,[6,"new_bulk_lookup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/connect_wise/new_companies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_companies_account_integrations_connect_wise_index_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"connect_wise"],[2,[7,"/"],[2,[6,"new_companies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/connect_wise/new_defaults(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_defaults_account_integrations_connect_wise_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"connect_wise"],[2,[7,"/"],[2,[6,"new_defaults"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/assessments/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_assessment_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"assessments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/infection_reports/:infection_report_id/soc_callback_requests/new(.:format)
 * @param {any} organization_id
 * @param {any} infection_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_infection_report_soc_callback_request_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"infection_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"soc_callback_requests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/infection_reports/:infection_report_id/soc_email_conversations/new(.:format)
 * @param {any} organization_id
 * @param {any} infection_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_infection_report_soc_email_conversation_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"infection_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"soc_email_conversations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/ispm/security_control_enforcements/bulk/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_ispm_bulk_security_control_enforcement_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"security_control_enforcements"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/ispm/managed_conditional_access_policies/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_ispm_managed_conditional_access_policy_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"managed_conditional_access_policies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/saved_queries/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_logs_saved_query_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"saved_queries"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/azures/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_logs_sources_azure_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"azures"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/bitwardens/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_logs_sources_bitwarden_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"bitwardens"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/bitwarden_hecs/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_logs_sources_bitwarden_hec_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"bitwarden_hecs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/cisco_amps/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_logs_sources_cisco_amp_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cisco_amps"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/cisco_umbrella_organizations/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_logs_sources_cisco_umbrella_organization_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cisco_umbrella_organizations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/cloud_trails/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_logs_sources_cloud_trail_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cloud_trails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/cloudflare_hecs/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_logs_sources_cloudflare_hec_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cloudflare_hecs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/crowd_strike_falcons/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_logs_sources_crowd_strike_falcon_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"crowd_strike_falcons"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/dnsfilter_hecs/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_logs_sources_dnsfilter_hec_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"dnsfilter_hecs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/duos/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_logs_sources_duo_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"duos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/generic_hecs/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_logs_sources_generic_hec_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"generic_hecs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/generic_s3s/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_logs_sources_generic_s3_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"generic_s3s"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/keeper_hecs/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_logs_sources_keeper_hec_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"keeper_hecs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/lastpass_hecs/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_logs_sources_lastpass_hec_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"lastpass_hecs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/ninja_one_hecs/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_logs_sources_ninja_one_hec_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"ninja_one_hecs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/oktas/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_logs_sources_okta_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"oktas"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/one_passwords/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_logs_sources_one_password_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"one_passwords"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/public_syslogs/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_logs_sources_public_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"public_syslogs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/wiz_hecs/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_logs_sources_wiz_hec_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"wiz_hecs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/wizards/starter/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_logs_sources_wizards_starter_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"wizards"],[2,[7,"/"],[2,[6,"starter"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/wizards/syslog/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_logs_sources_wizards_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"wizards"],[2,[7,"/"],[2,[6,"syslog"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/windows_audit_configs/resync/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_logs_windows_audit_configs_resync_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"windows_audit_configs"],[2,[7,"/"],[2,[6,"resync"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/managed_identity/attribute_rules/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_managed_identity_attribute_rule_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"attribute_rules"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/managed_identity/identities/:identity_id/attribute_rules/new(.:format)
 * @param {any} organization_id
 * @param {any} identity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_managed_identity_identity_attribute_rule_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"identity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"identities"],[2,[7,"/"],[2,[3,"identity_id"],[2,[7,"/"],[2,[6,"attribute_rules"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/member_invitations/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_member_invitation_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"member_invitations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/accounts/new(.:format)
 * @param {any} reseller_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_reseller_account_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/accounts/:account_id/subscriptions/new(.:format)
 * @param {any} reseller_id
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_reseller_account_subscription_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"account_id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/api_credentials/new(.:format)
 * @param {any} reseller_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_reseller_api_credential_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"api_credentials"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/memberships/new(.:format)
 * @param {any} reseller_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_reseller_membership_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /secure_account/backup/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_secure_account_backup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"secure_account"],[2,[7,"/"],[2,[6,"backup"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /secure_account/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_secure_account_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"secure_account"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /secure_account/totp/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_secure_account_totp_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"secure_account"],[2,[7,"/"],[2,[6,"totp"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /sso/login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_sso_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sso"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/syslog_agents/new_syslog_collector(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_syslog_collector_account_logs_sources_syslog_agents_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"syslog_agents"],[2,[7,"/"],[2,[6,"new_syslog_collector"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/syslog_agents/new_syslog_collector(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_syslog_collector_organization_logs_sources_syslog_agents_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"syslog_agents"],[2,[7,"/"],[2,[6,"new_syslog_collector"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agents/:agent_id/tasks/new_task_modal(.:format)
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_task_modal_admin_agent_tasks_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"new_task_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /confirmation/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_confirmation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"confirmation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /register(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /unlock/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_unlock_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"unlock"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/google/oauth2callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth2callback_account_integrations_google_tenants_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"google"],[2,[7,"/"],[2,[6,"oauth2callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/microsoft_tenants/oauth2callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth2callback_account_integrations_microsoft_tenants_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"microsoft_tenants"],[2,[7,"/"],[2,[6,"oauth2callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/microsoft_defender/tenants/:id/onboard(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboard_admin_microsoft_defender_tenant_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"microsoft_defender"],[2,[7,"/"],[2,[6,"tenants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"onboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_identity/organizations/onboarding(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_admin_managed_identity_organizations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"onboarding"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/identity_providers/onboarding_details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_details_account_integrations_identity_providers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"identity_providers"],[2,[7,"/"],[2,[6,"onboarding_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_agent_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:agent_id/ai_misuse(.:format)
 * @param {any} organization_id
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_agent_ai_misuse_index_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"ai_misuse"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:agent_id/antivirus(.:format)
 * @param {any} organization_id
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_agent_antivirus_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"antivirus"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:agent_id/antivirus/antivirus_config(.:format)
 * @param {any} organization_id
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_agent_antivirus_antivirus_config_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"antivirus"],[2,[7,"/"],[2,[6,"antivirus_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:agent_id/antivirus_detections/:id(.:format)
 * @param {any} organization_id
 * @param {any} agent_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_agent_antivirus_detection_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"agent_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"antivirus_detections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:agent_id/autoruns/:id(.:format)
 * @param {any} organization_id
 * @param {any} agent_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_agent_autorun_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"agent_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"autoruns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:agent_id/autoruns(.:format)
 * @param {any} organization_id
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_agent_autoruns_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"autoruns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:agent_id/firewall_rules(.:format)
 * @param {any} organization_id
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_agent_firewall_rules_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"firewall_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:agent_id/logs(.:format)
 * @param {any} organization_id
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_agent_logs_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:agent_id/microsoft_defender(.:format)
 * @param {any} organization_id
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_agent_microsoft_defender_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"microsoft_defender"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:agent_id/microsoft_defender_events(.:format)
 * @param {any} organization_id
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_agent_microsoft_defender_events_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"microsoft_defender_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:agent_id/monitored_files(.:format)
 * @param {any} organization_id
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_agent_monitored_files_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"monitored_files"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:agent_id/process_detections/:id(.:format)
 * @param {any} organization_id
 * @param {any} agent_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_agent_process_detection_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"agent_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"process_detections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:agent_id/process_detections(.:format)
 * @param {any} organization_id
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_agent_process_detections_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"process_detections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:agent_id/processes(.:format)
 * @param {any} organization_id
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_agent_processes_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"processes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_agents_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/ai_misuse/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_ai_misuse_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ai_misuse"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/ai_misuse(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_ai_misuse_index_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ai_misuse"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/antivirus_dashboard_active_incidents(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_antivirus_dashboard_active_incidents_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"antivirus_dashboard_active_incidents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/antivirus_dashboard_defender_health(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_antivirus_dashboard_defender_health_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"antivirus_dashboard_defender_health"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/antivirus_dashboard_resolved_incidents(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_antivirus_dashboard_resolved_incidents_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"antivirus_dashboard_resolved_incidents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/antivirus_dashboard_signals_investigated(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_antivirus_dashboard_signals_investigated_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"antivirus_dashboard_signals_investigated"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/antiviruses/antivirus_exclusion_widget(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_antivirus_exclusion_widget_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"antiviruses"],[2,[7,"/"],[2,[6,"antivirus_exclusion_widget"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/antivirus_exclusions(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_antivirus_exclusions_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"antivirus_exclusions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/antivirus_exclusions/settings/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_antivirus_exclusions_setting_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"antivirus_exclusions"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/antivirus_exclusions/settings(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_antivirus_exclusions_settings_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"antivirus_exclusions"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/antivirus_policy(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_antivirus_policy_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"antivirus_policy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/antiviruses(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_antiviruses_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"antiviruses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/assessments/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_assessment_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"assessments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/assessments(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_assessments_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"assessments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/autoruns/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_autorun_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"autoruns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/autoruns(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_autoruns_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"autoruns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/binaries(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_binaries_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"binaries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/binaries/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_binary_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"binaries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/command_center(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_command_center_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"command_center"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/command_center_active_incidents(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_command_center_active_incidents_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"command_center_active_incidents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/command_center_agents(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_command_center_agents_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"command_center_agents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/command_center_antivirus(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_command_center_antivirus_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"command_center_antivirus"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/command_center_escalations(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_command_center_escalations_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"command_center_escalations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/command_center_escalations_widget(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_command_center_escalations_widget_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"command_center_escalations_widget"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/command_center_explore_trial_panel(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_command_center_explore_trial_panel_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"command_center_explore_trial_panel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/command_center_firewall(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_command_center_firewall_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"command_center_firewall"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/command_center_incidents(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_command_center_incidents_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"command_center_incidents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/command_center_macos_agent_status(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_command_center_macos_agent_status_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"command_center_macos_agent_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/command_center_macos_agent_status_banner(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_command_center_macos_agent_status_banner_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"command_center_macos_agent_status_banner"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/command_center_mde_agent_coverage_widget(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_command_center_mde_agent_coverage_widget_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"command_center_mde_agent_coverage_widget"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/command_center_mde_agent_health_widget(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_command_center_mde_agent_health_widget_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"command_center_mde_agent_health_widget"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/command_center_mde_widget(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_command_center_mde_widget_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"command_center_mde_widget"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/command_center_mfa(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_command_center_mfa_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"command_center_mfa"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/command_center_sat_active_learners(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_command_center_sat_active_learners_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"command_center_sat_active_learners"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/command_center_screen_connect(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_command_center_screen_connect_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"command_center_screen_connect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/command_center_security_operations_center_actions(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_command_center_security_operations_center_actions_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"command_center_security_operations_center_actions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/command_center_stat_counts(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_command_center_stat_counts_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"command_center_stat_counts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/command_center_triage_feed(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_command_center_triage_feed_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"command_center_triage_feed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/command_center_user_entities(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_command_center_user_entities_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"command_center_user_entities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/unwanted_access/country_login_events/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_country_login_event_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"unwanted_access"],[2,[7,"/"],[2,[6,"country_login_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/antiviruses/detections(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_detections_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"antiviruses"],[2,[7,"/"],[2,[6,"detections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/edr_dashboard_active_incidents(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_edr_dashboard_active_incidents_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"edr_dashboard_active_incidents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/edr_dashboard_agent_status(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_edr_dashboard_agent_status_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"edr_dashboard_agent_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/edr_dashboard_isolated_host_notice(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_edr_dashboard_isolated_host_notice_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"edr_dashboard_isolated_host_notice"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/edr_dashboard_legacy_os_notice(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_edr_dashboard_legacy_os_notice_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"edr_dashboard_legacy_os_notice"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/edr_dashboard_resolved_incidents(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_edr_dashboard_resolved_incidents_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"edr_dashboard_resolved_incidents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/edr_dashboard_signals_investigated(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_edr_dashboard_signals_investigated_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"edr_dashboard_signals_investigated"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/edr_dashboard_surveys_chart(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_edr_dashboard_surveys_chart_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"edr_dashboard_surveys_chart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/edr_dashboard_systems_protected(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_edr_dashboard_systems_protected_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"edr_dashboard_systems_protected"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/email_security/message_sources(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_email_security_message_sources_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"email_security"],[2,[7,"/"],[2,[6,"message_sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/escalations/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_escalation_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"escalations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/escalations/:escalation_id/escalation_entities(.:format)
 * @param {any} organization_id
 * @param {any} escalation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_escalation_escalation_entities_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"escalation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"escalations"],[2,[7,"/"],[2,[3,"escalation_id"],[2,[7,"/"],[2,[6,"escalation_entities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/escalations(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_escalations_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"escalations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/external_recon(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_external_recon_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"external_recon"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/footholds(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_footholds_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"footholds"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/infection_reports/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_infection_report_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/infection_reports/:infection_report_id/comments/:id(.:format)
 * @param {any} organization_id
 * @param {any} infection_report_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_infection_report_comment_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"infection_report_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/infection_reports/:infection_report_id/comments(.:format)
 * @param {any} organization_id
 * @param {any} infection_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_infection_report_comments_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"infection_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/infection_reports/:infection_report_id/soc_callback_requests(.:format)
 * @param {any} organization_id
 * @param {any} infection_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_infection_report_soc_callback_requests_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"infection_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"soc_callback_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/infection_reports/:infection_report_id/soc_email_conversations(.:format)
 * @param {any} organization_id
 * @param {any} infection_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_infection_report_soc_email_conversations_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"infection_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"soc_email_conversations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/infection_reports/:infection_report_id/soc_support(.:format)
 * @param {any} organization_id
 * @param {any} infection_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_infection_report_soc_support_index_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"infection_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"soc_support"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/infection_reports/:infection_report_id/timeline_event_drawer(.:format)
 * @param {any} organization_id
 * @param {any} infection_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_infection_report_timeline_event_drawer_index_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"infection_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"timeline_event_drawer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/infection_reports/:infection_report_id/timeline_events(.:format)
 * @param {any} organization_id
 * @param {any} infection_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_infection_report_timeline_events_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"infection_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"timeline_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/infection_reports(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_infection_reports_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"infection_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/infections(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_infections_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"infections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/identity_providers/organization_integration_details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_integration_details_account_integrations_identity_providers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"identity_providers"],[2,[7,"/"],[2,[6,"organization_integration_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/ispm/security_control_enforcements/bulk(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_ispm_bulk_security_control_enforcement_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"security_control_enforcements"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/ispm/conditional_access_policies(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_ispm_conditional_access_policies_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"conditional_access_policies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/ispm/conditional_access_policies/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_ispm_conditional_access_policy_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"conditional_access_policies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/ispm/conditional_access_policy_templates/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_ispm_conditional_access_policy_template_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"conditional_access_policy_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/ispm/entitlement(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_ispm_entitlement_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"entitlement"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/ispm/managed_conditional_access_policies(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_ispm_managed_conditional_access_policies_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"managed_conditional_access_policies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/ispm/managed_conditional_access_policies/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_ispm_managed_conditional_access_policy_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"managed_conditional_access_policies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/ispm/security_controls/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_ispm_security_control_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"security_controls"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/ispm/security_control_enforcements(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_ispm_security_control_enforcements_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"security_control_enforcements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/ispm/security_controls/:security_control_id/risk_acceptance(.:format)
 * @param {any} organization_id
 * @param {any} security_control_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_ispm_security_control_risk_acceptance_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"security_control_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"security_controls"],[2,[7,"/"],[2,[3,"security_control_id"],[2,[7,"/"],[2,[6,"risk_acceptance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/ispm/security_control_rollbacks(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_ispm_security_control_rollbacks_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"security_control_rollbacks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/ispm/security_controls/:security_control_id/tasks(.:format)
 * @param {any} organization_id
 * @param {any} security_control_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_ispm_security_control_tasks_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"security_control_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"security_controls"],[2,[7,"/"],[2,[3,"security_control_id"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/ispm/security_controls(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_ispm_security_controls_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"security_controls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/ispm/tasks(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_ispm_tasks_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/ispm/widgets/completed_tasks(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_ispm_widgets_completed_tasks_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"completed_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/ispm/widgets/conditional_access_policies(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_ispm_widgets_conditional_access_policies_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"conditional_access_policies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/ispm/widgets/identities_count(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_ispm_widgets_identities_count_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"identities_count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/ispm/widgets/security_posture(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_ispm_widgets_security_posture_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ispm"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"security_posture"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/query_builders(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_query_builders_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"query_builders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/query_exports/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_query_export_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"query_exports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/query_exports(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_query_exports_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"query_exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/saved_queries(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_saved_queries_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"saved_queries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/saved_queries/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_saved_query_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"saved_queries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/:source_id/activity(.:format)
 * @param {any} organization_id
 * @param {any} source_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_source_activity_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"source_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[3,"source_id"],[2,[7,"/"],[2,[6,"activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/:source_id/activity_settings(.:format)
 * @param {any} organization_id
 * @param {any} source_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_source_activity_settings_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"source_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[3,"source_id"],[2,[7,"/"],[2,[6,"activity_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/arista_syslogs/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_arista_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"arista_syslogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/arista_syslogs(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_arista_syslogs_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"arista_syslogs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/azures/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_azure_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"azures"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/azure/entra_ids/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_azure_entra_id_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"azure"],[2,[7,"/"],[2,[6,"entra_ids"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/azure/generics/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_azure_generic_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"azure"],[2,[7,"/"],[2,[6,"generics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/azure/generic_jsons/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_azure_generic_json_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"azure"],[2,[7,"/"],[2,[6,"generic_jsons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/azure/monitors/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_azure_monitor_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"azure"],[2,[7,"/"],[2,[6,"monitors"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/azure/resources/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_azure_resource_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"azure"],[2,[7,"/"],[2,[6,"resources"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/azures(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_azures_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"azures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/barracuda_cloudgen_syslogs/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_barracuda_cloudgen_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"barracuda_cloudgen_syslogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/barracuda_cloudgen_syslogs(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_barracuda_cloudgen_syslogs_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"barracuda_cloudgen_syslogs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/bitwardens/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_bitwarden_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"bitwardens"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/bitwarden_hecs/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_bitwarden_hec_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"bitwarden_hecs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/bitwarden_hecs(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_bitwarden_hecs_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"bitwarden_hecs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/bitwarden/source_type_selectors(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_bitwarden_source_type_selectors_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"bitwarden"],[2,[7,"/"],[2,[6,"source_type_selectors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/bitwardens(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_bitwardens_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"bitwardens"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/cisco_amps/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_cisco_amp_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cisco_amps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/cisco_amps(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_cisco_amps_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cisco_amps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/cisco_asa_syslogs/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_cisco_asa_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cisco_asa_syslogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/cisco_asa_syslogs(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_cisco_asa_syslogs_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cisco_asa_syslogs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/cisco_ftd_syslogs/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_cisco_ftd_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cisco_ftd_syslogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/cisco_ftd_syslogs(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_cisco_ftd_syslogs_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cisco_ftd_syslogs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/cisco_umbrella_organizations/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_cisco_umbrella_organization_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cisco_umbrella_organizations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/cisco_umbrella_organizations(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_cisco_umbrella_organizations_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cisco_umbrella_organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/cloud_trails/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_cloud_trail_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cloud_trails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/cloud_trails(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_cloud_trails_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cloud_trails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/cloudflare_hecs/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_cloudflare_hec_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cloudflare_hecs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/cloudflare_hecs(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_cloudflare_hecs_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cloudflare_hecs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/crowd_strike/agents/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_crowd_strike_agent_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"crowd_strike"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/crowd_strike_falcons/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_crowd_strike_falcon_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"crowd_strike_falcons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/crowd_strike_falcons(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_crowd_strike_falcons_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"crowd_strike_falcons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/dnsfilter_hecs/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_dnsfilter_hec_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"dnsfilter_hecs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/dnsfilter_hecs(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_dnsfilter_hecs_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"dnsfilter_hecs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/duos/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_duo_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"duos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/duos(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_duos_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"duos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/endpoint_logs(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_endpoint_logs_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"endpoint_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/fortigate_syslogs/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_fortigate_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"fortigate_syslogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/fortigate_syslogs(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_fortigate_syslogs_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"fortigate_syslogs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/generic_hecs/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_generic_hec_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"generic_hecs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/generic_hecs(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_generic_hecs_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"generic_hecs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/generic_s3s/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_generic_s3_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"generic_s3s"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/generic_s3s(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_generic_s3s_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"generic_s3s"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/huntress_organizations/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_huntress_organization_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"huntress_organizations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/huntress_organizations(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_huntress_organizations_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"huntress_organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/itdrs/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_itdr_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"itdrs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/itdrs(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_itdrs_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"itdrs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/keeper_hecs/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_keeper_hec_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"keeper_hecs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/keeper_hecs(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_keeper_hecs_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"keeper_hecs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/lastpass_hecs/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_lastpass_hec_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"lastpass_hecs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/lastpass_hecs(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_lastpass_hecs_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"lastpass_hecs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/linux_events/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_linux_event_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"linux_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/linux_events(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_linux_events_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"linux_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/macos_events/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_macos_event_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"macos_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/macos_events(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_macos_events_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"macos_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/meraki_syslogs/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_meraki_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"meraki_syslogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/meraki_syslogs(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_meraki_syslogs_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"meraki_syslogs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/microsoft_defender_alerts/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_microsoft_defender_alert_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"microsoft_defender_alerts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/microsoft_defender_alerts(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_microsoft_defender_alerts_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"microsoft_defender_alerts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/ninja_one_hecs/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_ninja_one_hec_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"ninja_one_hecs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/ninja_one_hecs(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_ninja_one_hecs_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"ninja_one_hecs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/oktas/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_okta_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"oktas"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/oktas(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_oktas_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"oktas"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/one_passwords/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_one_password_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"one_passwords"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/one_passwords(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_one_passwords_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"one_passwords"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/palo_alto_syslogs/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_palo_alto_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"palo_alto_syslogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/palo_alto_syslogs(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_palo_alto_syslogs_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"palo_alto_syslogs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/pfsense_syslogs/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_pfsense_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"pfsense_syslogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/pfsense_syslogs(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_pfsense_syslogs_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"pfsense_syslogs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/public_syslogs/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_public_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"public_syslogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/public_syslogs/:public_syslog_id/ca_chain(.:format)
 * @param {any} organization_id
 * @param {any} public_syslog_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_public_syslog_ca_chain_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"public_syslog_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"public_syslogs"],[2,[7,"/"],[2,[3,"public_syslog_id"],[2,[7,"/"],[2,[6,"ca_chain"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/public_syslogs/:public_syslog_id/certificate(.:format)
 * @param {any} organization_id
 * @param {any} public_syslog_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_public_syslog_certificate_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"public_syslog_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"public_syslogs"],[2,[7,"/"],[2,[3,"public_syslog_id"],[2,[7,"/"],[2,[6,"certificate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/public_syslogs(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_public_syslogs_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"public_syslogs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/sentinel_one_agent_syslogs/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_sentinel_one_agent_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"sentinel_one_agent_syslogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/sentinel_one_site_syslogs/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_sentinel_one_site_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"sentinel_one_site_syslogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/sonicwall_syslogs/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_sonicwall_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"sonicwall_syslogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/sonicwall_syslogs(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_sonicwall_syslogs_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"sonicwall_syslogs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/sophos_syslogs/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_sophos_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"sophos_syslogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/sophos_syslogs(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_sophos_syslogs_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"sophos_syslogs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/syslogs/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"syslogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/syslog_agents(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_syslog_agents_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"syslog_agents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/syslogs(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_syslogs_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"syslogs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/ubiquiti_syslogs/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_ubiquiti_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"ubiquiti_syslogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/ubiquiti_syslogs(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_ubiquiti_syslogs_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"ubiquiti_syslogs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/watchguard_syslogs/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_watchguard_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"watchguard_syslogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/watchguard_syslogs(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_watchguard_syslogs_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"watchguard_syslogs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/windows_events/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_windows_event_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"windows_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/windows_events(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_windows_events_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"windows_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/wiz_hecs/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_wiz_hec_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"wiz_hecs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/wiz_hecs(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_wiz_hecs_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"wiz_hecs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/wizards/starter(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_wizards_starter_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"wizards"],[2,[7,"/"],[2,[6,"starter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/wizards/syslog(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_sources_wizards_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"wizards"],[2,[7,"/"],[2,[6,"syslog"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/windows_audit_configs/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_windows_audit_config_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"windows_audit_configs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/windows_audit_configs(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_windows_audit_configs_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"windows_audit_configs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/windows_audit_configs/resync(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_logs_windows_audit_configs_resync_index_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"windows_audit_configs"],[2,[7,"/"],[2,[6,"resync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/managed_identity/attribute_rules/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_managed_identity_attribute_rule_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"attribute_rules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/managed_identity/attribute_rules(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_managed_identity_attribute_rules_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"attribute_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/managed_identity(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_managed_identity_detections_table_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"managed_identity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/managed_identity/identities(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_managed_identity_identities_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"identities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/managed_identity/identities/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_managed_identity_identity_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"identities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/managed_identity/identities/:identity_id/attribute_rules(.:format)
 * @param {any} organization_id
 * @param {any} identity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_managed_identity_identity_attribute_rules_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"identity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"identities"],[2,[7,"/"],[2,[3,"identity_id"],[2,[7,"/"],[2,[6,"attribute_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/managed_identity/identities/:identity_id/logged_in_events(.:format)
 * @param {any} organization_id
 * @param {any} identity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_managed_identity_identity_logged_in_events_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"identity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"identities"],[2,[7,"/"],[2,[3,"identity_id"],[2,[7,"/"],[2,[6,"logged_in_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/managed_identity/risky_identities(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_managed_identity_risky_identities_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"risky_identities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/managed_identity/signals(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_managed_identity_signals_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"signals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/managed_identity/user_entities/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_managed_identity_user_entity_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"user_entities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/managed_identity/user_entities/:user_entity_id/licenses(.:format)
 * @param {any} organization_id
 * @param {any} user_entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_managed_identity_user_entity_licenses_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"user_entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"user_entities"],[2,[7,"/"],[2,[3,"user_entity_id"],[2,[7,"/"],[2,[6,"licenses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/member_invitations/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_member_invitation_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"member_invitations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/member_invitations(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_member_invitations_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"member_invitations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/memberships/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_membership_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/memberships(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_memberships_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"memberships"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/microsoft_defender_events/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_microsoft_defender_event_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"microsoft_defender_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/microsoft_defender_events(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_microsoft_defender_events_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"microsoft_defender_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/microsoft_defender_endpoints(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_microsoft_defender_machine_entities_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"microsoft_defender_endpoints"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/microsoft_defender_vulnerabilities/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_microsoft_defender_vulnerability_assessment_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"microsoft_defender_vulnerabilities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/microsoft_defender_vulnerabilities(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_microsoft_defender_vulnerability_assessments_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"microsoft_defender_vulnerabilities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/antivirus_exclusions/settings/organization_modal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_modal_account_antivirus_exclusions_settings_path = /*#__PURE__*/ __jsr.r({"format":{"d":"turbo_stream"}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"antivirus_exclusions"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"organization_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/antivirus_exclusions/settings/organization_modal(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_modal_organization_antivirus_exclusions_settings_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{"d":"turbo_stream"}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"antivirus_exclusions"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"organization_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/persistence/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_persistence_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"persistence"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/persistence/:persistence_id/agents(.:format)
 * @param {any} organization_id
 * @param {any} persistence_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_persistence_agents_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"persistence_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"persistence"],[2,[7,"/"],[2,[3,"persistence_id"],[2,[7,"/"],[2,[6,"agents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/processes(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_processes_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"processes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/ransomware_canaries(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_ransomware_canaries_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ransomware_canaries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/reports/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_report_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/reports(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_reports_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/rogue_apps_application_activity(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_rogue_apps_application_activity_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"rogue_apps_application_activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/rogue_apps/cloud_applications/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_rogue_apps_cloud_application_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"rogue_apps"],[2,[7,"/"],[2,[6,"cloud_applications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/rogue_apps/cloud_applications(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_rogue_apps_cloud_applications_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"rogue_apps"],[2,[7,"/"],[2,[6,"cloud_applications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/rogue_apps(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_rogue_apps_root_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"rogue_apps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/rogue_apps/service_principals/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_rogue_apps_service_principal_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"rogue_apps"],[2,[7,"/"],[2,[6,"service_principals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/rogue_apps/signals(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_rogue_apps_signals_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"rogue_apps"],[2,[7,"/"],[2,[6,"signals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/unwanted_access/rules(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_rules_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"unwanted_access"],[2,[7,"/"],[2,[6,"rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/screen_connect_agent_hosts(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_screen_connect_agent_hosts_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"screen_connect_agent_hosts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/signals/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_signal_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/signals(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_signals_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"signals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/simulated_incidents(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_simulated_incidents_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"simulated_incidents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/soc_callback_requests(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_soc_callback_requests_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"soc_callback_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/unwanted_access_active_incidents(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_unwanted_access_active_incidents_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"unwanted_access_active_incidents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/unwanted_access(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_unwanted_access_index_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"unwanted_access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/unwanted_access_login_events_map(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_unwanted_access_login_events_map_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"unwanted_access_login_events_map"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/unwanted_access_vpn_distribution(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_unwanted_access_vpn_distribution_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"unwanted_access_vpn_distribution"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /account/data_archives/organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizations_account_data_archives_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"data_archives"],[2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /partners/investigations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const partners_investigation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /partners/investigations/:investigation_id/response_plans/:id(.:format)
 * @param {any} investigation_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const partners_investigation_response_plan_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"response_plans"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /partners/investigations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const partners_investigations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[6,"investigations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/data_replays/:id/pause(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pause_admin_data_replay_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"data_replays"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/feature_rollouts/:id/pause(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pause_admin_feature_rollout_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"feature_rollouts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_identity/organizations/:id/perform_health_check(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const perform_health_check_admin_managed_identity_organization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"perform_health_check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /policies/platform(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const platform_policies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"platform"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /policies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const policies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"policies"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /policies/:filename(.:format)
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const policy_path = /*#__PURE__*/ __jsr.r({"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[3,"filename"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/processes/potentially_unsecured_credentials(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const potentially_unsecured_credentials_account_processes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[6,"potentially_unsecured_credentials"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/processes/potentially_unsecured_credentials(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const potentially_unsecured_credentials_organization_processes_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[6,"potentially_unsecured_credentials"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/assessments/samples/preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_account_assessments_samples_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"assessments"],[2,[7,"/"],[2,[6,"samples"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/reports/preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_account_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/infection_reports/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_admin_infection_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/rules/preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_admin_rules_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"rules"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/threatops/analyst_notes/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_admin_threatops_analyst_note_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"analyst_notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/threatops/detections/microsoft_defender_detection_sets/:microsoft_defender_detection_set_priority/event_mappings/preview(.:format)
 * @param {any} microsoft_defender_detection_set_priority
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_admin_threatops_detections_microsoft_defender_detection_set_event_mappings_path = /*#__PURE__*/ __jsr.r({"microsoft_defender_detection_set_priority":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"detections"],[2,[7,"/"],[2,[6,"microsoft_defender_detection_sets"],[2,[7,"/"],[2,[3,"microsoft_defender_detection_set_priority"],[2,[7,"/"],[2,[6,"event_mappings"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/infection_reports/:infection_report_id/sat_assignments/:id/preview_image(.:format)
 * @param {any} infection_report_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_image_account_infection_report_sat_assignment_path = /*#__PURE__*/ __jsr.r({"infection_report_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"sat_assignments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/reports/preview(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_organization_reports_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/view_components/*path(.:format)
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_view_component_path = /*#__PURE__*/ __jsr.r({"path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"view_components"],[2,[7,"/"],[2,[5,[3,"path"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/view_components(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_view_components_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"view_components"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/microsoft_defender_vulnerabilities/previously_seen(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const previously_seen_organization_microsoft_defender_vulnerability_assessments_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"microsoft_defender_vulnerabilities"],[2,[7,"/"],[2,[6,"previously_seen"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/invoices/price_increase_banner_dismissed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const price_increase_banner_dismissed_account_invoices_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"price_increase_banner_dismissed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /privacy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const privacy_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"privacy"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:agent_id/processes/process_events_grid(.:format)
 * @param {any} organization_id
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const process_events_grid_organization_agent_processes_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[6,"process_events_grid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/trials/product(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_account_trials_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"trials"],[2,[7,"/"],[2,[6,"product"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/microsoft_defender_vulnerabilities/product_vendors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_vendors_account_microsoft_defender_vulnerability_assessments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"microsoft_defender_vulnerabilities"],[2,[7,"/"],[2,[6,"product_vendors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/connect_wise/:id/products(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const products_account_integrations_connect_wise_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"connect_wise"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/epochs/:epoch_id/response_plans/:id/propose(.:format)
 * @param {any} investigation_id
 * @param {any} epoch_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const propose_admin_soc_investigation_epoch_response_plan_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"epoch_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"epochs"],[2,[7,"/"],[2,[3,"epoch_id"],[2,[7,"/"],[2,[6,"response_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"propose"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/marketing_assets/:id/publish(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publish_admin_marketing_asset_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"marketing_assets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/threatops/logs/query_history(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const query_history_account_threatops_logs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"query_history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_proxy_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_direct_uploads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encoded_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_proxy_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /services/collector/raw(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const raw_splunk_hec_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"collector"],[2,[7,"/"],[2,[6,"raw"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/binaries/:id/reanalyze_revlabs(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reanalyze_revlabs_admin_binary_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"binaries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reanalyze_revlabs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/microsoft_defender_tenants/:id/reassign(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reassign_account_integrations_microsoft_defender_tenant_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"microsoft_defender_tenants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reassign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/microsoft/reauthorize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reauthorize_account_integrations_cpv_mapping_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"microsoft"],[2,[7,"/"],[2,[6,"reauthorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/microsoft_defender_tenants/:id/reauthorize(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reauthorize_account_integrations_microsoft_defender_tenant_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"microsoft_defender_tenants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reauthorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/google/:id/reauthorize_confirmation(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reauthorize_confirmation_account_integrations_google_tenant_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"google"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reauthorize_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/microsoft_defender/tenants/recent_authorization_failures(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recent_authorization_failures_admin_microsoft_defender_tenants_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"microsoft_defender"],[2,[7,"/"],[2,[6,"tenants"],[2,[7,"/"],[2,[6,"recent_authorization_failures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agents/:agent_id/infection_reports/recent_counts(.:format)
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recent_counts_admin_agent_infection_reports_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[6,"recent_counts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/microsoft_defender/tenants/recent_errors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recent_errors_admin_microsoft_defender_tenants_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"microsoft_defender"],[2,[7,"/"],[2,[6,"tenants"],[2,[7,"/"],[2,[6,"recent_errors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/memberships/:id/recover_modal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recover_modal_account_membership_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"recover_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/memberships/:id/recover_modal(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recover_modal_organization_membership_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"recover_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/memberships/:id/recover_modal(.:format)
 * @param {any} reseller_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recover_modal_reseller_membership_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"recover_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/qc/reviews/:id/refresh(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refresh_admin_soc_qc_review_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"qc"],[2,[7,"/"],[2,[6,"reviews"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refresh"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/windows_event_log_configs/refresh_ttl(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refresh_ttl_admin_windows_event_log_configs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"windows_event_log_configs"],[2,[7,"/"],[2,[6,"refresh_ttl"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/api_credentials/:id/regenerate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regenerate_account_api_credential_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"api_credentials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"regenerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/regenerate_account_key(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regenerate_account_key_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"regenerate_account_key"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/reports/regenerate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regenerate_account_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"regenerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/reports/regenerate(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regenerate_organization_reports_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"regenerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/agents/register(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const register_api_v1_agents_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"agent"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:id/rehydrate_modal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rehydrate_modal_admin_organization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rehydrate_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:id/rehydrate_rio_data(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rehydrate_rio_data_admin_organization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rehydrate_rio_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/espm/app_control/rmm_tools/:id/reject(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reject_account_espm_app_control_rmm_tool_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"app_control"],[2,[7,"/"],[2,[6,"rmm_tools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/infection_reports/:infection_report_id/remediations/reject(.:format)
 * @param {any} infection_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reject_account_infection_report_remediations_path = /*#__PURE__*/ __jsr.r({"infection_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"remediations"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/espm/rmm_tool_candidates/:id/reject(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reject_admin_espm_rmm_tool_candidate_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"rmm_tool_candidates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/infection_reports/:infection_report_id/remediations/reject(.:format)
 * @param {any} organization_id
 * @param {any} infection_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reject_organization_infection_report_remediations_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"infection_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"remediations"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /partners/investigations/:id/reject(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reject_partners_investigation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agentic/configuration/rejected_report_estimate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rejected_report_estimate_admin_soc_agentic_configuration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agentic"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"rejected_report_estimate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/signals/:id/release(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const release_admin_signal_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"release"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:id/release(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const release_organization_agent_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"release"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/threatops/logs/investigations/:investigation_id/items/:log_uuid(.:format)
 * @param {any} investigation_id
 * @param {any} log_uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_from_investigation_account_threatops_logs_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"log_uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"log_uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/remove_logo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_logo_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"remove_logo"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/escalations/remove(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_organization_escalations_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"escalations"],[2,[7,"/"],[2,[6,"remove"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /invitation/remove(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_user_invitation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"invitation"],[2,[7,"/"],[2,[6,"remove"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/infection_reports/:id/reopen(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reopen_admin_infection_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reopen"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:id/reopen(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reopen_admin_soc_investigation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reopen"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/epochs/:id/reopen(.:format)
 * @param {any} investigation_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reopen_admin_soc_investigation_epoch_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"epochs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reopen"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/epochs/:epoch_id/response_plans/:response_plan_id/remediations/reorder(.:format)
 * @param {any} investigation_id
 * @param {any} epoch_id
 * @param {any} response_plan_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reorder_admin_soc_investigation_epoch_response_plan_remediations_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"epoch_id":{"r":true},"response_plan_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"epochs"],[2,[7,"/"],[2,[3,"epoch_id"],[2,[7,"/"],[2,[6,"response_plans"],[2,[7,"/"],[2,[3,"response_plan_id"],[2,[7,"/"],[2,[6,"remediations"],[2,[7,"/"],[2,[6,"reorder"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/signals/report_multi_entity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_multi_entity_admin_signals_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[6,"report_multi_entity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/email_download/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_email_download_path = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"email_download"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reseller_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/accounts/:id(.:format)
 * @param {any} reseller_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reseller_account_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/accounts/:account_id/aggregator_subscriptions(.:format)
 * @param {any} reseller_id
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reseller_account_aggregator_subscriptions_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"account_id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"aggregator_subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/accounts/:account_id/subscriptions/:id(.:format)
 * @param {any} reseller_id
 * @param {any} account_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reseller_account_subscription_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"account_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/accounts/:account_id/subscriptions(.:format)
 * @param {any} reseller_id
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reseller_account_subscriptions_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"account_id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/accounts(.:format)
 * @param {any} reseller_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reseller_accounts_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/api_credentials/:id(.:format)
 * @param {any} reseller_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reseller_api_credential_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"api_credentials"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/api_credentials(.:format)
 * @param {any} reseller_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reseller_api_credentials_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"api_credentials"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/billing(.:format)
 * @param {any} reseller_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reseller_billing_index_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reseller_contract_terms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reseller_contract_terms_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reseller_contract_terms"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/contracts(.:format)
 * @param {any} reseller_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reseller_contracts_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"contracts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/invoices/:id(.:format)
 * @param {any} reseller_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reseller_invoice_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/invoices/:invoice_id/product_usage_reports/:id(.:format)
 * @param {any} reseller_id
 * @param {any} invoice_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reseller_invoice_product_usage_report_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"invoice_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"invoice_id"],[2,[7,"/"],[2,[6,"product_usage_reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/invoices(.:format)
 * @param {any} reseller_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reseller_invoices_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/marketing_assets/:id(.:format)
 * @param {any} reseller_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reseller_marketing_asset_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"marketing_assets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/marketing_assets(.:format)
 * @param {any} reseller_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reseller_marketing_assets_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"marketing_assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/memberships/:id(.:format)
 * @param {any} reseller_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reseller_membership_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/memberships(.:format)
 * @param {any} reseller_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reseller_memberships_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"memberships"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /policies/reseller(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reseller_policies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"reseller"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/subscriptions(.:format)
 * @param {any} reseller_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reseller_subscriptions_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/:integration_id/psa_tickets/:id/resend(.:format)
 * @param {any} integration_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_account_integration_psa_ticket_path = /*#__PURE__*/ __jsr.r({"integration_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"integration_id"],[2,[7,"/"],[2,[6,"psa_tickets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/resend_confirmation_instructions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_confirmation_instructions_admin_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_confirmation_instructions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/resend_invitation(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_invitation_admin_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_invitation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/escalations/:id/resend_reports(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_reports_account_escalation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"escalations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/escalations/:id/resend_reports(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_reports_admin_escalation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"escalations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/escalations/:id/resend_reports(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_reports_organization_escalation_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"escalations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/arista_syslogs/:id/reset(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_account_logs_sources_arista_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"arista_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/barracuda_cloudgen_syslogs/:id/reset(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_account_logs_sources_barracuda_cloudgen_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"barracuda_cloudgen_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/cisco_asa_syslogs/:id/reset(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_account_logs_sources_cisco_asa_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cisco_asa_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/cisco_ftd_syslogs/:id/reset(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_account_logs_sources_cisco_ftd_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cisco_ftd_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/fortigate_syslogs/:id/reset(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_account_logs_sources_fortigate_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"fortigate_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/meraki_syslogs/:id/reset(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_account_logs_sources_meraki_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"meraki_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/palo_alto_syslogs/:id/reset(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_account_logs_sources_palo_alto_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"palo_alto_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/pfsense_syslogs/:id/reset(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_account_logs_sources_pfsense_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"pfsense_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/sentinel_one_agent_syslogs/:id/reset(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_account_logs_sources_sentinel_one_agent_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"sentinel_one_agent_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/sentinel_one_site_syslogs/:id/reset(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_account_logs_sources_sentinel_one_site_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"sentinel_one_site_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/sentinel_one_syslogs/:id/reset(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_account_logs_sources_sentinel_one_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"sentinel_one_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/sonicwall_syslogs/:id/reset(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_account_logs_sources_sonicwall_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"sonicwall_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/sophos_syslogs/:id/reset(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_account_logs_sources_sophos_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"sophos_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/syslogs/:id/reset(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_account_logs_sources_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/ubiquiti_syslogs/:id/reset(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_account_logs_sources_ubiquiti_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"ubiquiti_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/watchguard_syslogs/:id/reset(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_account_logs_sources_watchguard_syslog_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"watchguard_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:agent_id/monitored_files/reset_canaries(.:format)
 * @param {any} organization_id
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_canaries_organization_agent_monitored_files_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"monitored_files"],[2,[7,"/"],[2,[6,"reset_canaries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/arista_syslogs/:id/reset(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_organization_logs_sources_arista_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"arista_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/barracuda_cloudgen_syslogs/:id/reset(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_organization_logs_sources_barracuda_cloudgen_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"barracuda_cloudgen_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/cisco_asa_syslogs/:id/reset(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_organization_logs_sources_cisco_asa_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cisco_asa_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/cisco_ftd_syslogs/:id/reset(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_organization_logs_sources_cisco_ftd_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"cisco_ftd_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/fortigate_syslogs/:id/reset(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_organization_logs_sources_fortigate_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"fortigate_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/meraki_syslogs/:id/reset(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_organization_logs_sources_meraki_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"meraki_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/palo_alto_syslogs/:id/reset(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_organization_logs_sources_palo_alto_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"palo_alto_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/pfsense_syslogs/:id/reset(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_organization_logs_sources_pfsense_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"pfsense_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/sonicwall_syslogs/:id/reset(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_organization_logs_sources_sonicwall_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"sonicwall_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/sophos_syslogs/:id/reset(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_organization_logs_sources_sophos_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"sophos_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/syslogs/:id/reset(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_organization_logs_sources_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/ubiquiti_syslogs/:id/reset(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_organization_logs_sources_ubiquiti_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"ubiquiti_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/watchguard_syslogs/:id/reset(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_organization_logs_sources_watchguard_syslog_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"watchguard_syslogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/escalations/:id/resolve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolve_account_escalation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"escalations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/escalations/:escalation_id/escalation_entities/resolve(.:format)
 * @param {any} escalation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolve_account_escalation_escalation_entities_path = /*#__PURE__*/ __jsr.r({"escalation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"escalations"],[2,[7,"/"],[2,[3,"escalation_id"],[2,[7,"/"],[2,[6,"escalation_entities"],[2,[7,"/"],[2,[6,"resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/escalations/:escalation_id/escalation_entities/:id/resolve(.:format)
 * @param {any} escalation_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolve_account_escalation_escalation_entity_path = /*#__PURE__*/ __jsr.r({"escalation_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"escalations"],[2,[7,"/"],[2,[3,"escalation_id"],[2,[7,"/"],[2,[6,"escalation_entities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/infection_reports/:id/resolve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolve_account_infection_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/inquiries/:id/resolve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolve_account_inquiry_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"inquiries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/escalations/:id/resolve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolve_admin_escalation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"escalations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/epochs/:id/resolve(.:format)
 * @param {any} investigation_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolve_admin_soc_investigation_epoch_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"epochs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/escalations/:id/resolve(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolve_organization_escalation_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"escalations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/escalations/:escalation_id/escalation_entities/resolve(.:format)
 * @param {any} organization_id
 * @param {any} escalation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolve_organization_escalation_escalation_entities_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"escalation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"escalations"],[2,[7,"/"],[2,[3,"escalation_id"],[2,[7,"/"],[2,[6,"escalation_entities"],[2,[7,"/"],[2,[6,"resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/escalations/:escalation_id/escalation_entities/:id/resolve(.:format)
 * @param {any} organization_id
 * @param {any} escalation_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolve_organization_escalation_escalation_entity_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"escalation_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"escalations"],[2,[7,"/"],[2,[3,"escalation_id"],[2,[7,"/"],[2,[6,"escalation_entities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/infection_reports/:id/resolve(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolve_organization_infection_report_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/inquiries/:id/resolve(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolve_organization_inquiry_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"inquiries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rest_api_api_controller_path = /*#__PURE__*/ __jsr.r({"subdomain":{"d":"api"}}, [7,"/"]);

/**
 * Generates rails route to
 * /admin/dead_jobs/:id/retry(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retry_admin_dead_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dead_jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/epochs/:epoch_id/response_plans/:response_plan_id/remediations/:id/retry_remediation(.:format)
 * @param {any} investigation_id
 * @param {any} epoch_id
 * @param {any} response_plan_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retry_remediation_admin_soc_investigation_epoch_response_plan_remediation_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"epoch_id":{"r":true},"response_plan_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"epochs"],[2,[7,"/"],[2,[3,"epoch_id"],[2,[7,"/"],[2,[6,"response_plans"],[2,[7,"/"],[2,[3,"response_plan_id"],[2,[7,"/"],[2,[6,"remediations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry_remediation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/agentic/investigations/:id/retry_step(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retry_step_admin_soc_agentic_investigation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"agentic"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry_step"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/quotes/:id/review(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const review_account_quote_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"quotes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/subscriptions/review(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const review_account_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:id/review(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const review_admin_soc_investigation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/epochs/:epoch_id/response_plans/:id/review(.:format)
 * @param {any} investigation_id
 * @param {any} epoch_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const review_admin_soc_investigation_epoch_response_plan_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"epoch_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"epochs"],[2,[7,"/"],[2,[3,"epoch_id"],[2,[7,"/"],[2,[6,"response_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/autoruns/:id/reviewed(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reviewed_admin_autorun_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"autoruns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reviewed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/binaries/revlabs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revlabs_admin_binaries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"binaries"],[2,[7,"/"],[2,[6,"revlabs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/managed_identity/identities/:identity_id/tasks/revoke_identity_sessions(.:format)
 * @param {any} identity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revoke_identity_sessions_account_managed_identity_identity_tasks_path = /*#__PURE__*/ __jsr.r({"identity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"identities"],[2,[7,"/"],[2,[3,"identity_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"revoke_identity_sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_identity/identities/:identity_id/tasks/revoke_identity_sessions(.:format)
 * @param {any} identity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revoke_identity_sessions_admin_managed_identity_identity_tasks_path = /*#__PURE__*/ __jsr.r({"identity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"identities"],[2,[7,"/"],[2,[3,"identity_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"revoke_identity_sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:id/rio_override_tags(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rio_override_tags_admin_organization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rio_override_tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:id/rio_override_tags_modal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rio_override_tags_modal_admin_organization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rio_override_tags_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agents/:id/rio_survey(/:target_events)(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rio_survey_admin_agent_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"target_events":{},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rio_survey"],[2,[1,[2,[7,"/"],[3,"target_events"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/installer/rmm(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rmm_account_installer_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"installer"],[2,[7,"/"],[2,[6,"rmm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rob2025(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rob2025_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rob2025"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /account/rogue_apps_application_activity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rogue_apps_application_activity_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"rogue_apps_application_activity"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/roles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const roles_admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_path = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /sso(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_sso_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sso"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/billing/goalie_tasks/:id/run(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const run_admin_billing_goalie_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"goalie_tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"run"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /salesforce/accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const salesforce_accounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"salesforce"],[2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /salesforce/quotes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const salesforce_quotes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"salesforce"],[2,[7,"/"],[2,[6,"quotes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sat_msp_contract_terms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sat_msp_contract_terms_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sat_msp_contract_terms"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/accounts/:id/sat_trial_readiness(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sat_trial_readiness_admin_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sat_trial_readiness"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:agent_id/antivirus/scan(.:format)
 * @param {any} organization_id
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scan_organization_agent_antivirus_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"antivirus"],[2,[7,"/"],[2,[6,"scan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /scanapi/*unmatched_route(.:format)
 * @param {any} unmatched_route
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scanapi_path = /*#__PURE__*/ __jsr.r({"unmatched_route":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scanapi"],[2,[7,"/"],[2,[5,[3,"unmatched_route"]],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scanapi/v1/agent/:platform/:architecture(.:format)
 * @param {any} platform
 * @param {any} architecture
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scanapi__agent_path = /*#__PURE__*/ __jsr.r({"platform":{"r":true},"architecture":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scanapi"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"agent"],[2,[7,"/"],[2,[3,"platform"],[2,[7,"/"],[2,[3,"architecture"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /scanapi/v1/scans/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scanapi__scan_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scanapi"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scans"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /scanapi/v1/scans/:scan_id/surveys(.:format)
 * @param {any} scan_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scanapi__scan_surveys_path = /*#__PURE__*/ __jsr.r({"scan_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scanapi"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scans"],[2,[7,"/"],[2,[3,"scan_id"],[2,[7,"/"],[2,[6,"surveys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /scanapi/v1/sites/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scanapi__site_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scanapi"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /scanapi/v1/sites/:site_id/scans(.:format)
 * @param {any} site_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scanapi__site_scans_path = /*#__PURE__*/ __jsr.r({"site_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scanapi"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"site_id"],[2,[7,"/"],[2,[6,"scans"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /scanapi/v1/sites(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scanapi__sites_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"scanapi"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sites"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/investigation_notes/:id/screenshot_actions(.:format)
 * @param {any} investigation_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const screenshot_actions_admin_soc_investigation_investigation_note_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"investigation_notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"screenshot_actions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/notify/autotask/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_admin_notify_autotask_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"notify"],[2,[7,"/"],[2,[6,"autotask"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/notify/connectwise/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_admin_notify_connectwise_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"notify"],[2,[7,"/"],[2,[6,"connectwise"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/notify/halo_psa/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_admin_notify_halo_psa_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"notify"],[2,[7,"/"],[2,[6,"halo_psa"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/notify/kaseya/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_admin_notify_kaseya_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"notify"],[2,[7,"/"],[2,[6,"kaseya"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/notify/syncro/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_admin_notify_syncro_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"notify"],[2,[7,"/"],[2,[6,"syncro"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/threatops/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_admin_threatops_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /secure_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const secure_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"secure_account"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /secure_account/backup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const secure_account_backup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"secure_account"],[2,[7,"/"],[2,[6,"backup"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /secure_account/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const secure_account_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"secure_account"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /secure_account/totp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const secure_account_totp_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"secure_account"],[2,[7,"/"],[2,[6,"totp"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/security_awareness_training(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_awareness_training_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"security_awareness_training"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/agents/select2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select2_account_agents_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"select2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/microsoft_defender_tenants/:microsoft_defender_tenant_id/microsoft_defender_tenant_aliases/select2(.:format)
 * @param {any} microsoft_defender_tenant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select2_account_integrations_microsoft_defender_tenant_aliases_path = /*#__PURE__*/ __jsr.r({"microsoft_defender_tenant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"microsoft_defender_tenants"],[2,[7,"/"],[2,[3,"microsoft_defender_tenant_id"],[2,[7,"/"],[2,[6,"microsoft_defender_tenant_aliases"],[2,[7,"/"],[2,[6,"select2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/select2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select2_account_logs_sources_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"select2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/managed_identity/identities/select2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select2_account_managed_identity_identities_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"identities"],[2,[7,"/"],[2,[6,"select2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/organizations/select2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select2_account_organizations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"select2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/signals/select2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select2_account_signals_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[6,"select2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/accounts/:account_id/organizations/select2(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select2_admin_account_organizations_path = /*#__PURE__*/ __jsr.r({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"select2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/accounts/select2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select2_admin_accounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"select2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agents/select2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select2_admin_agents_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"select2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/select2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select2_admin_organizations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"select2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resellers/select2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select2_admin_resellers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[6,"select2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/select2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select2_admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"select2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/windows_events/select2_agents(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select2_agents_organization_logs_sources_windows_events_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"windows_events"],[2,[7,"/"],[2,[6,"select2_agents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/select2(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select2_organization_agents_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"select2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/security_awareness_training/organization_mappings/select2_sub_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select2_sub_accounts_account_security_awareness_training_organization_mappings_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"security_awareness_training"],[2,[7,"/"],[2,[6,"organization_mappings"],[2,[7,"/"],[2,[6,"select2_sub_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /selector(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const selector_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"selector"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /account/notification_contacts/:id/send_code(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_code_account_notification_contact_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"notification_contacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/inquiries/:id/send_report(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_report_account_inquiry_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"inquiries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/inquiries/:id/send_report(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_report_organization_inquiry_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"inquiries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/autotask/:id/services(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const services_account_integrations_autotask_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"autotask"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"services"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/google/setup_instructions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setup_instructions_account_integrations_google_tenants_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"google"],[2,[7,"/"],[2,[6,"setup_instructions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /multi_factor/backup/setup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setup_user_multi_factor_backup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"multi_factor"],[2,[7,"/"],[2,[6,"backup"],[2,[7,"/"],[2,[6,"setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /multi_factor/duo/setup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setup_user_multi_factor_duo_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"multi_factor"],[2,[7,"/"],[2,[6,"duo"],[2,[7,"/"],[2,[6,"setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /multi_factor/totp/setup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setup_user_multi_factor_totp_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"multi_factor"],[2,[7,"/"],[2,[6,"totp"],[2,[7,"/"],[2,[6,"setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/binaries/sha256/:sha256(.:format)
 * @param {any} sha256
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sha256_admin_binaries_path = /*#__PURE__*/ __jsr.r({"sha256":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"binaries"],[2,[7,"/"],[2,[6,"sha256"],[2,[7,"/"],[2,[3,"sha256"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_assets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shareable_marketing_asset_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing_assets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/endpoint_logs/org/:organization_id/:platform_type/agents(.:format)
 * @param {any} organization_id
 * @param {any} platform_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_account_logs_sources_endpoint_logs_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"platform_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"endpoint_logs"],[2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[3,"platform_type"],[2,[7,"/"],[2,[6,"agents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/antivirus_detections/:id/show_details(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_details_admin_antivirus_detection_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"antivirus_detections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/signal_events/:id/show_details(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_details_admin_signal_event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signal_events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:agent_id/antivirus_detections/:id/show_details(.:format)
 * @param {any} organization_id
 * @param {any} agent_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_details_organization_agent_antivirus_detection_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"agent_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"antivirus_detections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/signals/:id/show_event_details(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_event_details_organization_signal_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_event_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/qc/reviews/:id/show_navigation(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_navigation_admin_soc_qc_review_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"qc"],[2,[7,"/"],[2,[6,"reviews"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_navigation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/endpoint_logs/:platform_type/agents(.:format)
 * @param {any} organization_id
 * @param {any} platform_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_organization_logs_sources_endpoint_logs_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"platform_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"endpoint_logs"],[2,[7,"/"],[2,[3,"platform_type"],[2,[7,"/"],[2,[6,"agents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/sidekiq
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sidekiq_web_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"sidekiq"]]]]);

/**
 * Generates rails route to
 * /account/logs/:uuid/signal(.:format)
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signal_account_log_path = /*#__PURE__*/ __jsr.r({"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[3,"uuid"],[2,[7,"/"],[2,[6,"signal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/threatops/logs/:uuid/signal(.:format)
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signal_account_threatops_log_path = /*#__PURE__*/ __jsr.r({"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[3,"uuid"],[2,[7,"/"],[2,[6,"signal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/threatops/logs/:uuid/signal(.:format)
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signal_admin_threatops_log_path = /*#__PURE__*/ __jsr.r({"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[3,"uuid"],[2,[7,"/"],[2,[6,"signal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/:uuid/signal(.:format)
 * @param {any} organization_id
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signal_organization_log_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[3,"uuid"],[2,[7,"/"],[2,[6,"signal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/infection_reports/:id/signals(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signals_account_infection_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"signals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/processes/signals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signals_account_processes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[6,"signals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:id/signals(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signals_organization_agent_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"signals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:agent_id/ai_misuse/signals(.:format)
 * @param {any} organization_id
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signals_organization_agent_ai_misuse_index_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"ai_misuse"],[2,[7,"/"],[2,[6,"signals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:agent_id/antivirus_detections/signals(.:format)
 * @param {any} organization_id
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signals_organization_agent_antivirus_detections_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"antivirus_detections"],[2,[7,"/"],[2,[6,"signals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:agent_id/microsoft_defender_detections/signals(.:format)
 * @param {any} organization_id
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signals_organization_agent_microsoft_defender_detections_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"microsoft_defender_detections"],[2,[7,"/"],[2,[6,"signals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:agent_id/process_detections/signals(.:format)
 * @param {any} organization_id
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signals_organization_agent_process_detections_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"process_detections"],[2,[7,"/"],[2,[6,"signals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/infection_reports/:id/signals(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signals_organization_infection_report_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"signals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/managed_identity/identities/:id/signals(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signals_organization_managed_identity_identity_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"identities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"signals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/managed_identity/user_entities/:id/signals(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signals_organization_managed_identity_user_entity_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"user_entities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"signals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/processes/signals(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signals_organization_processes_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"processes"],[2,[7,"/"],[2,[6,"signals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:agent_id/antivirus/signature_update(.:format)
 * @param {any} organization_id
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signature_update_organization_agent_antivirus_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"antivirus"],[2,[7,"/"],[2,[6,"signature_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /signups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signups_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"signups"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/:id/smart_filter_stats(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const smart_filter_stats_account_logs_source_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"smart_filter_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/sources/smart_filter_stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const smart_filter_stats_account_logs_sources_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"smart_filter_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/:id/smart_filter_stats(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const smart_filter_stats_organization_logs_source_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"smart_filter_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/sources/smart_filter_stats(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const smart_filter_stats_organization_logs_sources_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"smart_filter_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/infection_reports/:infection_report_id/soc_support/soc_support_button_clicked(.:format)
 * @param {any} infection_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const soc_support_button_clicked_account_infection_report_soc_support_index_path = /*#__PURE__*/ __jsr.r({"infection_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"soc_support"],[2,[7,"/"],[2,[6,"soc_support_button_clicked"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/infection_reports/:infection_report_id/soc_support/soc_support_button_clicked(.:format)
 * @param {any} organization_id
 * @param {any} infection_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const soc_support_button_clicked_organization_infection_report_soc_support_index_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"infection_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"soc_support"],[2,[7,"/"],[2,[6,"soc_support_button_clicked"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/epochs/:epoch_id/response_plans/:response_plan_id/remediations/sort_to_execution_order(.:format)
 * @param {any} investigation_id
 * @param {any} epoch_id
 * @param {any} response_plan_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sort_to_execution_order_admin_soc_investigation_epoch_response_plan_remediations_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"epoch_id":{"r":true},"response_plan_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"epochs"],[2,[7,"/"],[2,[3,"epoch_id"],[2,[7,"/"],[2,[6,"response_plans"],[2,[7,"/"],[2,[3,"response_plan_id"],[2,[7,"/"],[2,[6,"remediations"],[2,[7,"/"],[2,[6,"sort_to_execution_order"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/windows_audit_configs/source_banner(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const source_banner_account_logs_windows_audit_configs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"windows_audit_configs"],[2,[7,"/"],[2,[6,"source_banner"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/windows_audit_configs/source_banner(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const source_banner_organization_logs_windows_audit_configs_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"windows_audit_configs"],[2,[7,"/"],[2,[6,"source_banner"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /services/collector(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const splunk_hec_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"collector"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sso/auth(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sso_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sso"],[2,[7,"/"],[2,[6,"auth"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/staff(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staff_admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"staff"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/data_replays/:id/start(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const start_admin_data_replay_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"data_replays"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"start"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/feature_rollouts/:id/start(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const start_admin_feature_rollout_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"feature_rollouts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"start"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/threatops/stat_counts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stat_counts_admin_threatops_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"stat_counts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/connect_wise/:id/statuses(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statuses_account_integrations_connect_wise_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"connect_wise"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"statuses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /stripe_4cfsj3ifyn
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripe_event_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"stripe_4cfsj3ifyn"]]);

/**
 * Generates rails route to
 * /stripe_4cfsj3ifyn/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripe_event_root_path = /*#__PURE__*/ __jsr.r({}, [2,[2,[7,"/"],[6,"stripe_4cfsj3ifyn"]],[7,"/"]]);

/**
 * Generates rails route to
 * /account/invoices/:id/stripe_receipt(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripe_receipt_account_invoice_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"stripe_receipt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/invoices/:id/stripe_receipt(.:format)
 * @param {any} reseller_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripe_receipt_reseller_invoice_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"stripe_receipt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/binaries/:id/submit_to_assemblyline(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submit_to_assemblyline_admin_binary_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"binaries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"submit_to_assemblyline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /newsletter/subscribe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscribe_newsletter_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"newsletter"],[2,[7,"/"],[2,[6,"subscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_identity/organizations/:id/subscribe_webhook(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscribe_webhook_admin_managed_identity_organization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"subscribe_webhook"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/connect_wise/:id/subtypes(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subtypes_account_integrations_connect_wise_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"connect_wise"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"subtypes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/signals/:id/suppress_correlated_modal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const suppress_correlated_modal_admin_signal_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"suppress_correlated_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agents/:id/survey(/:date)(/:time)(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const survey_admin_agent_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"date":{},"time":{},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"survey"],[2,[1,[2,[7,"/"],[3,"date"]]],[2,[1,[2,[7,"/"],[3,"time"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scan_results/:id/survey(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const survey_admin_scan_result_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scan_results"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"survey"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agents/:id/survey/latest(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const survey_latest_admin_agent_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"survey"],[2,[7,"/"],[2,[6,"latest"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agents/:id/survey/latest_edr(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const survey_latest_edr_admin_agent_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"survey"],[2,[7,"/"],[2,[6,"latest_edr"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/internal_api_docs/swagger_doc(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const swagger_doc_admin_internal_api_docs_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"internal_api_docs"],[2,[7,"/"],[2,[6,"swagger_doc"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/autotask/:id/sync_billing(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sync_billing_account_integrations_autotask_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"autotask"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sync_billing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/halo_psa/:id/sync_billing(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sync_billing_account_integrations_halo_psa_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"halo_psa"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sync_billing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/escalations/:id/task_network_test(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_network_test_account_escalation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"escalations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"task_network_test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /terms_of_service(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const terms_of_service_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"terms_of_service"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /account/integrations/webhooks/:id/test_endpoint(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const test_endpoint_account_integrations_webhook_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"test_endpoint"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/threatops/logs/threat_intel_lookup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const threat_intel_lookup_account_threatops_logs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"threat_intel_lookup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:id/timeline(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timeline_admin_soc_investigation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"timeline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/soc/investigations/:investigation_id/investigation_notes/:id/toggle_athena_exclusion(.:format)
 * @param {any} investigation_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_athena_exclusion_admin_soc_investigation_investigation_note_path = /*#__PURE__*/ __jsr.r({"investigation_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"soc"],[2,[7,"/"],[2,[6,"investigations"],[2,[7,"/"],[2,[3,"investigation_id"],[2,[7,"/"],[2,[6,"investigation_notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_athena_exclusion"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/toggle_auto_remediations_severity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_auto_remediations_severity_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"toggle_auto_remediations_severity"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/subscription/toggle_auto_renew(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_auto_renew_account_subscription_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"subscription"],[2,[7,"/"],[2,[6,"toggle_auto_renew"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/infection_reports/:infection_report_id/remediations/:id/toggle_complete(.:format)
 * @param {any} infection_report_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_complete_account_infection_report_remediation_path = /*#__PURE__*/ __jsr.r({"infection_report_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"remediations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/infection_reports/:infection_report_id/remediations/:id/toggle_complete(.:format)
 * @param {any} organization_id
 * @param {any} infection_report_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_complete_organization_infection_report_remediation_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"infection_report_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"infection_reports"],[2,[7,"/"],[2,[3,"infection_report_id"],[2,[7,"/"],[2,[6,"remediations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agent_rollouts/toggle_killswitch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_killswitch_admin_agent_rollouts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agent_rollouts"],[2,[7,"/"],[2,[6,"toggle_killswitch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/webhooks/:id/toggle_notification_category_for_endpoint(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_notification_category_for_endpoint_account_integrations_webhook_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_notification_category_for_endpoint"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/rules/:id/toggle_status(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_status_admin_rule_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"rules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/accounts/:id/toggle_threatops_notifications(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_threatops_notifications_admin_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_threatops_notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/microsoft_defender_vulnerabilities/top_cves(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const top_cves_organization_microsoft_defender_vulnerability_assessments_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"microsoft_defender_vulnerabilities"],[2,[7,"/"],[2,[6,"top_cves"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/logs/top_orgs_card(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const top_orgs_card_account_logs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"top_orgs_card"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/microsoft_defender_vulnerabilities/top_products(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const top_products_organization_microsoft_defender_vulnerability_assessments_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"microsoft_defender_vulnerabilities"],[2,[7,"/"],[2,[6,"top_products"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/logs/top_sources_card(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const top_sources_card_organization_logs_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"top_sources_card"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /multi_factor/setup/totp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const totp_user_multi_factor_setup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"multi_factor"],[2,[7,"/"],[2,[6,"setup"],[2,[7,"/"],[2,[6,"totp"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/espm/app_control/policies/:id/triage(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const triage_account_espm_app_control_policy_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"app_control"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"triage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/trials/trial_end(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trial_end_account_trials_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"trials"],[2,[7,"/"],[2,[6,"trial_end"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /hubspot/cards/account/trial(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trial_hubspot_cards_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hubspot"],[2,[7,"/"],[2,[6,"cards"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"trial"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /recede_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_recede_historical_location_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"recede_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /refresh_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_refresh_historical_location_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"refresh_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /resume_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_resume_historical_location_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"resume_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /account/integrations/connect_wise/:id/types(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const types_account_integrations_connect_wise_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"connect_wise"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscriptions/:id/unapprove(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unapprove_admin_subscription_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unapprove"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/agents/:agent_id/firewall_rules/unblock(.:format)
 * @param {any} organization_id
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unblock_organization_agent_firewall_rules_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"agent_id"],[2,[7,"/"],[2,[6,"firewall_rules"],[2,[7,"/"],[2,[6,"unblock"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_identity/organizations/unhealthy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unhealthy_admin_managed_identity_organizations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"unhealthy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/tasks/uninstall(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uninstall_api_v1_tasks_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"agent"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"uninstall"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/google/:id/unmap_confirmation(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unmap_confirmation_account_integrations_google_tenant_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"google"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unmap_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/microsoft_tenants/:id/unmap_confirmation(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unmap_confirmation_account_integrations_microsoft_tenant_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"microsoft_tenants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unmap_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/marketing_assets/:id/unpublish(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unpublish_admin_marketing_asset_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"marketing_assets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unpublish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/espm/app_control/rmm_tools/:id/unreject(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unreject_account_espm_app_control_rmm_tool_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"espm"],[2,[7,"/"],[2,[6,"app_control"],[2,[7,"/"],[2,[6,"rmm_tools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unreject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/escalations/:escalation_id/escalation_entities/:id/unresolve(.:format)
 * @param {any} escalation_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unresolve_account_escalation_escalation_entity_path = /*#__PURE__*/ __jsr.r({"escalation_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"escalations"],[2,[7,"/"],[2,[3,"escalation_id"],[2,[7,"/"],[2,[6,"escalation_entities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unresolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/escalations/:escalation_id/escalation_entities/:id/unresolve(.:format)
 * @param {any} organization_id
 * @param {any} escalation_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unresolve_organization_escalation_escalation_entity_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"escalation_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"escalations"],[2,[7,"/"],[2,[3,"escalation_id"],[2,[7,"/"],[2,[6,"escalation_entities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unresolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/unwanted_access_active_incidents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unwanted_access_active_incidents_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"unwanted_access_active_incidents"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/unwanted_access_login_events_map(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unwanted_access_login_events_map_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"unwanted_access_login_events_map"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/unwanted_access_vpn_distribution(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unwanted_access_vpn_distribution_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"unwanted_access_vpn_distribution"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/accounts/:account_id/subscriptions/:id/update_autorenew(.:format)
 * @param {any} reseller_id
 * @param {any} account_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_autorenew_reseller_account_subscription_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"account_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_autorenew"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/rio_config/update_default(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_default_admin_rio_configs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"rio_config"],[2,[7,"/"],[2,[6,"update_default"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agent_releases/update_defaults(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_defaults_admin_agent_releases_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agent_releases"],[2,[7,"/"],[2,[6,"update_defaults"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/antivirus_exclusions/update_exclusions_mode(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_exclusions_mode_account_antivirus_exclusions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"antivirus_exclusions"],[2,[7,"/"],[2,[6,"update_exclusions_mode"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/antivirus_exclusions/update_exclusions_mode(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_exclusions_mode_organization_antivirus_exclusions_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"antivirus_exclusions"],[2,[7,"/"],[2,[6,"update_exclusions_mode"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agent_releases/update_hupdate_hash(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_hupdate_hash_admin_agent_releases_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agent_releases"],[2,[7,"/"],[2,[6,"update_hupdate_hash"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/microsoft/update_mappings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_mappings_account_integrations_cpv_mapping_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"microsoft"],[2,[7,"/"],[2,[6,"update_mappings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/security_awareness_training/organization_mappings/update_mappings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_mappings_account_security_awareness_training_organization_mappings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"security_awareness_training"],[2,[7,"/"],[2,[6,"organization_mappings"],[2,[7,"/"],[2,[6,"update_mappings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/accounts/:id/update_neighborhood_watch(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_neighborhood_watch_admin_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_neighborhood_watch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/autotask/:id/update_organization_mappings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_organization_mappings_account_integrations_autotask_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"autotask"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_organization_mappings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/bms/:id/update_organization_mappings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_organization_mappings_account_integrations_bms_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"bms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_organization_mappings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/connect_wise/:id/update_organization_mappings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_organization_mappings_account_integrations_connect_wise_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"connect_wise"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_organization_mappings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/halo_psa/:id/update_organization_mappings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_organization_mappings_account_integrations_halo_psa_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"halo_psa"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_organization_mappings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/syncro/:id/update_organization_mappings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_organization_mappings_account_integrations_syncro_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"syncro"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_organization_mappings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/invoices/update_payment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_payment_account_invoices_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"update_payment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/organizations/:id/update_privilege(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_privilege_account_organization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_privilege"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/organizations/update_products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_products_account_organizations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"update_products"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encoded_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/accounts/:id/update_trial_end_date(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_trial_end_date_admin_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_trial_end_date"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resellers/:reseller_id/accounts/:account_id/subscriptions/:id/upgrade(.:format)
 * @param {any} reseller_id
 * @param {any} account_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upgrade_reseller_account_subscription_path = /*#__PURE__*/ __jsr.r({"reseller_id":{"r":true},"account_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"reseller"}}, [2,[7,"/"],[2,[6,"resellers"],[2,[7,"/"],[2,[3,"reseller_id"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"upgrade"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /usage_terms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usage_terms_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"usage_terms"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ransomware-canaries(/:secret)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_canary_path = /*#__PURE__*/ __jsr.r({"secret":{},"format":{}}, [2,[7,"/"],[2,[6,"ransomware-canaries"],[2,[1,[2,[7,"/"],[3,"secret"]]],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /confirmation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_confirmation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /invitation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_invitation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"invitation"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /multi_factor/backup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_multi_factor_backup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"multi_factor"],[2,[7,"/"],[2,[6,"backup"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /multi_factor/duo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_multi_factor_duo_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"multi_factor"],[2,[7,"/"],[2,[6,"duo"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /multi_factor/recovery(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_multi_factor_recovery_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"multi_factor"],[2,[7,"/"],[2,[6,"recovery"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /multi_factor/totp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_multi_factor_totp_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"multi_factor"],[2,[7,"/"],[2,[6,"totp"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /register(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /user_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_settings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_settings"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /unlock(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_unlock_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"unlock"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /unsubscribe/:type/:token(.:format)
 * @param {any} type
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_unsubscribe_path = /*#__PURE__*/ __jsr.r({"type":{"r":true},"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"unsubscribe"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/users/assume_role(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_assume_role_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"assume_role"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/users/disable_modal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_disable_modal_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"disable_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /v1/mcp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1_mcp_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"mcp"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /v1/mcp/authorize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1_mcp_authorize_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"mcp"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /v1/mcp/register(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1_mcp_register_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"mcp"],[2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /v1/mcp/token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1_mcp_token_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"mcp"],[2,[7,"/"],[2,[6,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/antivirus_exclusions/settings/validate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validate_account_antivirus_exclusions_settings_path = /*#__PURE__*/ __jsr.r({"format":{"d":"turbo_stream"}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"antivirus_exclusions"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"validate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/autotask/:id/validate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validate_account_integrations_autotask_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"autotask"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"validate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/bms/:id/validate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validate_account_integrations_bms_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"bms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"validate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/halo_psa/:id/validate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validate_account_integrations_halo_psa_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"halo_psa"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"validate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/service_now/:id/validate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validate_account_integrations_service_now_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"service_now"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"validate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/syncro/:id/validate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validate_account_integrations_syncro_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"syncro"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"validate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/managed_identity/attribute_rules/validate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validate_account_managed_identity_attribute_rules_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"attribute_rules"],[2,[7,"/"],[2,[6,"validate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/antivirus_exclusions/settings/validate(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validate_organization_antivirus_exclusions_settings_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{"d":"turbo_stream"}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"antivirus_exclusions"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"validate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/:organization_id/managed_identity/attribute_rules/validate(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validate_organization_managed_identity_attribute_rules_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"managed_identity"],[2,[7,"/"],[2,[6,"attribute_rules"],[2,[7,"/"],[2,[6,"validate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/threatops/logs/validate_query(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validate_query_account_threatops_logs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"threatops"],[2,[7,"/"],[2,[6,"logs"],[2,[7,"/"],[2,[6,"validate_query"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/notification_contacts/:id/verify(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_account_notification_contact_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"notification_contacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/agents/:id/verify(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_api_v1_agent_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"agent"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /multi_factor/duo/verify_async(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_async_user_multi_factor_duo_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"multi_factor"],[2,[7,"/"],[2,[6,"duo"],[2,[7,"/"],[2,[6,"verify_async"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/connect_wise/:id/verify_billing_sync(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_billing_sync_account_integrations_connect_wise_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"connect_wise"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"verify_billing_sync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/autotask/:id/verify_settings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_settings_account_integrations_autotask_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"autotask"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"verify_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/bms/:id/verify_settings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_settings_account_integrations_bms_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"bms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"verify_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/connect_wise/:id/verify_settings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_settings_account_integrations_connect_wise_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"connect_wise"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"verify_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/halo_psa/:id/verify_settings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_settings_account_integrations_halo_psa_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"halo_psa"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"verify_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/service_now/:id/verify_settings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_settings_account_integrations_service_now_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"service_now"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"verify_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/integrations/syncro/:id/verify_settings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_settings_account_integrations_syncro_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"syncro"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"verify_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /multi_factor/duo/verify_sms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_sms_user_multi_factor_duo_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"multi_factor"],[2,[7,"/"],[2,[6,"duo"],[2,[7,"/"],[2,[6,"verify_sms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /multi_factor/backup/verify(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_user_multi_factor_backup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"multi_factor"],[2,[7,"/"],[2,[6,"backup"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /multi_factor/duo/verify(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_user_multi_factor_duo_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"multi_factor"],[2,[7,"/"],[2,[6,"duo"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /multi_factor/totp/verify(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_user_multi_factor_totp_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"multi_factor"],[2,[7,"/"],[2,[6,"totp"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agents/versioning(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const versioning_admin_agents_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"versioning"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agent_releases/versions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const versions_admin_agent_releases_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agent_releases"],[2,[7,"/"],[2,[6,"versions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /vulnerabilities/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vulnerability_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vulnerabilities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

